{
    "common": {
        "added": {
            "label": {},
            "msg": {},
            "code": {}
        },
        "label": {
            "Views": "조회",
            "Updating": "업데이트 중",
            "By URL": "URL별",
            "Usage trend": "이용 추이",
            "Top {{count}} URLs": "URL 상위 {{count}}",
            "Top {{count}} referring domains": "유입 도메인 상위 {{count}}",
            "Top {{count}} countries": "국가 상위 {{count}}",
            "{{total}} total": "전체 {{total}}",
            "Published target": "게시 대상",
            "Last viewed": "마지막 조회",
            "{{count}} published": "게시 중 <0>{{count}}</0>",
            "As of {{hours}} hour(s) ago": "{{hours}}시간 전 기준",
            "As of {{days}} day(s) ago": "{{days}}일 전 기준",
            "As of less than an hour ago": "1시간 이내 기준",
            "Public URL statistics": "공개 URL 통계",
            "Usage of {{count}} public URL(s)": "공개 URL {{count}}개의 이용 현황",
            "Public URL statistics details": "공개 URL 통계 상세",
            "{{active}} published, {{released}} unpublished": "게시 중 <0>{{active}}</0> · 해제 <1>{{released}}</1>",
            "({{active}} published, {{released}} unpublished)": "(게시 중 {{active}} · 해제 {{released}})",
            "left axis": "(좌축)",
            "right axis": "(우축)",
            "Estimated visitors": "추정 방문자",
            "Data transferred": "전송량",
            "Referring domains": "유입 도메인",
            "Countries": "국가",
            "Last {{days}} days": "최근 {{days}}일",
            "When an asset is created": "자산 생성되었을 때",
            "When an asset is published": "자산 공개 URL 게시되었을 때",
            "When an asset is deleted": "자산 삭제되었을 때",
            "When an asset is unpublished": "자산 공개 URL 게시 해제되었을 때",
            "When an asset is updated": "자산 수정되었을 때",
            "Asset created": "자산 생성",
            "Asset published": "자산 공개 URL 게시",
            "Asset deleted": "자산 삭제",
            "Asset unpublished": "자산 공개 URL 게시 해제",
            "Asset updated": "자산 수정",
            "Connection settings": "연결 설정",
            "Create Webhook": "웹훅 생성",
            "Endpoint URL": "엔드포인트 URL",
            "Headers": "헤더",
            "Hide value": "값 숨기기",
            "HTTP Method": "HTTP 메서드",
            "Recent deliveries": "최근 전송 이력",
            "Remove header": "헤더 삭제",
            "Request body example": "요청 본문 예시",
            "Response": "응답",
            "Search by webhook name": "웹훅 이름으로 검색하세요",
            "Show value": "값 표시",
            "Transport format": "전송 형식",
            "Triggers": "트리거",
            "Webhook": "웹훅",
            "webhook": "웹훅",
            "Webhooks": "웹훅",
            "Delivery history": "전송 이력",
            "Request ID": "요청 ID",
            "Status code": "상태 코드",
            "Response time": "응답 시간",
            "Result": "결과",
            "Select result": "결과 선택",
            "Success": "성공",
            "Gen AI": "Gen AI",
            "Dimension": "해상도",
            "{{from}}-{{to}} of {{count}}": "{{count}} 중 {{from}}-{{to}}",
            " - Total {{totalSize}}": " - 총 {{totalSize}}",
            "Add Vocabulary?": "단어를 추가하시겠습니까?",
            "Add to all": "모두에 추가",
            "All items cannot be deleted.": "모든 항목을 삭제할 수는 없습니다.",
            "Archiving...": "아카이빙 중...",
            "Asset to be analyzed": "분석할 자산",
            "Bucket name must be between 3 and 63 letters and start with alphabet or number with allowed special characters of -, _, and .)": "버킷 이름은 반드시 3~63자 이내 여야하고 알파벳이나 숫자로 시작해야만하며, -, _, 그리고 .의 특수문자만 허용됩니다.",
            "Choose on Organizer": "주최자 선택",
            "Close my jobs": "내 작업 닫기",
            "Close tab menu": "탭 메뉴 닫기",
            "Collapse panel": "패널 접기",
            "Copy to {{name}}": "{{name}}(으)로 복사",
            "Customer": "고객",
            "Default value": "기본값",
            "Destination": "대상",
            "Domain URL": "도메인 URL",
            "Drive": "드라이브",
            "Duplicate the item?": "항목을 복제하시겠습니까?",
            "Empty Recoding History": "녹화 기록이 없습니다",
            "Enter Vocabulary name": "단어 이름을 입력하세요",
            "Enter after entering": "입력 후 Enter를 눌러주세요",
            "Enter field description": "필드 설명을 입력하세요",
            "Enter prefix": "접두사를 입력하세요",
            "Entering Console…": "콘솔에 접속 중…",
            "Error renaming from {{item1}} to {{item2}}.": "{{item1}}에서 {{item2}}(으)로 이름을 바꾸는 중 오류가 발생했습니다.",
            "Event Triggers": "이벤트 트리거",
            "Expand panel": "패널 펼치기",
            "Failed": "실패",
            "Find objects by prefix": "접두사로 객체 검색",
            "Go to Search Results": "검색 결과로 이동",
            "Grouping": "그룹화",
            "Height": "높이",
            "Id": "ID",
            "If you need permission, please contact your account manager.": "권한이 필요한 경우 담당 계정 관리자에게 문의하세요.",
            "In use": "사용 중",
            "Ingested": "인제스트됨",
            "Ingesting": "인제스트 중",
            "Min": "최소",
            "Moving...": "이동 중...",
            "No requests list": "요청 목록이 없습니다",
            "Offline": "오프라인",
            "Open tab menu": "탭 메뉴 열기",
            "Other": "기타",
            "Permission to access is required.": "액세스 권한이 필요합니다.",
            "Please create an organizer.": "주최자를 생성해주세요.",
            "Prefix cannot be empty": "접두사는 비워 둘 수 없습니다",
            "Prefix must begin with s3://": "접두사는 반드시 s3:// 로 시작해야합니다",
            "Preview Image": "미리보기 이미지",
            "Progressing": "진행 중",
            "Project name cannot be empty": "프로젝트 이름은 비워 둘 수 없습니다",
            "Re-Approval requested": "재승인 요청됨",
            "Search Projects": "프로젝트 검색",
            "Search by execution ID": "실행 ID로 검색",
            "Select Language": "언어 선택",
            "Select Service Type": "서비스 종류 선택",
            "Select Storage": "스토리지 선택",
            "Share to \"{{name}}\"": "\"{{name}}\"에 공유",
            "Smiling": "미소",
            "Space ID": "스페이스 아이디",
            "CDN ID": "CDN ID",
            "System management": "시스템 관리",
            "There is no resource in video.": "비디오에 리소스가 없습니다.",
            "There was an error creating the new folder {{item}}.": "{{item}} 폴더를 생성하는 중에 오류가 발생했습니다.",
            "Total for all projects": "전체 프로젝트 합계",
            "Use all": "모두 사용",
            "View Files": "파일 보기",
            "View History": "이력 보기",
            "Vocabularies": "단어",
            "Vocabulary Book Search Results": "단어장 검색 결과",
            "Width": "너비",
            "You do not have permission.": "권한이 없습니다.",
            "Zoom In": "확대",
            "Zoom Out": "축소",
            "and": "및",
            "canceled": "취소됨",
            "complete": "완료",
            "error": "오류",
            "group": "그룹",
            "loading...": "로딩 중...",
            "preview": "미리보기",
            "remove": "제거",
            "requested": "요청됨",
            "user": "사용자",
            "weekly": "주간",
            "{{name}} Search Results": "{{name}} 검색 결과",
            "READY TO DOWNLOAD": "다운로드 준비 완료",
            "STARTING": "시작 중",
            "STOPPING": "중지 중",
            "SUBMITED": "제출됨",
            "UNKNOWN": "알 수 없음",
            "AWS": "AWS",
            "Daglo": "Daglo",
            "S3 Glacier Deep Archive": "S3 Glacier Deep Archive",
            "S3 Glacier Flexible Retrieval": "S3 Glacier Flexible Retrieval",
            "Subsy": "Subsy",
            "Image zoom in": "이미지 확대",
            "Add Option": "옵션 추가",
            "Labels": "라벨",
            "Filter labels": "라벨 필터",
            "Go to details": "상세로 이동",
            "Select Key": "키 선택",
            "Current Space": "현재 스페이스",
            "Stage List": "스테이지 목록",
            "Empty Widget List": "위젯 없음",
            "Enlarge Layout": "확대 레이아웃",
            "Video Player": "비디오 플레이어",
            "Copying": "복사 중",
            "Empty Published History": "게시 이력 없음",
            "Request Details": "요청 상세",
            "Results for your Search": "검색 결과",
            "Average Confidence (%) : More than": "평균 신뢰도(%) : 이상",
            "Prev": "이전",
            "Go Detail": "상세로 이동",
            "By Last Created": "생성일",
            "day": "일",
            "Only Unused Files": "미사용 파일만",
            "Access Token": "액세스 토큰",
            "Refresh Token": "리프레시 토큰",
            "Projects Allowed to Use": "사용 가능한 프로젝트",
            "WORKFLOW_QUEUED": "대기 중",
            "WORKFLOW_READY": "준비 중",
            "WORKFLOW_RUNNING": "실행 중",
            "WORKFLOW_COMPLETED": "완료",
            "WORKFLOW_FAILED": "실패",
            "WORKFLOW_EXPIRED": "만료",
            "Start Date": "시작 일시",
            "End Date": "종료 일시",
            "Duration (sec)": "소요 시간(초)",
            "Go to error item": "오류 항목으로 이동",
            "Error message": "오류 메시지",
            "How to resolve": "해결 방법",
            "Continue editing": "계속 편집하기",
            "Acknowledge and save": "경고 확인하고 저장",
            "Add parallel step": "병렬 스텝 추가",
            "bucketName": "버킷 이름",
            "prefix": "접두사",
            "fileUrl": "파일 URL",
            "extension": "확장자",
            "extensions": "확장자",
            "minByte": "최소 바이트",
            "maxByte": "최대 바이트",
            "assetId": "자산 ID",
            "mediaType": "미디어 타입",
            "attributions": "속성",
            "tags": "태그",
            "categories": "카테고리",
            "description": "설명",
            "extendedMetadata": "확장 메타데이터",
            "virtualLocation": "위치",
            "collection": "컬렉션",
            "pipelineId": "파이프라인 ID",
            "videoId": "비디오 ID",
            "promptId": "프롬프트 ID",
            "storageClass": "스토리지 클래스",
            "platform": "플랫폼",
            "isCreateOriginAsset": "원본 소스를 자산으로 저장",
            "AI Search Mode": "AI 검색 모드",
            "Grant Space Admin": "Space 관리자 부여",
            "Grant Project Admin": "Project 관리자 부여",
            "1st": "1주차",
            "2nd": "2주차",
            "3rd": "3주차",
            "4th": "4주차",
            "5th": "5주차",
            "6th": "6주차",
            "- Total {{totalSize}}": "- 총 {{totalSize}}",
            "{{count}} views": "{{count}}개 보기",
            "{{name}} files": "{{name}} 파일",
            "{{name}} ID": "{{name}} 아이디",
            "{{name}} inquiry": "{{name}} 문의",
            "{{name}} overview": "{{name}} 개요",
            "24 hour operation": "24시간 작동됩니다.",
            "24 hours": "24 시간",
            "24/7": "24/7",
            "Accept": "수락",
            "Account": "계정",
            "Action": "동작",
            "Actions": "동작",
            "Active": "활성",
            "ACTIVE": "활성",
            "ACTIVE / INACTIVE TOGGLE": "활성 / 비활성 토글",
            "Add {{name}}": "{{name}} 추가",
            "Add a category": "카테고리 추가",
            "Add caption": "캡션 추가",
            "Add faces": "얼굴 추가",
            "Add files": "파일 추가",
            "Add image": "이미지 추가",
            "Add images": "이미지 추가",
            "Add lineup": "라인업 추가",
            "Add roles": "역할 추가",
            "Add teams": "팀 추가",
            "Add users": "사용자 추가",
            "Add posters": "포스터 추가",
            "Admin": "관리자",
            "Administration": "관리",
            "Advanced search": "고급 검색",
            "ALL": "모두",
            "All event type": "모든 이벤트 유형",
            "All ingest type": "모든 인제스트 유형",
            "All language": "모든 언어",
            "All media type": "모든 미디어 유형",
            "All media types": "모든 미디어 유형",
            "All pipeline": "모든 파이프라인",
            "All project": "모든 프로젝트",
            "All source": "모든 소스",
            "All state": "모든 상태",
            "All status": "모든 상태",
            "All type": "모든 유형",
            "All types": "모든 유형",
            "Allowed special characters": "허용되는 특수 문자",
            "Alternative name": "대체 이름",
            "Alternative names": "대체 이름",
            "Amount": "총양",
            "Amount : {{amount}}": "총양: {{amount}}",
            "Analyzed": "분석됨",
            "Analyzing": "분석 중",
            "Anywhere": "어디에서나",
            "Appears to be happy": "행복해 보임",
            "Appears to be male": "남성으로 보임",
            "Apply": "적용",
            "Approval": "승인",
            "Approval in progress": "승인 진행 중",
            "Approval request": "승인 요청",
            "Approval requested": "승인 요청됨",
            "Approval status": "승인 상태",
            "Approve": "승인",
            "Approve whitelist": "화이트리스트 승인",
            "Approved": "승인됨",
            "Approved whitelist": "승인된 화이트리스트",
            "Asset": "자산",
            "Asset ID": "자산 ID",
            "Asset name": "자산 이름",
            "Assets {{name}}": "자산 {{name}}",
            "Assets": "자산",
            "Attribution": "속성",
            "Attributions": "속성",
            "Audio": "오디오",
            "Audio settings": "오디오 설정",
            "Audit logs": "감사 로그",
            "Audit-Logs": "감사 - 로그",
            "Authority": "권한",
            "Auto Start/Stop": "자동 시작/중지",
            "Automated Workflow": "자동화 워크플로우",
            "AWS medialive channel": "AWS 미디어 라이브 채널",
            "AWS medialive input": "AWS 미디어 라이브 인풋",
            "Base video": "기본 비디오",
            "Blank time": "빈 시간",
            "Cancel": "취소",
            "CANCELED": "취소됨",
            "Cannot delete the stream": "스트림을 삭제할 수 없습니다",
            "CAPTION": "캡션",
            "Caption": "캡션",
            "Caption label": "캡션 라벨",
            "Captions": "캡션",
            "Categories": "카테고리",
            "Categories selected": "카테고리 선택",
            "Category": "카테고리",
            "Category description": "카테고리 설명",
            "Category group": "카테고리 그룹",
            "Category group description": "카테고리 그룹 설명",
            "Category group name": "카테고리 그룹 이름",
            "Category groups": "카테고리 그룹",
            "Celebrity recognition": "연예인 인식",
            "Channel": "채널",
            "Channel description": "채널 설명",
            "Channel ID": "채널 아이디",
            "Channel overview": "채널 개요",
            "Channel state of non-scheduled time": "스케줄 되지 않은 시간의 채널 상태",
            "Channels": "채널",
            "Chapter": "챕터",
            "Choose on schedules": "리스팅 선택",
            "Choose on stream": "스트림 선택",
            "Choose on streams": "스트림 선택",
            "Client ID": "클라이언트 아이디",
            "Client IP": "클라이언트 IP",
            "Client secret": "클라이언트 시크릿",
            "Client useragent": "클라이언트 사용자 에이전트",
            "Clone": "복제",
            "Close": "닫기",
            "Cloud": "클라우드",
            "Cloud inquiry": "클라우드 문의",
            "CloudPlex Media": "CloudPlex Media",
            "CloudPlex Media subtitle editor": "CloudPlex Media 자막 편집기",
            "CMS": "CMS",
            "Code": "코드",
            "COMPLETE": "완료",
            "Completed": "완료일",
            "Conditions": "조건",
            "Confidence": "신뢰도",
            "Configuration": "구성",
            "Constraints": "제약",
            "Content moderation": "콘텐츠 조정",
            "Contents": "콘텐츠",
            "Contents duration": "컨텐츠 재생 시간",
            "Copyright": "저작권",
            "Correct status": "상태 보정",
            "Create": "생성",
            "Create {{name}} asset": "{{name}} 자산 생성",
            "Create MP4 asset": "비디오 자산 생성",
            "Create MP3 asset": "오디오 자산 생성",
            "Create IMAGE asset": "이미지 자산 생성",
            "Create CAPTION asset": "캡션 자산 생성",
            "Create {{name}}": "{{name}} 생성",
            "Created": "생성일",
            "Creator": "만든이",
            "Execution History": "실행 이력",
            "Execution Result": "실행 결과",
            "Flow Detail Information": "플로우 상세 정보",
            "Created by": "만든 사람",
            "Creating": "생성 중",
            "CSV Export": "CSV 내보내기",
            "Cumulative viewers": "누적 시청자 수",
            "Cumulative views": "누적 시청 횟수",
            "Cumulative viewing time": "누적 시청 시간",
            "Current time": "현재 시간",
            "Current viewers": "현재 시청자 수",
            "Currently online": "현재 온라인",
            "Custom fields": "사용자 정의 필드",
            "Cycle": "주기",
            "Dailys": "일",
            "Dashboard": "대시보드",
            "Date": "날짜",
            "Date picker": "날짜 선택기",
            "Date format": "날짜 형식",
            "Day": "일",
            "Days": "일",
            "Default": "기본",
            "Delete": "삭제",
            "Delete all": "전체 삭제",
            "Deleted": "삭제됨",
            "Deleted output asset retention": "삭제된 아웃풋 자산 보관",
            "Description": "설명",
            "Desktop": "데스크탑",
            "Destination A": "대상 A",
            "Destination B": "대상 B",
            "Detach": "해제",
            "Detach {{name}}": "{{name}} 해제",
            "Detail": "상세",
            "Direct": "PC 파일",
            "Direct input": "직접 입력",
            "Disable": "사용 안 함",
            "Down": "내리기",
            "Download": "다운로드",
            "Download apps": "다운로드 앱",
            "Download filtered list": "필터된 목록 다운로드",
            "Download full list": "전체 목록 다운로드",
            "DRAFT": "초안",
            "Draft": "초안",
            "DUAL": "이중의",
            "Dual": "이중의",
            "Dubbing": "더빙",
            "MultipleAudios": "다중 오디오",
            "Duration": "재생 시간",
            "Edit": "수정",
            "Email": "이메일",
            "Embed code": "임베드 코드",
            "Employee Sign in": "LX하우시스 임직원 로그인",
            "Empty": "없음",
            "Empty {{name}}": "{{name}}(이)가 없습니다.",
            "Every {{interval}} days": "{{interval}}일 마다",
            "Enable": "사용",
            "Encoding profile": "인코딩 프로필",
            "End": "종료",
            "End date": "종료 날짜",
            "End now": "지금 종료",
            "End time": "종료 시간",
            "Endpoint": "엔드포인트",
            "Endpoints": "엔드 포인트",
            "Error": "에러",
            "ERROR": "오류",
            "Etc": "기타",
            "Event": "이벤트",
            "EVENT": "이벤트",
            "Event triggers": "이벤트 트리거",
            "Event type": "이벤트 종류",
            "EventTrigger": "이벤트 트리거",
            "EventTrigger description": "이벤트 트리거 설명",
            "EventTrigger name": "이벤트 트리거 이름",
            "EventTriggers": "이벤트 트리거",
            "Every": "마다",
            "Expired": "만료",
            "Expired at": "만료시점",
            "Expired date": "만료일",
            "Face": "얼굴",
            "Face anlaysis": "얼굴 분석",
            "Face index": "얼굴 인덱싱",
            "Face search": "얼굴 검색",
            "Facebook": "페이스북",
            "Faces": "얼굴",
            "Faces selected": "얼굴 선택",
            "Field type search": "필드 유형 검색",
            "Field {{count}}": "필드 {{count}}",
            "File": "파일",
            "File name": "파일명",
            "File source": "파일 소스",
            "Files": "파일",
            "Folder name": "폴더명",
            "Follow default values": "기본 값들을 사용합니다.",
            "Force inheritance": "강제 상속",
            "Fri": "무료",
            "Friday": "금요일",
            "General": "일반",
            "Go to schedule": "스케줄로 이동",
            "Grand additional roles": "다중 역할 추가",
            "Grant all permissions": "승인된 모든 권한",
            "Grant project access": "프로젝트 접근 권한 부여",
            "Granted": "승인 여부",
            "Granted roles": "승인된 역할",
            "Hide": "숨기기",
            "High": "높은",
            "Highest": "제일 높은",
            "Hub scope": "모든 프로젝트",
            "Hyper Browser": "하이퍼 브라우저",
            "ID": "ID",
            "Idle": "유휴",
            "Image": "이미지",
            "IMAGE": "이미지",
            "Image setting": "이미지 설정",
            "Image sources": "이미지 소스",
            "Images selected": "이미지 선택",
            "Inactive": "비활성",
            "Index": "인덱스",
            "Indexing": "인덱스 중입니다",
            "Indexed": "인덱스",
            "Index file": "인덱스 파일",
            "Individual settings": "개인 설정",
            "Ingest type": "인제스트 유형",
            "Ingest": "인제스트",
            "INGEST": "인제스트",
            "INGESTED": "인제스트됨",
            "INGESTING": "인제스트 중",
            "Inherit": "상속",
            "Input {{index}}": "인풋 {{index}}",
            "Input asset auto delete": "인풋 자산 자동 삭제",
            "Input detail": "인풋 상세",
            "Input path": "인풋 경로",
            "Input storage": "인풋 저장소",
            "Input storage path": "인풋 저장소 경로",
            "Inputs": "인풋",
            "Instagram": "인스타그램",
            "Interval": "반복 간격",
            "IP range": "IP 범위",
            "Job": "작업",
            "Job {{name}}": "작업 {{name}}",
            "Job ID": "작업 아이디",
            "Job overview": "잡 개요",
            "Jobs": "작업",
            "Key": "키",
            "Kind": "종류",
            "Label": "라벨",
            "Label detection": "라벨 감지",
            "Language": "언어",
            "Last access": "마지막 엑세스",
            "Last accessed at": "마지막 엑세스 시점",
            "Leave": "나가기",
            "Leave comment": "코멘트 남기기",
            "Linear": "리니어",
            "LINEAR": "리니어",
            "Lineup": "라인업",
            "Lineup copy": "라인업 복사",
            "Lineup count": "라인업 갯수",
            "Lineup detail": "라인업 상세",
            "Lineup name": "라인업 이름",
            "List": "목록",
            "Listing": "리스팅",
            "Schedules": "일정",
            "SCHEDULES": "리스팅",
            "Schedules detail": "리스팅 상세",
            "Schedules ID": "리스팅 아이디",
            "Schedules overview": "리스팅 개요",
            "Live": "라이브",
            "Live player URL": "라이브 플레이어 URL",
            "Loading...": "로딩중...",
            "Local": "현지",
            "Local file": "로컬 파일",
            "Logo": "로고",
            "Looks like a face": "얼굴처럼 보이는",
            "Loop": "고리",
            "Loop to fill lineup duration": "라인업 재생시간 동안 반복 재생",
            "Low": "낮은",
            "Lowest": "최저",
            "Main": "메인",
            "Mark in": "마크인",
            "Mark in~out": "마크인~마크아웃",
            "Mark out": "마크아웃",
            "Max": "최대",
            "Maximum object size": "최대 객체 크기",
            "Maximum schedule amount": "최대 스케쥴 시간",
            "Media": "미디어",
            "Media service": "미디어 서비스",
            "Media service inquiry": "미디어 서비스 문의",
            "Media type": "미디어 유형",
            "Medium": "중간",
            "Megazone ID": "메가존 아이디",
            "Members": "멤버",
            "Metadata": "메타데이터",
            "Metadata description": "메타데이터 설명",
            "Metadata name": "메타데이터 이름",
            "Metadata schema description": "메타데이터 스키마 설명",
            "Mon": "월",
            "Monday": "월요일",
            "Month": "달",
            "Months": "달",
            "More than 50%": "50% 이상",
            "MP4": "MP4",
            "My jobs": "내 작업",
            "Name": "이름",
            "Name / ID": "이름 / 아이디",
            "Name constraints": "이름 제약 조건",
            "Never": "없음",
            "No": "아니요",
            "No options": "옵션이 존재하지 않습니다.",
            "No {{name}}": "{{name}} 없음",
            "No asset contents": "자산 내용이 없습니다",
            "No asset searched.": "자산을 찾을 수 없습니다.",
            "No category searched": "검색된 카테고리가 없습니다.",
            "None": "없음",
            "Not copy to": "복사할 수 없음",
            "Not deleted": "삭제할 수 없음",
            "Not found": "찾을 수 없음",
            "Now": "지금",
            "Number": "번호",
            "Off": "끄기",
            "On": "켜기",
            "OR": "또는",
            "Origin": "원본",
            "Origins": "원본",
            "Output": "아웃풋",
            "Outputs": "아웃풋",
            "Output {{index}}": "아웃풋 {{index}}",
            "Output path": "아웃풋 경로",
            "Output preview": "아웃풋 미리보기",
            "Output storage": "아웃풋 저장소",
            "Output storage path": "아웃풋 저장소 경로",
            "Overview": "개요",
            "Owner": "소유자",
            "Parent device": "상위 디바이스",
            "Parent region": "상위 지역",
            "Path": "경로",
            "Payload": "페이로드",
            "Pending ingesting": "인제스트 대기 중",
            "Pending transcoding": "트랜스코딩 대기 중",
            "People": "인물",
            "People description": "인물 설명",
            "Period": "기간",
            "Period setting": "기간 설정",
            "Permissions": "권한",
            "Pipeline": "파이프라인",
            "Pipeline {{name}}": "{{name}} 파이프라인",
            "Player": "플레이어",
            "Please create a schedules.": "리스팅을 생성해 주십시오.",
            "Please create a stream.": "스트림을 생성해 주세요.",
            "Poster": "포스터",
            "Posters": "포스터",
            "Prefix": "접두사",
            "Preview": "미리보기",
            "Preview button": "미리보기 버튼",
            "Preview in browser URL": "브라우저 URL 미리보기",
            "Priority": "우선 순위",
            "Privacy policy": "개인정보처리방침",
            "Private": "비공개",
            "Profile": "프로필",
            "Profile {{name}}": "프로필 {{name}}",
            "Program": "프로그램",
            "Program duration": "프로그램 재생 시간",
            "Programes count": "프로그램 갯수",
            "Programs": "프로그램",
            "PENDING": "진행 중",
            "PROGRESSING": "진행",
            "Project": "프로젝트",
            "Project description": "프로젝트 설명",
            "Project ID": "프로젝트 아이디",
            "Project in use": "사용 중인 프로젝트",
            "Project manager": "프로젝트 매니저",
            "Project name": "프로젝트명",
            "Project Name / ID": "프로젝트 이름 / 아이디",
            "Project overview": "프로젝트 개요",
            "Project settings": "프로젝트 설정",
            "Projects": "프로젝트",
            "Projects in use": "사용 중인 프로젝트",
            "Provider": "프로바이더",
            "Provider / Service": "프로바이더 / 서비스",
            "Public": "공개",
            "Publish": "게시",
            "QR": "QR",
            "Quick search": "빠른 검색",
            "Range": "범위",
            "READY": "준비됨",
            "Reanalysis": "재분석",
            "Retry AI search indexing": "AI 검색 인덱싱 재시도",
            "Retry indexing": "인덱싱 재시도",
            "Reason": "사유",
            "Reason for approval requested": "승인 요청 사유",
            "Reason for reclaimed": "회수 사유",
            "Reason for rejected": "반려 사유",
            "Reason for request": "요청 사유",
            "Reason for response": "처리 사유",
            "Reason for return requested": "반환 요청 사유",
            "Reclaim": "회수",
            "Reclaim in progress": "회수 진행 중",
            "Reclaimed": "회수됨",
            "Recorded": "녹화",
            "Redirect URL": "리디렉션 URL",
            "Redundancy level": "리던던시 레벨",
            "Refresh": "새로고침",
            "Refresh token": "토큰 갱신",
            "Reject": "거부",
            "Rejected": "반려됨",
            "Related {{pascalK}}": "연관된 {{pascalK}}",
            "Remaining time": "남은 시간",
            "Remote": "클라우드 파일",
            "Remote file": "원격 파일",
            "Remove": "제거",
            "Rendition": "랜디션",
            "Renditions": "랜디션",
            "Repeat": "반복",
            "Request": "요청",
            "Request approval": "승인 요청",
            "Request body": "요청 바디",
            "Request cancel": "요청 취소",
            "Request return": "반환 요청",
            "Reset": "초기화",
            "Resolution": "해상도",
            "Resource": "리소스",
            "Response body": "응답 바디",
            "Restore to default": "기본값으로 복원",
            "Retry": "재시도",
            "Return": "반환",
            "Return cancel": "반환 취소",
            "Return in progress": "반환 진행 중",
            "Return request": "반환 요청",
            "Return requested": "반환 요청됨",
            "Returned": "반환됨",
            "Role description": "역할 설명",
            "Role name": "역할 이름",
            "Role overview": "역할 개요",
            "Role": "역할",
            "Roles": "역할",
            "rules": "규칙",
            "Running": "가동 중",
            "S3://~": "s3://~",
            "Sat": "토",
            "Saturday": "토요일",
            "Save": "저장",
            "Save origin asset": "원본 자산 저장",
            "Schedule": "스케쥴",
            "Schedule {{index}}": "스케줄 {{index}}",
            "Schedule repeat": "스케쥴 반복",
            "Scheduled lineups": "편성된 라인업",
            "Scheduled time": "스케쥴된 시간",
            "Scope": "범위",
            "Search": "검색",
            "Search assets name": "검색할 자산 이름",
            "Search by workflow name": "워크플로우 이름으로 검색하세요",
            "Search program name": "검색할 프로그램 이름",
            "Search team name": "검색할 팀 이름",
            "Search videos name": "검색할 비디오이름",
            "Security": "보안",
            "Select": "선택",
            "Select {{name}}": "{{name}} 선택",
            "Select a file": "파일 선택",
            "Select a one {{type}} file": "하나의 {{type}} 파일 선택",
            "Select a one caption file.": "캡션 파일을 선택하세요.",
            "Select assets": "자산 선택",
            "Select categories": "카테고리 선택",
            "Select category": "카테고리 선택",
            "Select event type": "이벤트 유형 선택",
            "Select files": "파일 선택",
            "Select folder": "폴더 선택",
            "Select kind": "종류 선택",
            "Select language": "언어 선택",
            "Select one MP4 file": "한개의 MP4 파일 선택해주세요",
            "Select pipeline": "파이프라인 선택",
            "Select roles to grant": "부여할 역할 선택",
            "Select whitelist": "화이트리스트 선택",
            "Select...": "선택...",
            "Selected {{name}}": "선택된 {{name}}",
            "Separate by newlines": "개행 문자로 분리",
            "Service": "서비스",
            "Set": "설정",
            "Set as default": "기본으로 설정",
            "Set as primary": "대표 이미지로 설정",
            "Settings": "설정",
            "Show all": "모두 표시",
            "Show more": "더보기",
            "Sign in": "로그인",
            "Sign in with Megazone Accounts": "Megazone 계정으로 로그인",
            "Single": "단일",
            "Single IP": "단일 IP",
            "Size": "크기",
            "smiling": "미소",
            "Source": "소스",
            "Source A": "소스 A",
            "Source B": "소스 B",
            "Source end behavior": "소스 종료시 동작",
            "Sources": "소스",
            "Specifications": "사양",
            "Stage": "스테이지",
            "Stage scope": "스테이지 범위",
            "Project scope": "프로젝트 범위",
            "Start": "시작",
            "Space": "스페이스",
            "Start {{name}}": "{{name}} 시작",
            "Start analysis": "분석 시작",
            "Start date": "시작 날짜",
            "Start indexing": "인덱싱 시작",
            "Start time": "시작 시간",
            "Start~End": "시작~종료",
            "Started": "시작됨",
            "Starting": "시작 중",
            "State": "상태",
            "Statistics": "통계",
            "Status": "상태",
            "Stop": "중지",
            "Stopped": "중지됨",
            "Stopping": "중지 중",
            "Storage path": "저장소 경로",
            "Stream": "스트림",
            "STREAM": "스트림",
            "Stream ID": "스트림 아이디",
            "Streams": "스트림",
            "Submit": "등록",
            "SUBMITTED": "제출됨",
            "Submitted": "제출됨",
            "Subtitle": "자막",
            "Sun": "일",
            "Sunday": "일요일",
            "Supported file formats": "지원되는 파일 형식",
            "Supported inputs": "지원되는 인풋",
            "Supported URL patterns": "지원되는 URL 패턴",
            "Supported URLs": "지원되는 URL",
            "Synchronization": "동기화",
            "table": "표",
            "Tag": "태그",
            "Tags": "태그",
            "Target ID": "대상 아이디",
            "Target resource": "대상 리소스",
            "Team": "팀",
            "Team ID": "팀 아이디",
            "Team overview": "팀 개요",
            "Teams": "팀",
            "Terms & Conditions": "이용 약관",
            "Text": "텍스트",
            "Text area": "텍스트 영역",
            "Text field": "텍스트 필드",
            "There is no Stream to select.": "선택 가능한 스트림이 없습니다.",
            "This {{name}}": "이번 {{name}}",
            "Thumbnails": "미리보기 이미지",
            "THUMBNAILS": "미리보기 이미지",
            "Thur": "목",
            "Thursday": "목요일",
            "Time": "시간",
            "Timestamp": "타임 스탬프",
            "Timezone": "타임존",
            "Title": "타이틀",
            "Today": "오늘",
            "Total": "총",
            "Total {{name}}": "총 {{name}}",
            "Total <strong className=\\\"emphasis\\\">{{elementsLength}}</strong>": "총 <0>{{elementsLength}}</0>",
            "Total <0>{{elementsLength}}</0>": "총 <0>{{elementsLength}}</0>",
            "Total time": "총 시간",
            "Transcode": "트랜스코드",
            "Transcode profile": "트랜스코드 프로필",
            "Transcoded": "트랜스코딩",
            "Transcoder Job ID": "트랜스코더 잡 아이디",
            "Transcoding": "트랜스코딩",
            "Transcoding canceled": "트랜스코딩 취소",
            "Transcoding complete": "트랜스코딩 완료",
            "Transcoding error": "트랜스코딩 에러",
            "Transcoding failed": "트랜스코딩 실패",
            "Transcoding time": "트랜스코딩 시간",
            "Tree": "트리",
            "Tue": "화",
            "Tuesday": "화요일",
            "Twitch": "트위치",
            "Twitter": "트위터",
            "Type": "유형",
            "Undefined": "정의되지 않음",
            "Unique": "고유의",
            "Unknown": "알 수 없음",
            "(Unknown)": "(알 수 없음)",
            "Unscheduled time": "스케쥴되지 않은 시간",
            "Unset default": "기본 해제",
            "Up": "올리기",
            "Update file": "업데이트 파일",
            "Updated": "업데이트",
            "Updated at": "업데이트",
            "Updated by": "업데이트 수행자",
            "Updating...": "업데이트 중...",
            "Upload": "업로드",
            "Upload {{status}}.": "업로드 {{status}}.",
            "Upload rules": "업로드 규칙",
            "Uploading": "업로드 중",
            "UPLOADING": "업로드 중",
            "URL": "URL",
            "User ID": "사용자 아이디",
            "User information": "사용자 정보",
            "User name": "사용자 이름",
            "User overview": "사용자 개요",
            "User username": "사용자 유저네임",
            "Username": "유저네임",
            "Users": "사용자",
            "Value": "값",
            "Video": "비디오",
            "Video ID": "비디오 ID",
            "Video AI": "비디오 AI",
            "Video setting": "비디오 설정",
            "Videos": "비디오",
            "View analytics data": "분석 데이터 보기",
            "View more": "더보기",
            "VOD player URL": "VOD 플레이어 URL",
            "Warning": "경고",
            "Wearing glasses": "안경을 쓰고있음",
            "Wed": "수",
            "Wednesday": "수요일",
            "Week": "주",
            "Weekly": "주간",
            "Weeks": "주",
            "Welcome": "환영합니다",
            "Whitelist": "화이트리스트",
            "Whitelist rules": "화이트리스트 규칙",
            "Whitelist to request": "요청할 화이트리스트",
            "Workflow": "워크플로우",
            "Workflow Name": "워크플로우 이름",
            "workflow": "워크플로우",
            "Years old": "살",
            "Yes": "예",
            "Youtube": "유튜브",
            "Youtube syndication": "유튜브 신디케이션",
            "사용자 설정 위젯": "사용자 설정 위젯",
            "팀 설정 위젯": "팀 설정 위젯",
            "프로젝트 설정 위젯": "프로젝트 설정 위젯",
            "전체 기간": "전체 기간",
            "빠른 지정": "빠른 지정",
            "사용자 지정": "사용자 지정",
            "이번주": "이번주",
            "이번달": "이번달",
            "올해": "올해",
            "지난 15분": "지난 15분",
            "지난 30분": "지난 30분",
            "지난 1시간": "지난 1시간",
            "지난 4시간": "지난 4시간",
            "선택됨": "선택됨",
            "에 업데이트됨": "에 업데이트됨",
            "위젯 설정": "위젯 설정",
            "선택된 위젯": "선택된 위젯",
            "프로젝트 설정으로 적용": "프로젝트 설정으로 적용",
            "선 그래프": "선 그래프",
            "바 그래프": "바 그래프",
            "동영상": "동영상",
            "시청자 수": "시청자 수",
            "시청 횟수": "시청 횟수",
            "디바이스별 시청자 수 (기간)": "디바이스별 시청자 수 (기간)",
            "디바이스별 시청자 수 (백분율)": "디바이스별 시청자 수 (백분율)",
            "현재 시청자 수": "현재 시청자 수",
            "누적 시청자 수": "누적 시청자 수",
            "누적 시청 횟수": "누적 시청 횟수",
            "누적 시청 시간": "누적 시청 시간",
            "상위 지역": "상위 지역",
            "상위 디바이스": "상위 디바이스",
            "PREPARING": "준비 중",
            "Restrict bucket access": "아웃풋 저장소 직접 접근 방지",
            "Active on creation": "생성시 자동 활성화",
            "ACTIVATING": "활성화 중",
            "INACTIVATING": "비활성화 중",
            "Published History": "배포 기록",
            "Channel Name": "채널 이름",
            "Accounts": "계정",
            "Account settings": "계정 설정",
            "Add Accounts": "계정 추가",
            "URL for Posting": "포스팅용 URL",
            "Kakaotalk": "카카오톡",
            "Select Accounts": "계정 선택",
            "Go to": "이동",
            "Auto Categorization": "자동 카테고리화",
            "Site access": "사이트 엑세스",
            "File meta": "파일 메타",
            "Operator": "연산자",
            "Console": "콘솔",
            "Contains": "포함",
            "Duration range": "시간 범위",
            "Date range": "날짜 범위",
            "Greater than": "보다 큰",
            "Less than": "보다 작은",
            "OverWrite": "덮어쓰기",
            "Overwrite": "덮어쓰기",
            "Skip": "건너뛰기",
            "OK": "확인",
            "Source name": "자원 이름",
            "Partial {{type}} to completed.": "{{type}}가 부분 완료되었습니다.",
            "Folder Upload": "폴더 업로드",
            "Files Upload": "파일 업로드",
            "New Folder": "새 폴더",
            "Upload Files": "업로드 파일",
            "References": "참조",
            "Every months on": "매월",
            "Archive": "아카이브",
            "Archving...": "아카이빙 중...",
            "Folder path": "폴더 경로",
            "No assets folder": "존재하지 않는 자산과 폴더",
            "Restoring...": "복구 중...",
            "Search in folder": "폴더 내 검색",
            "Root": "최상위",
            "Search results": "검색 결과",
            "Restoring": "복구",
            "Archiving": "아카이빙",
            "days": "일",
            "Achived Assets": "아카이브된 자산",
            "Archived": "아카이브",
            "Empty Archived": "아카이브된 항목이 없습니다",
            "Empty Data": "데이터가 비었습니다",
            "Archived by": "아카이브 작업자",
            "Archived Period": "아카이브 기간",
            "Archived Assets": "아카이브된 자산",
            "Restored": "복구 완료",
            "Archive ID": "아카이브 ID",
            "Multi Audio": "멀티 오디오",
            "New folder": "폴더 생성",
            "VIDEOS": "동영상",
            "VIEWERS": "시청자 수",
            "WATCH_COUNT": "시청 횟수",
            "DEVICE_VIEWERS_ON_TERM": "디바이스별 시청자 수 (기간)",
            "DEVICE_VIEWERS_ON_PERCENTAGE": "디바이스별 시청자 수 (백분율)",
            "COUNTRY_VIEWERS_ON_TERM": "나라별 시청자 수 (기간)",
            "COUNTRY_VIEWERS_ON_PERCENTAGE": "나라별 시청자 수 (백분율)",
            "REGION_VIEWERS_ON_TERM": "지역별 시청자 수 (기간)",
            "REGION_VIEWERS_ON_PERCENTAGE": "지역별 시청자 수 (백분율)",
            "CITY_VIEWERS_ON_TERM": "도시별 시청자 수 (기간)",
            "CITY_VIEWERS_ON_PERCENTAGE": "도시별 시청자 수 (백분율)",
            "VIEWERS_PROGRESS": "영상 구간별 시청자수",
            "NOT_READY": "NOT_READY",
            "Reference": "참조",
            "Restore": "복원",
            "Folder search": "폴더 검색",
            "Folder": "폴더",
            "Search in {{name}}": "{{name}} 내에서 검색",
            "{{name}} View": "{{name}} 보기",
            "Hierarchy": "계층",
            "{{name}} Search": "{{name}} 검색",
            "Confirm": "확인",
            "All lineups": "모든 라인업",
            "Repeat lineups": "반복 라인업",
            "All Copy to": "전체 복사",
            "Date to All copy to": "전체 복사할 날짜",
            "Daily Copy": "일별 복사",
            "Check date to all copy to": "전체 복사할 날짜 확인",
            "Available": "Available",
            "No assets category": "존재하지 않는 카테고리 자산",
            "No videos folder": "존재하지 않는 비디오 폴더",
            "No videos category": "존재하지 않는 비디오 카테고리",
            "No channels category": "존재하지 않는 채널 카테고리",
            "Create Auto Captions": "Auto Captions 생성",
            "Creating Auto Caption": "Auto Caption 생성",
            "Create Auto Caption": "Auto Caption 생성",
            "Default Language": "기본 언어",
            "Last login": "마지막 로그인",
            "Change view": "레이아웃 변경",
            "Of": "의",
            "All approval status": "모든 승인 상태",
            "Action rules": "동작 규칙",
            "Delete Constraints": "삭제 제약",
            "Copy to Constraints": "복사 제약",
            "Expired date :": "유효 기간 :",
            "Timeshift": "타임시프트",
            "Sec": "초",
            "DeleteFaceIndex": "얼굴 인덱스 삭제",
            "ModifyFaceIndex": "얼굴 인덱스 수정",
            "EditFaces": "얼굴 편집",
            "FaceToIndex": "인덱싱할 얼굴",
            "FaceToUnindex": "인덱싱 해제할 얼굴",
            "FacesIndexed": "인덱싱된 얼굴",
            "StorageClass": "스토리지 클래스",
            "Last Modified": "마지막 수정",
            "Objects": "객체",
            "View More": "더보기",
            "No buckets folder": "버킷 폴더 없음",
            "Access": "엑세스 하기",
            "Manage": "관리",
            "Source Buckets": "소스 버킷",
            "Bucket": "버킷",
            "Custom": "정의",
            "Header": "Header",
            "Setting": "설정",
            "Theme": "Theme",
            "White": "White",
            "Black": "Black",
            "CI": "로고",
            "BG": "배경",
            "Color": "색상",
            "Text button": "텍스트 버튼",
            "Quick Select": "빠른 선택",
            "User": "사용자",
            "Language Settings": "언어 설정",
            "Specific Language": "언어 직접 설정",
            "Auto Language": "언어 자동 설정",
            "Go analysis": "분석으로 이동",
            "Copy to": "복사",
            "Copy": "복사",
            "Move": "이동",
            "All Storage Class": "모든 스토리지 클래스",
            "Standard": "Standard",
            "Reduced Redundancy": "Reduced Redundancy",
            "Stanard-IA": "Stanard-IA",
            "One Zone-IA": "One Zone-IA",
            "Intelligent Tiering": "Intelligent Tiering",
            "Glacier": "Glacier",
            "Deep Archive": "Deep Archive",
            "Outposts": "Outposts",
            "Extension": "확장자",
            "All extensions": "모든 확장자",
            "Create FILE asset": "파일 자산 생성",
            "Channel Overview": "채널 개요",
            "Meeting": "미팅",
            "Rooms": "Rooms",
            "Recent Schedule": "현재 스케줄",
            "out of {{total}}": "전체 {{total}} 중",
            "Lock": "잠금",
            "people": "피플",
            "Disabled": "미사용",
            "Create Channel": "채널 생성",
            "Meetings": "미팅",
            "Unlock": "잠금 해제",
            "Locked": "잠김",
            "All": "전체",
            "Megazone Accounts": "Megazone 계정",
            "Megazone Login": "Megazone 로그인",
            "Sign in with Megazone Login": "메가존 계정으로 로그인",
            "or": "또는",
            "Basic": "기본",
            "Analyze by timestamp": "타임스탬프 별 분석",
            "Usage Time": "사용시간",
            "Music": "뮤직",
            "Photo": "포토",
            "Audio Sources": "오디오 소스",
            "Album Images": "앨범 이미지",
            "Teaser Images": "티저 이미지",
            "Music Videos": "뮤직 비디오",
            "Teaser Videos": "티저 비디오",
            "Live Videos": "라이브 비디오",
            "Music Description": "음악 설명",
            "No musics category": "음악 카테고리 없음",
            "INACTIVE": "비활성",
            "Update {{name}}": "{{name}} 수정",
            "{{name}} Description": "{{name}} 설명",
            "Share": "공유",
            "Shared Box": "공유함",
            "Share Box": "공유 박스",
            "Shared Date": "공유일",
            "Share to me": "나에게 공유",
            "Share by me": "공유하기",
            "Add to Shared Box": "공유 상자에 추가",
            "Remove from Share Box": "공유 상자에서 제거",
            "Shared {{name}}": "공유 {{name}}",
            "Share Management": "공유 관리",
            "Shared with Me": "나에게 공유됨",
            "Requested to Share": "공유 요청",
            "Requester": "요청자",
            "Requested": "요청됨",
            "Review Request": "요청 검토",
            "Review Access Request": "액세스 요청 검토",
            "Please add {{name1}} and {{name2}}.": "{{name1}} 및 {{name2}}을(를) 추가하십시오.",
            "Phone Number": "전화 번호",
            "Asset Sharer": "자산 공유자",
            "Quick": "빠른",
            "Advanced": "고급",
            "Show": "보기",
            "{{view}} Search fields": "{{view}} 검색 영역",
            "Search for assets by all projects.": "모든 프로젝트의 자산을 검색",
            "<0>{{count}}</0> Results for your Search": "<0>{{count}}</0> 검색 결과",
            "Management": "관리",
            "Assets to be shared": "공유 할 자산",
            "Please add {{name}}.": "{{name}}를 추가하십시오.",
            "Image Viewer": "이미지 뷰어",
            "Images Viewer": "이미지 뷰어",
            "Result of <0>{{name}}</0>": "<0>{{name}}</0> 에 의한 결과",
            "Download Link": "다운로드 링크",
            "Elements": "요소",
            "This download link URL is only available for one week from now.": "이 다운로드 링크 URL은 지금부터 일주일 동안 만 사용할 수 있습니다.",
            "Preparing download link URL": "다운로드 링크 URL 준비 중",
            "No Images List": "이미지 목록 없음",
            "File Meta": "파일 메타",
            "Operation": "조작",
            "Versions": "버전",
            "Version": "버전",
            "Current Version": "현재 버전",
            "My Activity": "나의 활동",
            "Share Management Rules": "공유 관리 규칙",
            "Users and teams belonging to the project for the selected asset are excluded from sharing.": "선택한 자산의 프로젝트에 속한 사용자 및 팀은 공유에서 제외됩니다.",
            "Search for assets in this project.": "이 프로젝트에서 자산을 검색하십시오.",
            "Recent People": "최근 인물",
            "Recent Music": "최근 뮤직",
            "Recent Photos": "최근 사진",
            "Recent Photo": "최근 사진",
            "Reason for sharing request (Optional)": "공유 요청 이유 (선택 사항)",
            "Request Access": "접근 요청",
            "Display Name": "표시명",
            "Department": "Department",
            "results": "결과",
            "Sharer": "공유자",
            "Shared": "공유됨",
            "Last Login": "마지막 로그인",
            "Spec": "스펙",
            "Asset’s Project": "자산의 프로젝트",
            "All Projects": "모든 프로젝트",
            "All Users": "모든 사용자",
            "Only mine": "내 항목만",
            "Rename": "이름 변경",
            "Moving": "이동 중",
            "Copying to": "복사 중",
            "Deleting": "삭제 중",
            "Renaming": "이름 변경 중",
            "{{type}} completed.": "{{type}}(이)가 완료되었습니다.",
            "Partial {{type}} completed.": "일부 {{type}}(이)가 완료되었습니다.",
            "{{type}} canceled.": "{{type}}(이)가 취소되었습니다.",
            "{{type}} error.": "{{type}}하는 도중 오류가 발생했습니다.",
            "Overwrite or skip file": "파일 덮어쓰기 또는 건너뛰기",
            "Pending {{type}}...": "{{type}} 대기 중...",
            "Ask": "묻기",
            "Always Overwrite": "항상 덮어쓰기",
            "Always Skips": "항상 건너뛰기",
            "Handling in case of duplicate files": "중복 파일 처리",
            "Apply to all": "모두 적용",
            "Shares": "공유",
            "Accessible Projects": "접근 가능한 프로젝트",
            "Recent Videos": "최근 동영상",
            "Recent Assets Shared with Me": "나와 공유 된 최근 자산",
            "Search all assets": "모든 자산 검색",
            "Search assets": "자산 검색",
            "Add Users and Teams": "사용자 및 팀 추가",
            "Project Settings": "프로젝트 설정",
            "Back to Console": "콘솔로 돌아가기",
            "No related assets": "연결된 자산 없음",
            "No reference": "참조 없음",
            "My Assets": "나의 자산",
            "Group": "그룹",
            "Group ID": "그룹 ID",
            "Groups": "그룹",
            "No Groups": "그룹 없음",
            "Add groups": "그룹 추가",
            "Add Users and Groups": "사용자 및 그룹 추가",
            "Enter Users and Groups": "사용자 및 그룹 입력",
            "Assets shared with the group are not deleted": "그룹과 공유 된 자산은 삭제되지 않습니다.",
            "Group overview": "그룹 개요",
            "Selected files": "선택한 파일",
            "Create by Transcoding": "트랜스코딩으로 생성",
            "Create as Assets": "자산으로 생성",
            "ItemSet for Metadata": "메타데이터용 항목세트",
            "ItemSet": "항목 세트",
            "Items": "항목",
            "Multiple": "다중",
            "Storage": "저장소",
            "CaptionSync": "캡션 동기화",
            "Fast": "빨리",
            "Slow": "느리게",
            "No Time Change": "시간 변경 없음",
            "Time Control": "시간 제어",
            "No captions": "캡션 없음",
            "Edit Captions": "캡션 편집",
            "sec": "초",
            "Interactive Video": "인터렉티브 비디오",
            "Interactive Videos": "인터렉티브 비디오",
            "Open Chatting": "오픈 채팅",
            "Group Chatting": "그룹 채팅",
            "Add Attendees": "참석자 추가",
            "Recording": "레코딩",
            "Ending Video": "엔딩 영상",
            "msec": "밀리초",
            "Enter Email Address": "이메일 주소 입력",
            "Intro Video URL": "소개 동영상 URL",
            "Ending Video URL": "종료 동영상 URL",
            "Empty Recording History": "빈 녹화 기록",
            "Recording History": "녹화 기록",
            "Recording Time": "녹화 시간",
            "Intro Videos": "소개 영상",
            "Ending Videos": "엔딩 영상",
            "No Schedule": "일정 없음",
            "Input file upload error": "입력 파일 업로드 실패",
            "Input file preprocessing error": "입력 파일 전처리 실패",
            "MediaConvert transcoding error": "MediaConvert 트랜스코딩 실패",
            "Input file post processing error": "입력 파일 후처리 실패",
            "Console first entry screen": "콘솔 첫 진입 화면",
            "Add attendees to join the Group Chatting": "그룹 채팅에 참여할 참석자 추가",
            "Add attendees": "참석자 추가",
            "Schedule Name": "일정 이름",
            "Schedule Time": "일정 시간",
            "Channel type": "채널 유형",
            "Video latency": "비디오 지연",
            "Playback authorization": "재생 승인",
            "Standard latency": "표준 지연 시간",
            "Ultra-low latency": "초저지연",
            "Amazon IVS": "Amazon IVS",
            "Amazon Chime": "Amazon Chime",
            "Playback": "재생",
            "Recordings": "녹화",
            "Recorded Videos": "녹화된 비디오",
            "Event Time": "이벤트 시간",
            "Storage Path": "저장 경로",
            "Change after channel creation": "채널 생성 후 변경",
            "Create Assets on creation": "생성 시 자산 생성",
            "Manage Access": "엑세스 관리",
            "Search with subcategories": "하위 카테고리로 검색",
            "Service Provider": "서비스 제공자",
            "Sync complete": "동기화 완료",
            "Sync failed": "동기화 실패",
            "Synchronizing": "동기화 중",
            "Sync refresh": "동기화 새로 고침",
            "Projects Allowed To Use": "사용이 허용된 프로젝트",
            "SPACE ADMINISTRATION": "스페이스 관리",
            "CloudPlex Delivery": "CloudPlex Delivery",
            "CloudPlex Start": "CloudPlex Start",
            "Switch to Admin": "관리자로 전환",
            "Add User": "사용자 추가",
            "UserName": "사용자이름",
            "Last Access": "마지막 액세스",
            "Add teaser images": "티저 이미지 추가",
            "out of": "총 ",
            "Indexed Faces": " 개 인덱스된 얼굴 중",
            "Products": "제품",
            "Customer Service": "고객 서비스",
            "Invitation Pending": "초대 대기 중",
            "Has Space Access": "스페이스 이용 가능",
            "No Space Access": "스페이스 접근 불가",
            "Member": "회원",
            "Trusted": "신뢰할 수 있음",
            "No role": "역할 없음",
            "Revoke space access": "스페이스 액세스 취소",
            "Last Name": "성",
            "First Name": "이름",
            "Phone number": "전화 번호",
            "Company": "회사",
            "Position": "위치",
            "’s Detail": "의 세부 사항",
            "Has access on Space": "Space에 대한 액세스 권한이 있습니다.",
            "Administrator": "관리자",
            "Any role": "모든 역할",
            "Last Activity": "마지막 활동",
            "Grant space access": "스페이스 액세스 권한 부여",
            "Remove user": "사용자 제거",
            "Add {{number}} users": "{{number}}명의 사용자 추가",
            "Add user": "사용자 추가",
            "Add attribute": "속성 추가하기",
            "Next": "다음",
            "Photos": "포토",
            "Zoom in": "확대",
            "Zoom out": "축소",
            "Previous": "이전",
            "Compressing": "압축중",
            "Ready to {{type}}": "{{type}} 준비가 완료되었습니다",
            "Select Files": "파일 선택",
            "Edit Default Metadata": "기본 메타데이터 편집",
            "Edit and Create Assets": "에셋 편집 및 생성",
            "Create assets": "에셋 생성",
            "create assets": "에셋 생성",
            "Create Assets": "에셋 생성",
            "assets": "자산",
            "Asset creation": "에셋 생성",
            "Create Assets Bulk": "에셋 대량 생성",
            "Selected Files": "선택한 파일",
            "Edit Metadata": "메타데이터 편집",
            "APPLY ALL OVER Options": "옵션 전체에 적용",
            "Apply All Over": "전체 적용",
            "Set as Options": "옵션으로 설정",
            "Asset Name Alias": "에셋 이름 별칭",
            "Choose Bulk Operation": "대량 작업 선택",
            "Asset Type": "에셋 유형",
            "Asset Composition Type": "에셋 구성 유형",
            "Set to Default": "기본값으로 설정",
            "Preparing {{type}}...": "{{type}} 준비중...",
            "Add Files to Bulk": "벌크 파일 추가",
            "Choose Files": "파일 선택",
            "A total of <0> {{number}} </0> files can be added.": "총 <0> {{number}} </0>개의 파일을 추가할 수 있습니다.",
            "Add All": "모두 추가",
            "If a file is changed or deleted from the storage list": "스토리지 목록에서 파일을 변경 및 삭제 하였을 경우",
            "Asset Composition Types": "에셋 구성 유형",
            "Auto-apply language & labels": "언어와 레이블 자동 적용",
            "Ex": "예",
            "Single Asset": "단일 에셋",
            "Multiple Asset": "다중 에셋",
            "Filters": "필터",
            "Add Assets": "자산 추가",
            "No Files": "파일 없음",
            "Caption Type Asset Creation Rules": "캡션 타입 에셋 생성 규칙",
            "Language & Label": "언어 와 레이블",
            "If there is a language code after the file name (_)": "파일명(_) 뒤에 언어코드가 있을 경우",
            "If there is no language code after the file name (_)": "파일명(_) 뒤에 언어코드가 없을 경우",
            "Add <0> {{number}} </0> file(s)": "파일 <0> {{number}} </0>개 추가",
            "Ready": "준비됨",
            "In Progress": "진행 중",
            "FAILED": "실패",
            "NOT_SUPPORTED": "미지원",
            "PARTIAL_COMPLETED": "부분 완료",
            "Video and image content analysis": "영상·이미지 내용 분석",
            "Metadata analysis": "메타데이터 분석",
            "AI search mode indexing": "AI 검색모드 인덱싱",
            "AI search indexing status": "AI 검색 인덱싱 상태",
            "AI search mode": "AI 검색 모드",
            "Indexing status": "인덱싱 상태",
            "Request to Create Assets": "에셋 생성 요청",
            "In Order of Accuracy": "정확도 순으로",
            "Latest Order": "최근순으로",
            "Only Mine": "접근 가능한 파일",
            "Other then Mine": "기타 파일",
            "Detailed Filter": "상세 필터",
            "Storage Class": "스토리지 클래스",
            "Search for storage and assets by all projects.": "모든 프로젝트의 스토리지 및 자산을 검색",
            "Please enter your search term": "검색어를 입력하세요",
            "Please check the search term you entered again.": "입력하신 검색어를 다시 확인해 주세요.",
            "Only My Buckets": "내 버킷만",
            "Other Buckets": "그 외 버킷",
            "Only My Projects": "내 프로젝트만",
            "Other Projects": "그 외 프로젝트",
            "No results were found for your search.": "검색에 대한 결과가 없습니다.",
            "Please re-enter your search term.": "검색어를 다시 입력해주세요.",
            "Please enter your search term.": "검색어를 입력해주세요.",
            "Select Bucket": "버킷 선택",
            "Choose the bucket you want to use.": "사용하려는 버킷을 선택합니다.",
            "Current Project": "현재 프로젝트",
            "Accessible": "접근 가능",
            "Not Accessible": "접근 불가능",
            "Current": "현재",
            "Project other than this one": "이 프로젝트 이외의 프로젝트",
            "Use of features based on access": "접근 여부에 따른 기능 사용",
            "All functions available": "모든 기능 사용가능",
            "All functions unavailable": "모든 기능 사용불가",
            "Partial functions unavailable": "일부 기능 사용가능",
            "Folder path to check": "확인할 폴더 경로",
            "Current project": "현재 프로젝트",
            "Switch Project": "프로젝트 전환",
            "Project to switch to": "전환할 프로젝트",
            "Add users and teams to share": "공유할 사용자 및 팀 추가",
            "Link Setting": "링크 설정",
            "Password": "비밀번호",
            "Link": "링크",
            "download link URL": "다운로드 링크 URL",
            "Download Period": "다운로드 기간",
            "Number of Downloads": "다운로드 수",
            "Files to share": "공유할 파일",
            "The files to download are ready.": "다운로드할 파일이 준비되었습니다.",
            "The number of password errors has been exceeded.": "비밀번호 오류 수가 초과되었습니다.",
            "The download period of times has expired.": "다운로드 기간이 만료되었습니다.",
            "The download number of times has expired.": "다운로드 횟수가 만료되었습니다.",
            "The page not found.": "페이지를 찾을 수 없습니다.",
            "Enter your Password": "비밀번호를 입력하세요",
            "Show Password": "비밀번호 표시",
            "Enter {{name}}": "{{name}}을 입력하세요",
            "Done": "완료",
            "Enter Name": "이름을 입력하세요",
            "Share Link": "링크 공유",
            "Share Request": "공유 요청",
            "Choose One Approver": "승인자 선택",
            "File to request": "요청할 파일",
            "Send request": "요청 보내기",
            "Expires At": "만료일",
            "History of my request to share": "요청한 내역",
            "History of requests to share": "요청 받은 내역",
            "Previous Request": "이전 요청",
            "Linked Requests": "연결된 요청",
            "Shared History": "공유 기록",
            "Permission": "허가",
            "Reason for Approval (Optional)": "승인 사유(선택사항)",
            "Reason for Reject (Optional)": "거부 사유(선택 사항)",
            "Select User": "사용자를 선택",
            "Canceled": "취소됨",
            "Shared by me": "내가 공유함",
            "Shared with me": "나와 공유됨",
            "Shared with": "공유 된",
            "Revoke": "회수",
            "Revoked": "회수됨",
            "Revoke access": "권한 회수",
            "Revoke link": "회수하기",
            "File to be shared": "공유할 파일",
            "By last shared": "마지막 공유 기준",
            "By last modified": "마지막 수정자",
            "By name": "이름",
            "By type": "유형별",
            "Removed": "제거됨",
            "Manage shared with": "공유",
            "Send email with password": "비밀번호가 포함된 이메일 보내기",
            "Include": "포함",
            "Not Include": "포함하지 않음",
            "Request expired": "요청 만료됨",
            "Shared by": "공유자",
            "Create Videos": "비디오 생성",
            "Create People": "인물 생성",
            "Create Music": "뮤직 생성",
            "Create Photo": "포토 생성",
            "Folder Path": "폴더 경로",
            "Select Folder Path": "폴더 경로 선택",
            "Folder View": "폴더 보기",
            "Category View": "카테고리 보기",
            "View All": "모두보기",
            "Zendesk Widget": "Zendesk 위젯",
            "Widget": "위젯",
            "Widget Settings": "위젯 설정",
            "Zendesk Settings": "Zendesk 설정",
            "Zendesk Domain": "Zendesk 도메인",
            "API Token": "API 토큰",
            "Locale": "장소",
            "Page URL": "페이지 URL",
            "Show API Token": "API 토큰 표시",
            "Section ID": "섹션 ID",
            "Topic ID": "주제 ID",
            "Minimum Image Size": "최소 이미지 크기",
            "Metadata Template": "메타데이터 템플릿",
            "Name Prefix": "이름 접두어",
            "Metadata Preset": "메타데이터 프리셋",
            "Metadata Name Prefix": "메타데이터 이름 접두어",
            "Metadata Template Name": "메타데이터 템플릿 이름",
            "Metadata Template Description": "메타데이터 템플릿 설명",
            "Select Metadata Template": "메타데이터 템플릿 선택",
            "Asset to share": "공유할 에셋",
            "Message": "메세지",
            "Message (Optional)": "메세지 (선택사항)",
            "Send": "전송",
            "Add Users": "유저 추가",
            "Pending changes": "보류 중인 변경 사항",
            "Access Updated": "접근 권한 갱신됨",
            "No Assets Folders": "자산 폴더 없음",
            "Select Category Group": "카테고리 그룹 선택",
            "Discard": "무시",
            "<0> {{number}} </0> days": "<0> {{number}} </0> 일",
            "<0/> times": "<0/> 회",
            "Search Category Group": "카테고리 그룹 검색",
            "In Use": "사용중",
            "Not Used": "사용하지 않음",
            "File to share": "공유할 파일",
            "Asset Name Prefix": "자산 이름 접두어",
            "Save assets to the top-level path on the drive": "드라이브의 최상위 경로에 자산 저장",
            "Save assets according to the storage folder path": "저장 폴더 경로에 따라 자산 저장",
            "Save assets to the selected folder": "선택한 폴더에 자산 저장",
            "share": "공유",
            "Folder Path Option": "폴더 경로 옵션",
            "Clear All": "모두 지우기",
            "Grouping View mode": "그룹화 보기",
            "View All mode": "모두보기",
            "Requested At": "요청일시",
            "Subject": "요청사항",
            "Share Expires Date": "공유만료일",
            "Approval Status": "승인 상태 ",
            "Status Updated": "상태 업데이트일",
            "Shared History Action": "승인/거절",
            "Approver": "승인자 선택",
            "Sharehistory": "공유 기록",
            "Sharebox": "공유함",
            "Internal Share": "내부 공유",
            "External Share": "외부 공유",
            "asset creation": "에셋 생성",
            "Creating asset...": "에셋 생성중...",
            "No {{type}} Categories": "{{type}} 카테고리 없음",
            "Delete the asset?": "자산을 삭제하시겠습니까?",
            "Apply All": "모두 적용",
            "Delete the item?": "항목을 삭제하시겠습니까?",
            "Location": "위치",
            "Specify Here": "여기에서 지정",
            "Move the item?": "이 항목을 이동하시겠습니까?",
            "Move these items?": "이 항목들을 이동하시겠습니까?",
            "Dimensions": "해상도",
            "Asset Created": "자산 생성일",
            "History of my internal share requests": "요청한 내부 공유 내역",
            "History of internal sharing requests to me": "요청 받은 내부 공유 내역",
            "History of my external sharing": "외부 공유 내역",
            "No list": "목록 없음",
            "Restore the item?": "이 항목을 복원 하시겠습니까?",
            "Change Restore Option": "복원 옵션 변경",
            "Users shared with": "공유 받은 사람",
            "Status of ready": "준비상태",
            "Expiration Date": "만료일",
            "Items Shared": "공유된 항목",
            "Histories": "히스토리",
            "Shared Histories": "공유 히스토리",
            "Search owner": "소유자 검색",
            "Search extension": "확장자 검색",
            "Search type": "타입 검색",
            "Search filter": "필터 검색",
            "Search status": "상태 검색",
            "Mail Language Settings": "메일 언어 설정",
            "History of external share": "외부 공유 히스토리",
            "Calulating...": "계산 중...",
            "Asset Details": "자산 상세",
            "Asset Search Results": "자산 검색 결과",
            "API Endpoint": "API 엔드포인트",
            "Information": "정보",
            "USED": "사용",
            "UNUSED": "미사용",
            "Archive after adding assets": "자산 추가 후 아카이브",
            "Moving to CloudPlex Assets": "CloudPlex 자산으로 이동",
            "Download All": "모두 다운로드",
            "Starred": "별표 표시",
            "Hi, {{name}}": "안녕하세요! {{name}}님",
            "Switch to": "다음으로 전환",
            "Add to Starred": "별표 표시에 추가",
            "Remove from Starred": "별표 표시에서 제거",
            "Column Settings": "열 설정",
            "Sort in descending order": "내림차순 정렬",
            "Sort in ascending order": "오름차순 정렬",
            "Project Name": "프로젝트명",
            "Project Lead": "프로젝트 리더",
            "Sort by": "정렬 기준",
            "by name": "이름 순",
            "by most recent": "최신 순",
            "by update": "업데이트 순",
            "Last Updated": "마지막 수정 일시",
            "Hide all": "모두 숨기기",
            "ARCHIVED": "아카이브 됨",
            "ARCHIVING": "아카이브 중",
            "RESTORING": "복원 중",
            "PUBLIC": "공개",
            "PRIVATE": "비공개",
            "Add Project": "프로젝트 추가",
            "Grid Layout": "그리드 레이아웃",
            "List Layout": "리스트 레이아웃",
            "Lead": "리더",
            "New": "추가",
            "Project unassigned": "할당되지 않은 프로젝트",
            "Replace Asset": "자산 변경",
            "Set lockout for other users": "다른 사용자에 대한 잠금 설정",
            "locked by": "잠금",
            "Me": "나",
            "Locked by": "잠금",
            "locked by '{{name}}({{username}})'": "{{name}}({{username}})(이)가 잠금",
            "locked by 'Me'": "내가 잠금",
            "Automatic Bucket Lock Options": "자동 버킷 잠금 옵션",
            "Auto-Lock Enabled": "자동 잠금 활성화됨",
            "Size of files Option": "파일 크기 옵션",
            "Size of files": "파일 크기",
            "Number of files": "파일 수",
            "Number of files Option": "파일 수 옵션",
            "Default Archive Option": "기본 아카이브 옵션",
            "Allow customization when archiving": "아카이브 사용자 지정 허용",
            "Default Restore Options": "기본 복원 옵션",
            "Archive Option": "아카이브 옵션",
            "Restore Option": "복원 옵션",
            "Back to Project": "프로젝트로 돌아가기",
            "Archive the item?": "항목을 아카이브 하시겠습니까?",
            "Archive items?": "항목을 아카이브 하시겠습니까?",
            "Restore items?": "이 항목을 복원 하시겠습니까?",
            "files": "개",
            "CPD Integrations": "CPD 정합",
            "Credentials Information": "자격 증명 정보",
            "CloudPlex Delivery Information": "CloudPlex Delivery 정보",
            "Switch Admin": "관리자 전환",
            "Space List": "스페이스 목록",
            "App Download": "앱 다운로드",
            "REQUEST_ARCHIVE": "아카이브 요청",
            "REQUEST_RESTORE": "복원 요청",
            "ARCHIVE_ERROR": "아카이브 오류",
            "RESTORE_ERROR": "복원 오류",
            "RESTORED": "복원 됨",
            "Add Collection": "컬렉션 추가",
            "Collections": "컬렉션",
            "Assets Count": "자산 개수",
            "Collection Details": "컬렉션 상세",
            "Collection ID": "컬렉션 ID",
            "Linked Collections": "연결된 컬렉션",
            "All Media Types": "모든 미디어 타입",
            "Specify the folder location?": "폴더 위치를 지정하시겠습니까?",
            "Select assets through search": "검색을 통한 자산 선택",
            "Select assets in a specific folder?": "특정 폴더에서 자산을 선택하시겠습니까?",
            "Select assets in a specific folder": "특정 폴더에서 자산 선택",
            "Selected Assets": "선택된 자산",
            "max": "최대",
            "Also include assets from subfolders": "하위 폴더의 자산도 포함",
            "Only assets in that folder are selected": "해당 폴더의 자산만 포함",
            "Selected a Folder": "선택된 폴더",
            "Selected Collections": "선택된 컬렉션",
            "Add assets?": "에셋을 추가하시겠습니까?",
            "Collections Search Results": "컬렉션 검색 결과",
            "Enter ID": "아이디 입력",
            "Enter the creator": "만든 사람 입력",
            "Enter the person who modified it": "수정한 사람 입력",
            "Enter name": "이름 입력",
            "Collection": "컬렉션",
            "Specify the collection?": "컬렉션을 지정하시겠습니까?",
            "Assets to be created can be managed by applying them to a specific collection.": "생성될 에셋은 특정 컬렉션에 적용하여 관리할 수 있습니다.",
            "Specify the folder where the assets will be located. If not specified, it will be saved in the top path.": "자산이 위치할 폴더를 지정합니다. 지정하지 않으면 최상위 경로에 저장됩니다.",
            "Duplicate": "복제",
            "Add Fields": "필드 추가",
            "Metadata Fields": "메타데이터 필드",
            "Reference Fields": "참조 필드",
            "Hidden": "숨김",
            "Fields": "필드",
            "Enter default text": "기본 텍스트를 입력하세요.",
            "Enter default number": "기본 숫자를 입력하세요.",
            "Required": "필수 항목",
            "Create Content Schema": "콘텐츠 스키마 생성",
            "Content Schemas": "콘텐츠 스키마",
            "Details": "상세",
            "Search for the project name.": "프로젝트 이름을 검색해 보세요.",
            "Fields Search": "필드 검색",
            "No Metadata Fields yet.": "아직 메타데이터 필드가 없습니다.",
            "No Reference Fields yet.": "아직 참조 필드가 없습니다.",
            "Custom Fields": "사용자 정의 필드",
            "No {{isReference}} Fields yet.": "아직 {{isReference}} 필드가 없습니다.",
            "Enter field name": "필드 이름을 입력하세요",
            " {{name}}": " {{name}}",
            " '{{name}}' and <emp>{{count}}</emp> others": " '{{name}}' 외 <emp>{{count}}</emp>개",
            "Select type": "타입 선택",
            "Select status": "상태 선택",
            "Remove the item?": "항목을 제거하시겠습니까?",
            "Remove items?": "항목들을 제거하시겠습니까?",
            "Delete items?": "항목들을 삭제하시겠습니까?",
            "Archiving asset...": "자산 아카이빙 중...",
            "Restoring asset...": "자산 복원 중...",
            "Create {{schemaName}}": "{{schemaName}} 생성",
            "Selected Image": "선택한 이미지",
            "Selected {{referenceType}}s": "선택한 {{referenceType}}",
            "Enter text": "텍스트를 입력하세요",
            "Enter number": "숫자를 입력하세요",
            "No {{name}} yet.": "아직 {{name}}이(가) 없습니다.",
            "Enter description": "설명을 입력하세요",
            "Engine to Use": "사용할 엔진",
            "Service Type": "서비스 종류",
            "Auto Language (<Strong>{{n}}</Strong>/max. {{max}})": "자동 언어(<Strong>{{n}}</Strong>/최대 {{max}})",
            "Vocabulary Book": "단어장",
            "Select Vocabulary Book": "단어장 선택",
            "Not Selected": "선택되지 않은",
            "Select Default Language": "기본 언어 선택",
            "Go to vocabulary book": "단어장으로 이동",
            "Speaker Classification": "화자 분류",
            "Enter Label": "라벨을 입력하세요",
            "Enter Asset name": "자산 이름을 입력하세요",
            "Sounds Like": "발음과 비슷한 단어",
            "Display As": "표시할 단어",
            "Add Vocabulary": "단어 추가",
            "Enter Display As": "표시할 단어를 입력하세요",
            "Enter Sounds Like (Enter after typing)": "발음과 비슷한 언어를 입력하세요 (입력 후 엔터)",
            "Credentials": "자격 증명",
            "Engines": "엔진",
            "Available in Auto Captions.": "오토캡션에서 사용할 수 있습니다.",
            "Before input": "입력 전",
            "Typing": "입력 중",
            "Editing": "수정 중",
            "Input complete": "입력 완료",
            "Assets > Video Asset Detail > Related Assets": "자산 > 비디오 자산 세부정보 > 연결된 자산",
            "Contents > Videos Detail > Captions > Auto Captions": "콘텐츠 > 비디오 상세정보 > 캡션 > 오토 캡션",
            "Additional informations": "추가 정보",
            "Auto caption": "오토 캡션",
            "Console Default Language": "콘솔 기본 언어",
            "List Default Layout": "목록 기본 레이아웃",
            "Additional AI analysis": "추가 분석",
            "View timestamps": "타임스탬프 보기",
            "Start AI analysis": "AI 분석 시작",
            "AI analysis completed": "AI 분석 완료",
            "AI Analysis": "AI 분석",
            "Added to Check timestamp": "'타임스탬프 확인'에 추가됨",
            "Removed from Check timestamp": "'타임스탬프 확인'에서 삭제됨",
            "Removed from Metadata tags": "'메타데이터 태그'에서 삭제됨",
            "Added to Metadata tags": "'메타데이터 태그'에 추가됨",
            "Engine": "엔진",
            "Summary analysis result": "요약 분석 결과",
            "Original analysis result": "원본 분석 결과",
            "Top 10 most exposed labels": "노출이 많이된 라벨 Top 10",
            "Exposure Point (First / Last)": "노출 지점(첫 번째 / 마지막)",
            "Label detection in Video": "비디오의 레이블을 탐지합니다.",
            "Recognize Faces in Video": "비디오에서 인덱싱된 얼굴을 인식합니다.",
            "Recognize Celebrity in Video": "비디오에서 유명인의 얼굴을 인식합니다.",
            "Content Moderation in Video": "비디오의 유해성 검사를 합니다. ",
            "Video transcription": "비디오의 음성을 받아쓰기 합니다.",
            "Long audio transcription": "음성파일을 문자로 받아쓰기합니다.",
            "Annotate Scenes in Video": "비디오의 장면을 분석합니다",
            "Recognize Texts in Video": "비디오에서 텍스트를 인식합니다.",
            "Avg. Confidence (%)": "평균 신뢰 (%)",
            "Timestamp - Start": "타임스탬프 - 시작",
            "Timestamp - End": "타임스탬프 - 종료",
            "Analysis result {{number}}": "분석 결과 {{number}}",
            "Auto Detected": "자동 감지",
            "Check timestamp for each label": "라벨별 타임스탬프 확인",
            "View Details": "상세 보기",
            "Fold": "축소",
            "Expand": "확장",
            "point of initial exposure": "최초 노출 지점",
            "last exposure point": "마지막 노출 지점",
            "Update Asset": "자산 업데이트",
            "Reply to thread": "스레드에 답장",
            "Edit message": "메세지 수정",
            "Add reaction": "반응 추가",
            "Delete message": "메세지 삭제",
            "{{commentCount}} replies": "{{commentCount}}개의 댓글",
            "See all replies": "모든 댓글 보기",
            "replies": "댓글",
            "Thread": "스레드",
            "Reply": "댓글",
            "Replied to :": "댓글 대상 :",
            "Please enter your message.": "메세지를 입력해주세요.",
            "Yesterday": "어제",
            "member of comment": "댓글 멤버",
            "Change name": "이름 변경",
            "Private comment name (maximum <0>{{count}}</0> characters)": "비공개 댓글 이름 (최대 <0>{{count}}</0> 자)",
            "Add member": "멤버 추가",
            "Delete private comment": "비공개 댓글 삭제",
            "All public": "전체 공개",
            "member": "멤버",
            "Check": "확인",
            "Private comment name": "비공개 댓글 이름",
            "Comments where I was mentioned": "내가 언급된 댓글",
            "Comments written by me": "내가 쓴 댓글",
            "Comments in threads I belong to": "내가 속한 스레드의 댓글",
            "Reply to my comment": "내 댓글에 달린 댓글",
            "My Comments": "내 댓글",
            "Waiting for invitation": "초대 대기 중",
            "User invitation": "사용자 초대",
            "Would you like to invite users?": "사용자를 초대하시겠습니까?",
            "Invite": "초대하기",
            "Accessible project": "접근 가능한 프로젝트",
            "Invitation date": "초대 날짜",
            "Pending Invitation": "대기 중인 초대",
            "User waiting to be invited": "초대를 기다리는 사용자",
            "Projects you want to allow access to": "액세스를 허용하려는 프로젝트",
            "Manual settings": "수동 설정",
            "Auto settings": "자동 설정",
            "ROLES_Read": "읽기 권한",
            "ROLES_Edit": "편집 권한",
            "ROLES_Archive": "아카이브 권한",
            "ROLES_Download": "다운로드 권한",
            "ROLES_Internal": "내부 공유 권한",
            "ROLES_External": "내・외부 공유 권한",
            "ROLES_Publish": "게시 권한",
            "ROLES_Internal Request": "내부 요청 권한",
            "Create Roles": "역할 생성",
            "No permission": "권한 없음",
            "Custom Metadata": "커스텀 메타데이터",
            "Select Content Schema": "콘텐츠 스키마 선택",
            "Search by content schema name.": "콘텐츠 스키마 이름으로 검색하세요.",
            "Selected schema": "선택된 스키마",
            "CreatedAt": "생성일",
            "Accessed": "엑세스됨",
            "Add Users or Groups": "사용자 또는 그룹 추가",
            "Share Settings": "공유 설정",
            "Add to Added Users": "공유된 사용자에 추가",
            "Maximum": "최대",
            "times": "회",
            "Current location": "현재 위치",
            "Where to clone": "복제할 위치",
            "Save to top path": "최상위 경로에 저장",
            "Parent folder": "상위 폴더",
            "Parent folder location": "상위 폴더 위치",
            "Select file": "파일 선택",
            "Unapply": "적용 해제",
            "Undo add": "추가 해제",
            "Clear": "초기화",
            "Choose one custom data.": "하나의 커스텀 데이터를 선택하세요.",
            "Folder Duplication": "폴더 복제",
            "Duplication target folder": "복제 대상 폴더",
            "Asset to be duplicated": "복제할 자산",
            "Request share": "공유 요청",
            "Share link": "링크 공유",
            "Downloader Permission Settings": "다운로더 권한 설정",
            "Sharing Period": "공유 기한",
            "Related Assets": "관련된 에셋",
            "Linked Assets": "연결된 에셋",
            "Remove Asset": "에셋 제거",
            "Add Linked Assets?": "연결된 에셋을 추가하시겠습니까?",
            "Menu Display": "메뉴 표시",
            "info": "정보",
            "Specify Folder Location": "폴더 위치 지정",
            "Select by Recent Location": "최근 폴더 위치 선택",
            "Create a private comment": "비공개 댓글 만들기",
            "Open comment window": "댓글 창 열기",
            "Close comment window": "댓글 창 닫기",
            "Specify Collection": "컬렉션 지정",
            "Moving to CloudPlex Media…": "CloudPlex Media로 이동중…",
            "edited": "수정됨",
            "Uploading files": "파일 업로드 중",
            "Cancel Upload": "업로드 취소하기",
            "Attach Files": "파일 첨부하기",
            "Mention": "멘션하기",
            "Attach Emoji": "이모지",
            "Files cannot be attached.": "파일을 첨부할 수 없습니다.",
            "Select collections in a specific folder?": "특정 폴더에서 컬렉션 선택",
            "Asset Duplication": "에셋 복제",
            "Please search by folder name": "폴더 이름으로 검색해주세요.",
            "Added Users": "공유된 사용자",
            "Custom Content": "커스텀 콘텐트",
            "Storages": "저장소",
            "Custom Contents": "커스텀 콘텐트",
            "All categories": "모든 카테고리",
            "Default Custom Metadata": "기본 커스텀 메타데이터",
            "Default View Mode": "기본 뷰 모드",
            "List view": "전체 뷰",
            "Folder view": "폴더 뷰",
            "Category view": "카테고리 뷰",
            "Select default metadata template": "기본 메타데이터 템플릿 선택",
            "Select default custom metadata": "기본 커스텀 메타데이터 선택",
            "Please enter a message for your request (Optional)": "요청사항에 대한 메시지를 입력해주세요(선택사항)",
            "Enter name or email": "이름이나 이메일을 입력해주세요.",
            "Duplicate this role?": "이 역할을 복제하시겠습니까?",
            "Change Name": "이름 변경",
            "Enter required values": "필수값 입력하기",
            "Select Custom Metadata": "커스텀 메타데이터 선택",
            "Select custom metadata": "커스텀 메타데이터 선택",
            "Duplicate within a subfolder": "하위 폴더 포함하여 복제하기",
            "Duplication target assets": "복제 대상 자산",
            "Asset to be copied": "복제 대상 자산",
            "Create assets from all files individually": "모든 파일에서 개별적으로 자산 만들기",
            "Creating image and caption files as one asset": "이미지와 캡션 파일을 하나의 자산으로 만들기",
            "Please select files to add": "추가할 파일을 선택하세요.",
            "Select all files": "파일 전체 선택",
            "InteractiveVideos": "인터렉티브 비디오",
            "and <emp>{{count}}</emp> others": "외 <emp>{{count}}</emp>개",
            "Asset Bulk Create": "자산 대량 생성",
            "An error occurred while preparing the asset for {{type}}.": "{{type}}에 대한 자산을 준비하는 동안 오류가 발생했습니다.",
            "Transcode in progress": "트랜스코드 진행중",
            "Transcode has been cancelled.": "트랜스코드가 취소되었습니다.",
            "Transcode completed.": "트랜스코드가 \b완료되었습니다.",
            "An error occurred while transcoding.": "트랜스코드 \b하는 동안 오류가 발생했습니다.",
            "Asset Duplicate": "자산 복제",
            "Asset Jobs": "자산 작업",
            "Source Upload": "저장소 업로드",
            "Source Jobs": "저장소 작업",
            "This operation was not entirely successful.": "이 작업은 완전히 성공하지 못했습니다.",
            "Change Menu Name": "메뉴 이름 변경",
            "Default menu name": "기본 메뉴 이름",
            "Menu name to change": "변경할 메뉴 이름",
            "Apply as default menu name": "기본 메뉴 이름으로 적용",
            "History of share link": "링크 공유 기록",
            "Delete Group": "그룹 삭제",
            "COPY_ASSETS": "자산 복제",
            "UPLOAD_ASSET": "자산 생성",
            "CREATE_ASSETS": "자산 대량 생성",
            "UPLOAD": "저장소 업로드",
            "ASSET_DOWNLOAD": "자산 다운로드",
            "STORAGE_DOWNLOAD": "저장소 다운로드",
            "Create Asset": "자산 생성",
            "TRANSCODE": "트랜스코드",
            "COPY": "복제",
            "RENAME": "이름변경",
            "MOVE": "이동",
            "DELETE": "삭제",
            "Replication location": "복제 위치",
            "existing location": "기존 위치",
            "Copy assets": "자산 복제",
            "Drag files here": "여기로 파일을 드래그하세요.",
            "Browse": "검색",
            "drop your files to upload": "업로드할 파일을 드랍하세요",
            "Downloader": "다운로더",
            "Viewer": "뷰어",
            "Adjust": "적용",
            "Back to list": "목록으로 돌아가기",
            "Back to comments": "댓글로 돌아가기",
            "View private comments": "비공개 댓글방 목록 보기",
            "Close private comments": "비공개 댓글방 목록 닫기",
            "Select project": "프로젝트 선택",
            "Role settings": "권한 설정",
            "All projects": "모든 프로젝트",
            "Comments": "댓글",
            "Folders": "폴더",
            "Integrated Search": "통합 검색",
            "Users & Groups": "사용자 & 그룹",
            "Project In Use": "사용중인 프로젝트",
            "Manage Account": "계정 관리",
            "Log out": "로그아웃",
            "Sub menu": "하위 메뉴",
            "Storage files": "저장소 파일",
            "Please enter a description of the asset.": "자산에 대한 설명을 입력하세요.",
            "Create Role": "권한 생성",
            "Create Workflow": "워크플로우 생성",
            "Comment": "댓글",
            "Specific": "특정 기능",
            "Go to space list": "스페이스 목록으로 이동하기",
            "Bold": "굵게",
            "Underline": "밑줄",
            "Strikethrough": "취소선",
            "Share request": "공유 요청",
            "contents": "컨텐츠",
            "collections": "컬렉션",
            "preview images": "프리뷰 이미지",
            "Add {{name}}?": "{{name}}을 추가하시겠습니까?",
            "User invited to group": "그룹으로 초대된 사용자",
            "Space Admin": "Space 관리자",
            "Project Admin": "Project 관리자",
            "Recent Assets": "최근 자산",
            "Recent Assets Shared To Me": "최근 공유된 자산",
            "archive assets": "자산 아카이브",
            "ARCHIVE_ASSETS": "자산 아카이브",
            "An error occurred while preparing {{type}}.": "{{type}}을(를) 준비하는 동안 오류가 발생했습니다.",
            "Preparing {{type}}": "{{type}} 준비중",
            "{{type}} in progress": "{{type}} 진행 중",
            "Metadata Export": "메타데이터 내보내기",
            "Completed At": "완료일시",
            "PROCESSING": "진행중",
            "search options": "검색 옵션",
            "Export": "내보내기",
            "Asset creation period": "에셋 생성 기간",
            "COMPLETED": "완료",
            "Created At": "생성일시",
            "Updated At": "수정일시",
            "Project count": "프로젝트 갯수",
            "Additional items": "추가항목",
            "Make": "만들기",
            "Export metadata": "메타데이터 내보내기",
            "Selected projects": "선택된 프로젝트",
            "Asset creation date": "에셋 생성일",
            "metadata export": "메타데이터 내보내기",
            "Directly assigned": "직접 할당됨",
            "Create Collection": "콜렉션 생성",
            "Select scope": "스콥 선택",
            "METADATA_DOWNLOAD": "메타데이터 다운로드",
            "Metadata download": "메타데이터 다운로드",
            "Vocabulary": "단어",
            "Assets Name": "자산 이름",
            "Assets ID": "자산 아이디",
            "Preview Settings": "미리보기 설정",
            "Assets to share": "공유할 자산",
            "Collections to share": "공유할 컬렉션",
            "Folder to share": "공유할 폴더",
            "Archive assets": "자산 아카이브",
            "COLLECTION_DOWNLOAD": "컬렉션 다운로드",
            "collection download": "컬렉션 다운로드",
            "Event occurrence date and time": "이벤트 발생 일시",
            "Domain": "도메인",
            "Admin Audit Logs": "관리 감사 로그",
            "Audit log details": "감사 로그 상세",
            "User Agent": "사용자 에이전트",
            "Select domain": "도메인 선택",
            "Select action": "동작 선택",
            "Select requestedBy": "사용자 선택",
            "Publishing options": "게시 옵션",
            "Player ControlBar Control": "플레이어 컨트롤바",
            "Start the Player Fullscreen": "전체 화면 플레이어로 시작",
            "Continue after Stopping the Player": "플레이어를 멈춘 후 다시 시작",
            "Video Download": "비디오 다운로드",
            "Embed code options": "임베드 코드 옵션",
            "Player Width": "플레이어 넓이",
            "Auto Play": "자동 재생",
            "Loop Play": "반복 재생",
            "Play directly with the player within the web page": "웹 페이지 내에서 플레이어 그대로 재생",
            "Copied": "복사됨",
            "Open in new window": "새 창으로 열기",
            "Add Vocabulary Book": "단어장 추가",
            "Vocabulary Book ID": "단어장 ID",
            "Shrink": "축소",
            "Example": "예시",
            "1024px or 100%": "1024px 혹은 100%",
            "Publishing": "게시중",
            "Reclaiming": "회수중",
            "Published": "게시됨",
            "Unpublished": "해제됨",
            "Enter ResourceId": "리소스 ID 입력",
            "Enter ThreadResourceId": "리소스 ID 입력",
            "Select projects": "프로젝트 선택",
            "ResourceId": "리소스 ID",
            "ThreadResourceId": "리소스 ID",
            "Select user": "사용자 선택",
            "Report collection period": "리포트 수집 기간",
            "Whether to send mail": "메일 발송 여부",
            "SEND": "발송",
            "NOT SEND": "미발송",
            "Targets and actions": "대상 및 동작",
            "Email recipients": "메일 수신 대상자",
            "Sending cycle": "발송 주기",
            "REPORT_Create": "생성",
            "REPORT_Delete": "삭제",
            "Reports": "리포트",
            "{{value}} people": "{{value}} 명",
            "Total asset count": "전체 총 자산 수",
            "Total asset size": "전체 총 자산 사용량",
            "{{period}} {{condition}} tasks": "{{period}} 내 {{condition}} 작업 수",
            "A week ago": "전주와 비교",
            "tasks": "작업",
            "{{period}} total": "{{period}} 내 총 합",
            "Top <emp>10</emp> projects by {{period}} tasks": "{{period}} 내 작업 수 Top <emp>10</emp> 프로젝트",
            "Table": "테이블",
            "Chart": "차트",
            "{{period}} task count": "{{period}} 내 작업 수",
            "{{hour}}:{{minute}} {{period}}": "{{period}} {{hour}}:{{minute}}",
            "AM": "오전",
            "PM": "오후",
            "Pipeline during video creation": "비디오 생성시 파이프라인",
            "Resource ID": "리소스 아이디",
            "Video editing": "영상 편집",
            "Video image capture": "영상 이미지 캡쳐",
            "Pan": "팬",
            "Zoom": "줌",
            "Cut": "자르기",
            "Pull start marker": "시작 마커 당기기",
            "Pull end marker": "종료 마커 당기기",
            "Video name": "비디오 이름",
            "Create a video": "비디오로 생성하기",
            "Create an edited video": "편집된 비디오 만들기",
            "Edit and save images": "이미지 편집 및 저장",
            "Save as asset": "자산으로 저장하기",
            "Current video time": "현재 영상 시간",
            "Aspect custom": "사용자 지정",
            "Scale": "스케일",
            "Coordinate": "좌표",
            "Incision": "자르기",
            "frame {{id}}": "{{id}} 프레임",
            "Image size": "이미지 사이즈",
            "Folder location": "폴더 위치",
            "Get instant download": "즉시 다운로드 받기",
            "Auto-archive status": "자동 아카이브 상태",
            "Auto-archive enabled": "자동 아카이브 적용중",
            "Auto-archive schedule date": "자동 아카이브 예정일",
            "Date to automatically retain assets after creation or restoration": "자산 생성 또는 복원된 후 자동 보관할 날짜",
            "Prefix before asset name": "자산 이름 앞 접두사",
            "days later": "일 후",
            "or more": "이상",
            "days left": "일 남음",
            "Select content in a specific folder?": "특정 폴더에서 컨텐츠를 선택하시겠습니까?",
            "Failure reason": "실패 사유",
            "Unsupported reason": "미지원 사유",
            "Field description": "필드 설명",
            "Field default value": "필드 기본 값",
            "Enter field link": "링크를 입력하세요.",
            "Add link": "링크 추가하기",
            "Add group": "그룹 추가",
            "Enter your name": "이름을 입력해주세요.",
            "Preparing to share": "공유 준비중",
            "Send again": "다시 보내기 ",
            "Cancel invitation": "초대 취소",
            "Total file size": "전체 총 파일 사용량",
            "Total Usage": "사용량",
            "Project Settings > Settings > Menu (e.g. Assets) > Category Groups": "프로젝트 설정 > 설정 > 메뉴 (예 : 자산) > 카테고리 그룹",
            "Setting location": "설정 위치",
            "Category group settings": "카테고리 그룹 설정",
            "Please select a custom metadata preset.": "커스텀 메타데이터 프리셋을 선택해주세요.",
            "Load custom metadata schema": "커스텀 메타데이터 스키마 불러오기",
            "Load Metadata": "메타데이터 불러오기",
            "PROJECT_RESOURCES_DOWNLOAD": "프로젝트 리소스 다운로드",
            "Project resources download": "프로젝트 리소스 다운로드",
            "Statistics period": "수집기간",
            "Weekly change": "전주와 비교",
            "Weekly Asset Count": "주간 에셋 업데이트",
            "Weekly File Size": "주간 파일 사용량",
            "Asset count": "에셋 갯수",
            "Comment Room Option": "댓글방 옵션 기능",
            "Project Comment": "프로젝트 댓글",
            "preview image": "미리보기 이미지",
            "Activity History": "활동 내역",
            "Activity": "활동",
            "Select location": "위치 선택",
            "item selected": "개 선택됨",
            "Include subfolders": "하위 폴더 포함",
            "Thumbnail": "썸네일",
            "Maintain image proportions": "이미지 비율 유지하기",
            "Crop": "크롭하기",
            "Create asset": "자산 생성",
            "Menu": "메뉴",
            "Cusom settings": "사용자 정의",
            "Submenu": "하위메뉴",
            "Add menu": "메뉴 추가",
            "Add submenu": "하위메뉴 추가",
            "Library": "라이브러리",
            "Menu item settings": "메뉴 항목 설정",
            "Menu name": "메뉴 이름",
            "Add assets from folder": "폴더의 자산 추가",
            "Downloads": "다운로드",
            "Select menu": "메뉴 선택",
            "Default settings": "기본 설정",
            "Custom settings": "사용자 정의",
            "First entry screen": "첫 진입 화면",
            "First entry screen(Create page)": "첫 진입 화면(생성 화면)",
            "Edit menu": "편집",
            "Shared At": "공유일",
            "VIDEO": "비디오",
            "AUDIO": "오디오",
            "PEOPLE": "피플",
            "TEXT": "텍스트",
            "FILE": "파일",
            "Select media type": "미디어 유형 선택",
            "Widget Preference": "위젯 설정",
            "LastName/FirstName": "성/이름",
            "Site access permission": "사이트 접근 권한",
            "Person in charge": "담당자",
            "Request date": "요청 날짜",
            "Request I made": "내가 한 요청",
            "Request received": "받은 요청",
            "Inquiry history": "문의 내역",
            "In Review": "검토 중",
            "Respond": "처리 완료",
            "Attachment": "첨부파일",
            "Request download": "다운로드 요청",
            "Setting download permissions": "다운로드 권한 설정",
            "Unlimited": "무제한",
            "Unstarred": "별표 제거",
            "Selected Categories": "선택된 카테고리",
            "Select requester": "요청자 선택",
            "Select person in charge": "담당자 선택",
            "Common": "일반",
            "Download permission": "다운로드 권한",
            "Not assigned": "할당되지 않음",
            "Attached file": "첨부된 파일",
            "Shared users": "공유된 사용자",
            "Shared management": "공유 관리",
            "Share expiration date": "공유 만료일",
            "Number of downloads remaining": "다운로드 남은 횟수",
            "Share date": "공유일",
            "Asset Create": "자산 생성",
            "Asset Archive": "자산 아카이브",
            "COMMENT_ATTACHMENT_DOWNLOAD": "댓글 첨부파일 다운로드",
            "Metadata Download": "메타데이터 다운로드",
            "Comment Attachment Download": "댓글 첨부파일 다운로드",
            "Asset Download": "자산 다운로드",
            "Storage Download": "저장소 다운로드",
            "Collection Download": "컬렉션 다운로드",
            "My Jobs": "내 작업",
            "Requests": "요청",
            "Upload from My PC": "내 PC에서 업로드",
            "Upload from cloud": "클라우드에서 업로드",
            "To Start Page": "시작 페이지로 이동",
            "Go to previous page": "이전 페이지로 이동",
            "Go to first page": "첫 페이지로 이동",
            "Go to next page": "다음 페이지로 이동",
            "Go to last page": "마지막 페이지로 이동",
            "Go to page {{page}}": "{{page}} 페이지로 이동",
            "Go to start-ellipsis page": "이전 페이지 묶음으로 이동",
            "Go to end-ellipsis page": "다음 페이지 묶음으로 이동",
            "Open": "열기",
            "REQUEST_ATTACHMENT_DOWNLOAD": "요청 첨부파일 다운로드",
            "Request Attachment Download": "요청 첨부파일 다운로드",
            "Partial": "부분",
            "Request attachment download": "요청 첨부파일 다운로드",
            "Reverse sort direction": "역방향 정렬",
            "Selected Attachment": "첨부된 파일",
            "No Channel Categories": "채널 카테고리 없음",
            "Search Engine": "검색 엔진",
            "Create caption asset": "캡션 자산 생성",
            "Create video asset": "비디오 자산 생성",
            "Create audio asset": "오디오 자산 생성",
            "Create image asset": "이미지 자산 생성",
            "Create file asset": "파일 자산 생성",
            "Caption asset": "캡션 자산",
            "Video asset": "비디오 자산",
            "Audio asset": "오디오 자산",
            "Image asset": "이미지 자산",
            "File asset": "파일 자산",
            "Caption kind": "캡션 종류",
            "Caption language": "캡션 언어",
            "Create Event Triggers": "이벤트 트리거 생성",
            "Task": "작업",
            "TRIGGER": "트리거",
            "CHOICE": "선택",
            "TASK": "작업",
            "Input Path": "입력 경로",
            "Options": "옵션",
            "Enter key": "키를 입력하세요",
            "Enter value": "값을 입력하세요",
            "Auto Language ({{n}}/max. {{max}})": "자동 언어 ({{n}}/max. {{max}})",
            "Add Task": "작업 추가",
            "Keep original folder structure": "원본 폴더 경로 유지",
            "AI Analysis Settings": "AI 분석 설정",
            "Transcribe": "트랜스크라이브",
            "STT": "STT",
            "Video annotation": "비디오 주석",
            "OCR": "OCR",
            "Vocabulary book": "단어장",
            "Speaker classification": "화자 분류",
            "Asset creation options": "에셋 생성 옵션",
            "Create per file": "파일별 생성",
            "Create as a batch": "묶어서 생성",
            "Create collection": "콜렉션 생성",
            "Invited user": "초대된 사용자",
            "Space admin permission": "Space 관리자 권한",
            "Grant space admin": "Space 관리자 권한",
            "Please search by name": "이름으로 검색하세요",
            "Grant site access": "사이트 액세스",
            "Admin permission": "관리자 권한",
            "Select admin": "권한을 선택하세요",
            "Grant project admin": "Project 관리자 권한",
            "Bucket Settings": "버킷 설정",
            "Essential": "필수",
            "AWS Account Connection": "AWS 계정 연결",
            "Create Project": "프로젝트 생성",
            "Use Service Account": "서비스 계정 사용",
            "Connect External Account": "타계정 연결",
            "Region Settings": "지역 설정",
            "AWS Account Connection Guide": "AWS 계정 연결 가이드",
            "Create IAM Permission": "IAM Permission 생성",
            "Copy code": "코드 복사",
            "Create IAM Role": "IAM Role 생성",
            "View Connection Guide": "연결 가이드 보기",
            "Group Access Management": "그룹 엑세스 관리",
            "User Access Management": "사용자 엑세스 관리",
            "Change Owner": "소유자 변경",
            "Change": "변경하기",
            "Not locked": "안잠김",
            "Locked state": "잠김 상태",
            "Region": "지역",
            "AWS account connection": "AWS 계정 연결",
            "Retrieving analysis results...": "분석 결과를 가져오는 중...",
            "AI Auto Tagging": "AI 자동 태깅",
            "Use": "사용",
            "Don't Use": "사용 안 함",
            "Min. Confidence": "최소 신뢰도",
            "API Key": "API 키",
            "Summary": "개요",
            "Usage Dashboard": "사용량 대시보드",
            "Unique accessed users": "유니크 접속자 수",
            "Transcoding jobs": "트랜스코딩 작업",
            "Total assets": "총 자산 수",
            "Metadata registration rate": "메타데이터 등록률",
            "AI jobs": "AI 작업 수",
            "A month ago": "전월 대비",
            "Usage Trend": "월간 사용량 트렌드",
            "Asset count and storage usage by {{target}}": "{{target}} 별 자산 수 및 스토리지 사용량",
            "AI jobs by service type": "AI 작업 유형별 분포",
            "AI jobs by engine": "엔진 별 분포",
            "Assets by media type": "자산 타입별 분포",
            "Daily asset creation count": "일간 자산 생성 수",
            "All customers": "모든 고객사",
            "Segment detection": "구간 감지",
            "Text detection": "텍스트 감지",
            "Translate": "번역",
            "File size": "스토리지",
            "{{target}} detail data": "{{target}} 상세 데이터",
            "Customer name": "고객사 명",
            "Grant role": "역할 할당",
            "Loading Data...": "데이터를 불러오는 중...",
            "MimeType": "마임 유형",
            "Inviter": "초대자",
            "Mark as read": "읽음으로 표시",
            "Mark as unread": "읽지 않음으로 표시",
            "Mark all as read": "모두 읽음으로 표시",
            "Notifications": "알림",
            "Show only unread items": "읽지 않은 항목만 표시",
            "Subtitle generation basic settings": "자막생성 기본설정",
            "Auto-delete input bucket": "인풋 버킷 자동삭제",
            "Try again": "다시 시도",
            "Ask a new question": "새 질문하기",
            "New Task": "새 작업",
            "Tasks": "작업",
            "Go Back": "돌아가기",
            "Create Shortform": "숏폼 생성",
            "AI WorkSpace Preset": "AI WorkSpace 프리셋",
            "Active presets": "활성화된 프리셋",
            "Creation location": "생성 위치",
            "Create Prompt Presets": "프롬프트 프리셋 생성",
            "Prompt": "프롬프트",
            "Response format": "응답 형태",
            "Timeline for editing": "편집용 타임라인",
            "AI Workspace": "AI Workspace",
            "Unsupported video file format": "지원되지 않는 비디오 파일 형식",
            "Name ascending order": "이름 오름차순",
            "Name descending order": "이름 내림차순",
            "Expiration date": "만료일",
            "View": "보기",
            "Save Tags": "태그 저장",
            "Deleted after {{day}} day(s)": "{{day}}일 뒤 삭제",
            "Single type": "단일형",
            "Chat type": "대화형",
            "Save description immediately": "설명 바로 저장하기",
            "Save Description": "설명 저장",
            "Start ingest": "인제스트 시작",
            "End ingest": "인제스트 종료",
            "Start transcoding": "트랜스코딩 시작",
            "End transcoding": "트랜스코딩 종료",
            "Copy description": "복사하기",
            "Whether transcoded assets are exposed": "트랜스코딩된 자산 노출 여부",
            "Create original quality video only": "원본 화질 영상만 생성",
            "Automatically activated": "자동으로 활성",
            "Publish to YouTube": "Youtube 게시",
            "Create and manage video URL": "비디오 URL 생성 및 관리",
            "Published channels": "게시된 채널",
            "Delete URL": "URL 삭제",
            "Create URL": "URL 생성",
            "You can create a URL for video sharing.": "비디오 공유용 URL을 생성할 수 있습니다.",
            "Creating video URL": "비디오 URL을 생성하고 있습니다",
            "MODAL_Publishing": "퍼블리싱",
            "Archived ID": "아카이브 ID",
            "Selected": "선택됨",
            "audit logs": "감사 로그",
            "Select description": "동작 선택",
            "List View Settings": "목록 보기 설정",
            "User Preference Widget": "사용자 설정 위젯",
            "User Group Preference Widget": "팀 설정 위젯",
            "Project Preference Widget": "프로젝트 설정 위젯",
            "Entire Period": "전체 기간",
            "This Week": "이번주",
            "This Month": "이번달",
            "This Year": "올해",
            "Last 15 Minutes": "지난 15분",
            "Last 30 Minutes": "지난 30분",
            "Last 1 Hour": "지난 1시간",
            "Last 4 Hours": "지난 4시간",
            "Apply with Project Settings": "프로젝트 설정으로 적용",
            "Line Chart": "선 그래프",
            "Bar Chart": "바 그래프",
            "Notice": "유의사항",
            "Cancel Update": "업데이트 취소",
            "Widget Type": "위젯 형태",
            "Wide Type": "와이드 형",
            "Default Dashboard Exposure": "대시보드에 기본 노출",
            "Widget Exposure Settings": "위젯 노출 설정",
            "Not Entered": "미입력 상태",
            "Show Search Options": "검색옵션 표시",
            "Project Settings > Settings > Menu (e.g. Asset) > Category Group": "프로젝트 설정 > 설정 > 메뉴 (예 : 자산) > 카테고리 그룹",
            "Category Group": "카테고리 그룹",
            "Asset name 1": "자산 이름 1",
            "Empty notifications": "빈 알림",
            "Unread only": "읽지 않은 알림만",
            "Read only": "읽은 알림만",
            "Mixed read/unread": "읽은/읽지 않은 혼합",
            "All comment types mixed": "모든 댓글 유형 혼합",
            "All domains mixed": "모든 도메인 혼합",
            "All asset media types mixed": "모든 자산 미디어 타입 혼합",
            "Turn off test mode": "테스트 모드 끄기",
            "Turn on test mode": "테스트 모드 켜기",
            "Select a preset": "프리셋을 선택하세요",
            "Recommended": "추천",
            "More": "그 외",
            "Hide Presets": "프리셋 숨기기",
            "See More Presets": "프리셋 더보기",
            "Duplicate {{name}}": "{{name}} 복제",
            "Schedule ID": "스케쥴 ID",
            "Enter Owner": "소유자 입력",
            "Add": "추가",
            "Search all Assets": "모든 자산 검색",
            "Add Content Schema": "콘텐츠 스키마 추가",
            "Add {{schemaName}}": "{{schemaName}} 추가",
            "Enter Sounds Like": "발음과 비슷한 언어를 입력하세요",
            "There are no analysis results for {{name}}.": "{{name}}에 대한 분석 결과가 없습니다.",
            "Change menu name": "메뉴 이름 변경",
            "Delete group": "그룹 삭제",
            "Recent Assets Shared to Me": "최근 공유된 자산",
            "Users and groups belonging to the project for the selected asset are excluded from sharing.": "선택한 자산의 프로젝트에 속한 사용자 및 그룹은 공유에서 제외됩니다.",
            "All Buckets": "모든 버킷",
            "CPA_ARCHIVED": "아카이브 됨",
            "CPA_ARCHIVING": "아카이브 중",
            "CPA_RESTORING": "복원 중",
            "CPA_ERROR": "오류",
            "View all Projects": "모든 프로젝트 보기",
            "Selected {{referenceType}}": "선택한 {{referenceType}}",
            "REMOVE": "제거",
            "Name setting": "이름 설정",
            "Automatic storage date after asset creation": "자산 생성 후 자동 저장 날짜",
            "role_Copy": "복사",
            "customer": "고객",
            "project": "프로젝트",
            "Recoding": "레코딩",
            "Unable to use AI-Workspace": "AI-Workspace 사용 불가",
            "Read Only": "읽기 전용",
            "Switch": "전환하기",
            "Switching": "전환 중",
            "S3_OBJECT_CREATED": "파일이 업로드되면",
            "ASSET_CREATED": "자산이 생성되면",
            "FILTER_BY_FILE_EXTENSION": "파일 확장자로 필터",
            "FILTER_BY_FILE_SIZE": "파일 용량으로 필터",
            "FILTER_BY_ASSET_MEDIA_TYPE": "자산을 미디어 타입으로 필터",
            "FILTER_BY_ASSET_SIZE": "자산을 용량으로 필터",
            "ATTACH_ASSET_METADATA": "메타데이터 연결",
            "CREATE_ASSET": "에셋 생성",
            "CREATE_VIDEO": "비디오 생성",
            "SUBMIT_AI_WORKSPACE_SINGLE_TYPE_JOB": "AI 워크스페이스 작업 제출",
            "ARCHIVE_ASSET": "자산 아카이브",
            "PUBLISH_VIDEO": "비디오 퍼블리시",
            "File URL": "파일 URL",
            "File Extension": "파일 확장자",
            "File Size": "파일 용량",
            "Asset Media Type": "자산 미디어 타입",
            "Asset Size": "자산 용량",
            "Condition": "조건",
            "Flow Edit": "플로우 편집",
            "Flow Details": "플로우 상세",
            "Auto": "자동",
            "Manual": "수동",
            "Select a step": "스텝 선택",
            "clippings": "클리핑",
            "accountId": "계정 ID",
            "AiWorkspaceJob SingleTypeJob Output": "AI 워크스페이스 작업 결과",
            "AI Mode": "AI 모드",
            "AI Mode OFF": "AI 모드 OFF",
            "Ask anything": "무엇이든 물어보세요",
            "Hi, this is AI search mode": "AI 검색 모드입니다",
            "Describe a scene or feature in the video you are looking for!": "찾으시는 영상 속 상황이나 특징을 설명해 보세요!",
            "AI Search Preset Recently modified videos": "최근에 수정한 영상",
            "AI Search Preset Golden sunset on the beach": "해변의 황금빛 노을",
            "AI Search Preset People in a meeting at the office": "사무실에서 회의하는 사람들",
            "AI Search Preset Cinematic mood videos": "시네마틱한 분위기의 영상",
            "AI Search Preset City night view by drone": "드론으로 촬영한 도시 야경",
            "AI Search Preset Children smiling brightly": "환하게 웃는 아이들",
            "View indexing status": "인덱싱 상태 보기",
            "AI Analysis Plan and Usage": "AI 분석 요금제 및 사용량",
            "Ai-billing": "AI 분석 요금제 및 사용량",
            "Current subscription": "현재 구독",
            "No active subscription": "활성 구독 없음",
            "Concurrent sessions": "동시 세션",
            "Fees and usage": "사용료 및 사용량",
            "Fees": "사용료",
            "Usage": "사용량",
            "Aggregating": "집계 중",
            "Settled": "정산 완료",
            "Total so far": "현재까지 합계",
            "Settled total": "정산 합계",
            "Period subtotal": "구간 소계",
            "Cumulative usage": "누적 사용량",
            "Year option {{year}}": "{{year}}년",
            "Month option {{month}}": "{{month}}월",
            "Pay-as-you-go": "사용량 과금",
            "No change": "변동 없음",
            "vs. last month": "전월 대비",
            "min": "분",
            "AI applied": "AI 적용",
            "Apply all": "전체 적용",
            "Cancel setting": "설정 취소",
            "Custom metadata": "커스텀 메타데이터",
            "Differs from preset schema": "프리셋 스키마와 다름",
            "Not extracted": "추출 안됨",
            "Replace": "교체",
            "Replace with preset schema": "프리셋 스키마로 교체",
            "Revert to existing schema": "기존 스키마로 되돌리기",
            "Same as preset schema": "프리셋 스키마와 같음",
            "Save custom metadata directly": "커스텀 메타데이터 바로 저장",
            "Set preset schema": "프리셋 스키마로 설정",
            "Save metadata": "메타데이터 저장",
            "Add publish": "게시 추가",
            "Back to manage": "관리로",
            "Copy public URL": "공개 URL 복사",
            "Last published": "마지막 게시",
            "Manage public URL": "공개 URL 관리",
            "Open public URL": "공개 URL 열기",
            "Open URL": "URL 열기",
            "Publish ({{count}})": "게시 ({{count}})",
            "Publish and manage public URL": "공개 URL 게시 및 관리",
            "Publish public URL": "공개 URL 게시",
            "Publish target": "게시 대상",
            "Unpublish": "게시 해제",
            "Unpublish ({{count}})": "게시 해제 ({{count}})",
            "{{count}} files": "{{count}}개 파일",
            "English (en-US)": "영어 (en-US)",
            "Korean (ko-KR)": "한국어 (ko-KR)",
            "Related Videos": "관련 영상",
            "and <emp>{{count}}</emp> others' shared": "외 <emp>{{count}}</emp>개 공유됨",
            "(<emp>{{count}}</emp> days left)": "(<emp>{{count}}</emp>일 남음)",
            "Info": "정보",
            "Filter": "필터",
            "Create Highlights": "하이라이트 생성",
            "Create Description": "설명 생성",
            "Remove all Shares": "모든 공유 해제",
            "Create date": "생성일",
            "Complete date": "완료일",
            "Start Failure": "시작 실패",
            "Recording Started": "녹화가 시작되었습니다",
            "Upload Cancel": "업로드 취소",
            "Select Content in a specific folder?": "특정 폴더의 콘텐츠를 선택하시겠습니까?",
            "Template preview": "템플릿 미리보기",
            "Terms and Conditions": "이용약관",
            "toggle password visibility": "비밀번호 표시 전환",
            "{{type}} Asset Name": "{{type}} 에셋 이름",
            "Enter {{type}} Asset Name": "{{type}} 에셋 이름 입력",
            "' shared": "' 공유됨",
            "Minimap": "미니맵",
            "Go back": "돌아가기",
            "Use service account": "서비스 계정 사용",
            "{{names}} and {{restCount}} more": "{{names}} 외 {{restCount}}개",
            "Proxy video": "프록시 영상",
            "Proxy video status": "프록시 추출 상태",
            "Auto generate proxy video": "프록시 영상 자동 생성",
            "Proxy video ready": "프록시 준비됨",
            "Extracting proxy video": "프록시 추출 중",
            "Proxy extraction failed": "프록시 추출 실패",
            "Best match": "가장 잘 맞는 결과",
            "AI Search": "AI 검색",
            "{{count}} errors": "오류 {{count}}",
            "View by country and referrer": "국가·유입 도메인 보기",
            "Countries (this URL)": "국가 (이 URL 기준)",
            "Referring domains (this URL)": "유입 도메인 (이 URL 기준)",
            "persons": "명",
            "and {{count}} more": "외 {{count}}개",
            "All URLs": "전체 URL",
            "All unpublished": "전부 해제",
            "View all URLs": "전체 URL 보기",
            "Search URL": "URL 검색",
            "Share of total": "비중",
            "Country": "국가",
            "CF address": "CF 주소"
        },
        "msg": {
            "How many times the asset was opened through its public URL. Downloads and on-screen views are counted together, and for video, starting playback counts as one - watching to the end is not measured. If there is no access for 30 minutes after the first view, the next view is counted separately.": "공개 URL 로 자산이 열린 횟수입니다. 내려받은 것과 화면에서 본 것을 함께 세고, 영상은 재생을 시작하면 1회이고 끝까지 봤는지는 세지 않습니다. 첫 조회 후 30분간 접근이 없다가 다시 조회되면 2회로 셉니다.",
            "Total data sent out through this asset's public URLs. Opening the same file again adds to it.": "이 자산이 공개 URL 로 내보낸 데이터 총량입니다. 같은 파일을 다시 열면 그만큼 늘어납니다.",
            "An estimate, not a headcount. Several people in one company may count as one, and one person switching devices may count as several.": "사람 수가 아니라 추정치입니다. 같은 회사에서 여러 명이 보면 하나로, 한 사람이 기기를 옮기면 여럿으로 셉니다.",
            "The site the visitor came from right before opening this URL. Whether the asset was actually embedded in that page or reached by a link is not distinguished. Entries with no value are grouped as Unknown.": "이 URL 을 열기 직전에 있던 사이트입니다. 실제로 그 페이지에 삽입된 것인지, 링크를 눌러 온 것인지는 구분되지 않습니다. 값이 없는 것은 「알 수 없음」으로 묶습니다.",
            "Could not load statistics": "통계를 불러오지 못했습니다.",
            "Could not update. Showing the previous result.": "업데이트하지 못했습니다. 이전 결과를 보고 있습니다.",
            "Data is aggregated hourly, not in real time.": "실시간이 아닌 1시간마다 데이터가 집계됩니다.",
            "Aggregated hourly, so the most recent views may not be here yet. Do not decide whether a URL is still in use from this column alone.": "1시간마다 집계되어 가장 최근 조회는 아직 없을 수 있습니다. 이 열만 보고 URL 을 계속 쓰는지 판단하지 마세요.",
            "The country the viewer was in.": "시청자가 위치한 국가입니다.",
            "CDN logs are not real-time, so today and yesterday are still filling in. Downloads and on-screen views are counted together, and referring domains do not distinguish embedded pages from link clicks.": "CDN 로그는 실시간이 아니라 오늘·어제 수치는 아직 채워지는 중입니다. 내려받은 것과 화면에서 본 것은 함께 세며, 유입 도메인은 페이지에 삽입된 것인지 링크를 눌러 온 것인지 구분하지 않습니다.",
            "Please try again in a moment.": "잠시 후 다시 시도해 주세요.",
            "No views recorded yet": "아직 집계된 조회가 없습니다.",
            "Views appear here once someone opens the asset through its public URL.": "누군가 공개 URL 로 자산을 열면 여기에 표시됩니다.",
            "Add request headers such as an authorization token if needed.": "인증 토큰 등 요청에 포함할 헤더가 필요하면 추가하세요.",
            "Only letters, numbers, and hyphens are allowed.": "영문·숫자·하이픈만 사용할 수 있습니다.",
            "This header cannot be used.": "사용할 수 없는 헤더입니다.",
            "Line breaks are not allowed.": "줄바꿈은 사용할 수 없습니다.",
            "Headers can be up to {{maxLength}} characters in total. (currently {{length}})": "헤더는 전체 {{maxLength}}자까지 입력할 수 있습니다. (현재 {{length}}자)",
            "The URL is too long.": "URL이 너무 깁니다.",
            "Internal addresses (private, loopback, or link-local) cannot be used.": "내부 주소(사설·루프백·링크로컬)는 사용할 수 없습니다.",
            "\"{{name}}\" will be deleted forever and you won't be able to restore it.": "\"{{name}}\" 은(는) 완전히 삭제되며 복구할 수 없습니다.",
            "The webhook has been activated.": "웹훅이 활성화되었습니다.",
            "The webhook has been deactivated. Events will no longer be sent.": "웹훅이 비활성화되었습니다. 트리거가 발생해도 전송되지 않습니다.",
            "A webhook sends asset event data to an external endpoint whenever a selected trigger occurs.": "웹훅은 선택한 트리거가 발생할 때마다 외부 엔드포인트로 자산 이벤트 데이터를 전송합니다.",
            "Deliveries appear here once a selected trigger occurs.": "선택한 트리거가 발생하면 전송 이력이 여기에 표시됩니다.",
            "Are you sure you want to delete this webhook?": "이 웹훅을 삭제하시겠습니까?",
            "HTTP method is fixed to POST and cannot be changed.": "HTTP 메서드는 POST로 고정되어 변경할 수 없습니다.",
            "https://example.com/webhooks": "https://example.com/webhooks",
            "Key is required.": "키는 필수입니다.",
            "Key must be unique.": "키는 고유해야 합니다.",
            "Please enter a valid URL.": "올바른 URL을 입력하세요.",
            "Please select at least one trigger.": "트리거를 하나 이상 선택하세요.",
            "Select a trigger to preview the request body.": "요청 본문을 미리 보려면 트리거를 선택하세요.",
            "The request body is determined automatically by the system based on the trigger and cannot be edited.": "요청 본문은 트리거에 따라 시스템이 자동으로 결정하며 수정할 수 없습니다.",
            "We recommend using https.": "https 사용을 권장합니다.",
            "'{{item}}' has been added.": "'{{item}}'이(가) 추가되었습니다.",
            "'{{name}}' AI analysis has begun.": "'{{name}}'의 AI 분석이 시작되었습니다.",
            "'{{name}}' has been added.": "'{{name}}'이(가) 추가되었습니다.",
            "AI Caption task failed.": "AI 캡션 작업이 실패했습니다.",
            "Access has Expired": "액세스가 만료되었습니다",
            "An error has occurred": "오류가 발생했습니다",
            "An error occured while changing Custom Metadata {type}": "커스텀 메타데이터 {type} 변경 중 오류가 발생했습니다",
            "An error occured while changing collection name": "컬렉션 이름 변경 중 오류가 발생했습니다",
            "An error occured while changing collection {{type}}": "컬렉션 {{type}} 변경 중 오류가 발생했습니다",
            "An error occured while changing custom content {{type}}": "커스텀 콘텐츠 {{type}} 변경 중 오류가 발생했습니다",
            "An organizer can be selected.": "주최자를 선택할 수 있습니다.",
            "Assets must only be in DRM-free MP4 video type.": "자산은 DRM-free MP4 비디오 형식만 가능합니다.",
            "Collection '{{name}}' has been created.": "컬렉션 '{{name}}'이(가) 생성되었습니다.",
            "Content schema '{{name}}' has been duplicated.": "콘텐츠 스키마 '{{name}}'이(가) 복제되었습니다.",
            "Creating video URL.": "비디오 URL을 생성하고 있습니다.",
            "Creation of new Metadata Export {{item}} is completed.": "새 메타데이터 내보내기 {{item}} 생성이 완료되었습니다.",
            "Detach {{name}}": "{{name}} 해제",
            "Download request failed": "다운로드 요청에 실패했습니다",
            "Enter your name": "이름을 입력해주세요.",
            "Error adding collection '{{name}}'. {{line}} Please refresh the page and try again.": "컬렉션 '{{name}}'을(를) 추가하는 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Expired date :": "만료일 :",
            "Face collection is not registered. Please contact to admin.": "얼굴 컬렉션이 등록되지 않았습니다. 관리자에게 문의하세요.",
            "Failed to configure AI analysis trigger.": "AI 분석 트리거 설정에 실패했습니다.",
            "Failed to move.": "이동에 실패했습니다.",
            "File is empty.": "파일이 비어 있습니다.",
            "Group '{{name}}' has been added.": "그룹 '{{name}}'이(가) 추가되었습니다.",
            "I agree to the above terms and conditions": "위 약관에 동의합니다",
            "If you apply a different category group, those items can be found under ‘<NotClassified>Categories Not Classified into Assets</NotClassified>’ in the category view.": "다른 카테고리 그룹을 적용할 경우, 해당 아이템들은 카테고리 보기의 ‘<NotClassified>자산에 분류되지 않은 카테고리</NotClassified>’에서 확인할 수 있습니다.",
            "If you delete <0>{{name}}</0>,  will also be removed from reference and you won't be able to revert this.<1/>Are you sure you want to delete?": "<0>{{name}}</0>을(를) 삭제할 경우, 참조에서도 제거되며 되돌릴 수 없습니다.<1/>정말 삭제하시겠습니까?",
            "If you delete <0>{{name}}</0>, you won't be able to revert this.<1/>Are you sure you want to delete?": "<0>{{name}}</0>을(를) 삭제하면 되돌릴 수 없습니다.<1/>정말 삭제하시겠습니까?",
            "If you have issues with Space approval, please contact Megazone Cloud. ": "Space 승인에 문제가 있는 경우 Megazone Cloud에 문의하십시오. ",
            "Korean can not contain numbers.": "한글에는 숫자를 포함할 수 없습니다.",
            "Please enter title": "제목을 입력하세요",
            "Please search by collection name": "컬렉션 이름으로 검색해주세요",
            "Please uncheck the items you wish to leave and try to delete them.": "남길 항목의 선택을 해제한 후 삭제해 주세요.",
            "Saving of changes to '{{tab}}' failed. - {{error}}": "'{{tab}}'의 변경 사항 저장에 실패했습니다. - {{error}}",
            "Shortform creation has been requested.": "숏폼 생성이 요청되었습니다.",
            "Since this is a category group that is not used in {{name}}s, you can check the created {{name}} in 'categories not classified in {{name}}s'.": "{{name}}에서 사용하지 않는 카테고리 그룹이므로, 생성된 {{name}}은(는) '{{name}}에 분류되지 않은 카테고리'에서 확인할 수 있습니다.",
            "The Key field be up to {{tag}} characters long.": "키 필드는 최대 {{tag}}자입니다.",
            "The Lineup Name field be up to {{name}} characters long.": "라인업 이름 필드는 최대 {{name}}자입니다.",
            "The Value field be up to {{tag}} characters long.": "값 필드는 최대 {{tag}}자입니다.",
            "The caption of the program can be edited in the caption of the <0> {{number}} </0> ": "프로그램의 캡션은 <0> {{number}} </0> 캡션에서 편집할 수 있습니다. ",
            "The language of the captions to be applied to the video must not be duplicated.": "비디오에 적용할 캡션의 언어는 중복될 수 없습니다.",
            "There is already a {{target}} with the same email. Please change it to a different email.": "같은 이메일의 {{target}}이(가) 이미 있습니다. 다른 이메일로 변경해 주세요.",
            "There is no Organizers to select.": "선택할 주최자가 없습니다.",
            "There is no file to retry.": "재시도할 파일이 없습니다.",
            "There was an error sharing asset {{item}}": "{{item}} 에셋을 공유하는 중에 오류가 발생했습니다",
            "This field can be at least {{minByte}} bytes.": "이 필드는 최소 {{minByte}}바이트여야 합니다.",
            "This field can be at least {{minLength}} characters.": "이 필드는 최소 {{minLength}}자여야 합니다.",
            "This field must be in email address format.": "이 필드는 이메일 주소 형식이어야 합니다.",
            "This listings has updated information.<0/>Please refresh and try again. Do you want to refresh now?": "이 목록에 업데이트된 정보가 있습니다.<0/>새로고침 후 다시 시도해 주세요. 지금 새로고침하시겠습니까?",
            "Try another search to find an vocabulary.": "단어를 찾으려면 다른 검색을 시도해 보세요.",
            "User invitation has been completed.": "사용자 초대가 완료되었습니다.",
            "Video '{{name}}' has been requested.": "'{{name}}' 비디오가 요청되었습니다.",
            "Videos must only be in DRM-free MP4 video type among the sources.": "소스 중 비디오는 DRM-free MP4 비디오 형식만 가능합니다.",
            "Words to display - Enter Korean, English, numbers, spaces, and special characters (~\\\\!@#$%^&*()-_=+[{]}\\\\|;:'”,<.>/?) You can.": "표시할 단어 - 한글, 영문, 숫자, 공백, 특수문자(~\\\\!@#$%^&*()-_=+[{]}\\\\|;:'”,<.>/?)를 입력할 수 있습니다.",
            "Words to display - You can enter English, numbers, spaces, and special characters (~\\\\!@#$%^&*()-_=+[{]}\\\\|;:'”,<.>/?) there is.": "표시할 단어 - 영문, 숫자, 공백, 특수문자(~\\\\!@#$%^&*()-_=+[{]}\\\\|;:'”,<.>/?)를 입력할 수 있습니다.",
            "You can create a URL for video sharing.": "비디오 공유용 URL을 생성할 수 있습니다.",
            "You can enter up to 30 whitelist rules.": "화이트리스트 규칙은 30개까지 입력할 수 있습니다.",
            "You can see all your current assets. You can find the asset you are looking for using the search option.": "현재 보유한 모든 자산을 볼 수 있습니다. 검색 옵션을 사용하여 원하는 자산을 찾을 수 있습니다.",
            "You cannot upload files to this list.": "이 목록에는 파일을 업로드할 수 없습니다.",
            "You must leave at least one entry in your vocabulary book.": "단어장에는 최소 하나의 항목을 남겨야 합니다.",
            "You will receive an email letting you know that <0/>  the asset has been shared with you.": "자산이 회원님과 공유되었음을 <0/>  이메일로 알려드립니다.",
            "Your folder name is too long including parent folders, you can shorten the folder name and try again.": "상위 폴더를 포함한 폴더 이름이 너무 깁니다. 폴더 이름을 줄인 후 다시 시도해 주세요.",
            "{{resourceName}} '{{name}}' has been updated.": "{{resourceName}} '{{name}}'이(가) 업데이트되었습니다.",
            "{{schemaName}} '{{name}}' has been created.": "{{schemaName}} '{{name}}'이(가) 생성되었습니다.",
            "No labels": "라벨 없음",
            "This user does not exist.": "존재하지 않는 사용자입니다.",
            "No Sharer.": "공유자가 없습니다.",
            "No Users.": "사용자가 없습니다.",
            "No Groups.": "그룹이 없습니다.",
            "Please manage your assets by adding the new folder.": "새 폴더를 추가하여 자산을 관리하세요.",
            "The video list is missing.": "비디오 목록이 없습니다.",
            "Delete completely from Music": "뮤직에서 완전히 삭제합니다",
            "You have selected <0>{{count}}</0> other than <1>{{name}}</1>": "<1>{{name}}</1> 외 <0>{{count}}</0>개를 선택했습니다",
            "Remove from category <0>{{name}}</0> only": "<0>{{name}}</0> 카테고리에서만 제거",
            "You won’t be able to revert this.": "되돌릴 수 없습니다.",
            "If you delete <0>{{name}}</0>, it will also be removed from <0>Reference</0> and you won’t be able to revert this.<1/>Are you sure you want to delete <0>{{name}}</0>?": "<0>{{name}}</0>을(를) 삭제하면 <0>참조</0>에서도 함께 제거되며 되돌릴 수 없습니다.<1/>정말 <0>{{name}}</0>을(를) 삭제하시겠습니까?",
            "If you delete <0>{{count}}</0> other than <0>{{name}}</0>, it will also be removed from <0>Reference</0> and you won’t be able to revert this.<1/>Are you sure you want to delete <0>{{name}}</0>?": "<0>{{name}}</0> 외 <0>{{count}}</0>개를 삭제하면 <0>참조</0>에서도 함께 제거되며 되돌릴 수 없습니다.<1/>정말 <0>{{name}}</0>을(를) 삭제하시겠습니까?",
            "{{verb}} <0>{{count}}</0> files from <1>{{path}}</1> to <2>{{to}}</2>": "<0>{{count}}</0>개 파일을 <1>{{path}}</1>에서 <2>{{to}}</2>(으)로 {{verb}}",
            "An item with the name <0>{{name}}</0> is already in this location.<1/>Do you want to overwrite it with the target file?": "<0>{{name}}</0> 이름의 항목이 이미 이 위치에 있습니다.<1/>대상 파일을 덮어쓰시겠습니까?",
            "Delete completely from Photo": "사진에서 완전히 삭제합니다",
            "Upload Failed.": "업로드 실패.",
            "Upload failed.": "업로드 실패.",
            "<0>{{date}} (24 hours) </0> schedule is complete, or there is not enough<br />blank time than video duration.<br />If you want to add a schedule, please manual schedule it.": "<0>{{date}} (24시간) </0> 일정이 모두 완료되었거나, 영상 길이에 비해 남은 빈 시간이 부족합니다.<br />일정을 추가하려면 직접 편성해 주세요.",
            "{{count}} fields auto-filled": "필드 {{count}}개 자동 입력",
            "The current workflow can be saved as a draft, but some connection structures are invalid, which may cause issues when running.": "현재 워크플로우를 초안으로 저장할 수 있지만, 일부 연결 구조가 올바르지 않아 실행 시 문제가 발생할 수 있습니다.",
            "You can save the current workflow, but saving your changes will cancel <0>{{queuedCount}} queued executions</0>.": "현재 워크플로우를 저장할 수 있지만, 변경 시 실행을 기다리는 <0>대기 중인 {{queuedCount}}건의 작업</0>이 모두 취소됩니다.",
            "The current workflow has items that need to be resolved and cannot be saved. Please fix the items below and save again.": "현재 워크플로우에 해결이 필요한 항목이 있어 저장할 수 없습니다.\n다음 항목을 수정한 후 다시 저장해 주세요.",
            "Add at least one task.": "작업을 1개 이상 추가합니다.",
            "User list export has been requested.": "사용자 목록 내보내기를 요청했습니다.",
            "Failed to export the user list.": "사용자 목록 내보내기에 실패했습니다.",
            "This setting may take some time to take effect after being changed, and the status cannot be changed again while it is being applied.": "이 설정은 변경 후 실제 적용까지 시간이 소요될 수 있으며, 적용 중에는 상태를 다시 변경할 수 없습니다.",
            "This setting is currently being applied. You can change it again after it takes effect.": "현재 설정이 적용 중입니다. 적용이 완료된 후에 다시 변경하실 수 있습니다.",
            "Please select {{type}}.": "{{type}}를 선택해 주세요.",
            "Please select a step.": "스텝을 선택해 주세요.",
            "Select a step node.": "스텝 노드를 선택해 주세요.",
            "No available step": "사용 가능한 스텝이 없습니다.",
            "Up to 5 parallel steps.": "병렬 스텝은 최대 5개까지 추가할 수 있습니다.",
            "Drag anywhere to move the canvas.": "캔버스를 이동하려면 아무 곳이나 드래그하세요.",
            "The step tree for workflow \"{{name}}\" has been updated.": "워크플로우 \"{{name}}\"의 스텝 트리가 업데이트되었습니다.",
            "Input conditions are not satisfied by upstream steps.": "상위 스텝 출력으로 입력 조건이 충족되지 않습니다.",
            "This may take some time to apply, depending on the amount of data.": "데이터 양에 따라 적용까지 시간이 걸릴 수 있습니다.",
            "You have no permission to view this page.": "이 페이지를 볼 수 있는 권한이 없습니다.",
            "Attribution cannot be empty.<0/>Please enter a valid attribution.": "\"어트리뷰션\"은 빈 값일 수 없습니다.<0/>유효한 어트리뷰션을 입력해 주세요.",
            "\"Tags\" can be up to 30.": "30개까지 \"태그\"를 입력할 수 있습니다.",
            "\"Tags\" can be up to {{count}}.": "{{count}}개까지 \"태그\"를 입력할 수 있습니다.",
            "ㆍCIDR : xxx.xxx.xxx.xxx/yy\n \n \n ㆍseparate by newlines": "ㆍCIDR : xxx.xxx.xxx.xxx/yy\n \n \n ㆍ줄 바꿈에 의해 분리됨",
            "ㆍSingle IP : xxx.xxx.xxx.xxx\n ㆍIP Range : xxx.xxx.xxx.xxx~zzz.zzz.zzz.zzz\n ㆍCIDR : xxx.xxx.xxx.xxx/yy\n ㆍSeparate by newlines": "ㆍ 단일 IP : xxx.xxx.xxx.xxx \n  ㆍ IP 범위 : xxx.xxx.xxx.xxx ~ zzz.zzz.zzz.zzz \n  ㆍ CIDR : xxx.xxx.xxx.xxx/yy\n  ㆍ 줄 바꿈에 의해 분리됨",
            "Add file by drag and drop or double-clicking in the select sources.": "선택한 소스를 끌어서 놓거나 두 번 클릭하여 파일을 추가합니다.",
            "A maximum of 2 streams can be selected.": "최대 두 개까지 선택할 수 있습니다.",
            "A one schedules can be selected.": "하나의 스케줄을 선택 할 수 있습니다.",
            "Access denied.": "액세스가 거부되었습니다.",
            "An error occured while trying to analyze the asset": "자산 분석 중 오류 발생",
            "Analyzed automatically labels objects, concepts and scenes in video.": "비디오에서 객체들, 컨셉, 장면들을 자동으로 분석하고 라벨링 합니다.",
            "And {{count}} Other - Total {{total}}": "외 {{count}} - 총 {{total}}",
            "Approve the channel after creation": "생성 후 채널 승인",
            "Are you sure ? You won't be able to revert this!": "확실한가요? 되돌릴 수 없습니다.",
            "Are you sure you delete the selected lineups?": "선택된 라인업을 제거하시겠습니까?",
            "Are you sure you want to approve the selected?": "선택한 항목을 승인하시겠습니까?",
            "Are you sure you want to cancel the request the selected?": "선택된 요청을 취소 하시겠습니까?",
            "Are you sure you want to cancel the return the selected?": "선택된 반환을 취소 하시겠습니까?",
            "Are you sure you want to delete": "삭제 하시겠습니까",
            "Are you sure you want to delete <0>{{name}} ({{id}})</0>?": "정말 <0>{{name}} ({{id}})</0>를 삭제하시겠습니까?",
            "Are you sure you want to delete <0>{{name}}</0>?": "정말 <0>{{name}}</0>을 삭제하시겠습니까?",
            "Are you sure you want to reclaim the selected?": "선택한 항목을 회수 하시겠습니까?",
            "Are you sure you want to reject the request?": "요청을 거부 하시겠습니까?",
            "Are you sure you want to return the selected?": "선택된 항목을 반환 하시겠습니까?",
            "Are you sure you want to request the selected?": "선택된 항목을 요청 하시겠습니까?",
            "Automatically detects explicit adult content in video.": "자동으로 비디오의 노골적인 성인 콘텐츠를 감지합니다.",
            "Automatically recognizes celebrities in video.": "자동으로 비디오에서 유명 인사를 인식합니다.",
            "Base video file can be set only for english without special characters and spaces.": "기본 비디오 파일명은 특수 문자와 공백이 없이 영어로만 가능합니다.",
            "Base video file to be used for the channel can be set only for English without special characters and spaces. (Allowed special characters: ~! () _-.)": "기본 비디오 파일명은 특수 문자와 공백없이 영문이어야 합니다. (허용된 특수문자: ~! () _-.)",
            "Bucket name must be between 3 and 63 letters and start with alphabet or number with allowed special characters of -, _, and .)": "버킷 이름은 반드시 3~63자 이내 여야하고 알파벳이나 숫자로 시작해야만하며, -, _, 그리고 .의 특수문자만 허용됩니다.",
            "Cannot apply because no schema is set": "스키마가 설정되지 않아 적용할 수 없습니다",
            "Cannot apply because the schema is different": "스키마가 달라 적용할 수 없습니다",
            "Cannot create a job": "작업을 생성할 수 없습니다.",
            "CloudPlex Media subtitle editor works with the platform to provide flexible workflows from subtitle registration to publishing.<0/>Quickly create subtitles with user experience-based UI.": "CloudPlex Media 자막 편집기는 플랫폼과 함께 자막 등록부터 퍼블리싱까지 이르는 유연한 워크플로우를 제공합니다.<0/>사용 환경 기반 UI와 함께 신속히 자막을 생성해보세요.",
            "Deleted output assets will be kept for the specified days": "삭제된 아웃풋 자산은 지정된 일 동안 보관됩니다",
            "Do not have an account yet?": "아직 계정이 없으십니까?",
            "Do you really want to change?": "정말로 변경 하시겠습니까?",
            "Do you really want to delete it?": "정말 삭제 하시겠습니까?",
            "Drag and drop a file here": "파일을 여기에 드레그 드랍 하세요.",
            "Drag your files to upload": "업로드할 파일을 드레그 해주세요",
            "Duplicate key. The key must be unique.": "중복된 키가 있습니다.",
            "Duplicate values. This field must be unique.": "중복 값. 이 필드는 고유해야합니다.",
            "Every month on the": "매월",
            "Every month on the {{interval}} days": "매월 {{interval}} 일",
            "Every months on": "매월",
            "Every weeks on": "매주",
            "Failed to get file information from the url.": "URL에서 파일 정보를 가져오지 못했습니다.",
            "Reindexing has been requested.": "재인덱싱이 요청되었습니다.",
            "AI search indexing failed.": "AI 검색 인덱싱에 실패했습니다.",
            "AI search indexing is not supported for this asset.": "이 자산은 AI 검색 인덱싱을 지원하지 않습니다.",
            "This is an unsupported media type.": "지원하지 않는 미디어 타입입니다.",
            "This is an unsupported source format.": "지원하지 않는 소스 포맷입니다.",
            "This image is smaller than the minimum size (128x128 pixels).": "이 이미지는 최소 크기(128x128 픽셀)보다 작습니다.",
            "This image exceeds the maximum file size (5 MiB).": "이 이미지는 최대 파일 용량(5 MiB)을 초과했습니다.",
            "This video exceeds the maximum file size (6 GB).": "이 비디오는 최대 파일 용량(6 GB)을 초과했습니다.",
            "This video exceeds the maximum duration (4 hours).": "이 비디오는 최대 재생 시간(4시간)을 초과했습니다.",
            "Failed to prepare indexing.": "인덱싱 준비에 실패했습니다.",
            "Failed to extract metadata.": "메타데이터 추출에 실패했습니다.",
            "Failed to create the source.": "소스 생성에 실패했습니다.",
            "Failed to check source support.": "소스 지원 여부 확인에 실패했습니다.",
            "Failed to analyze the source.": "소스 분석에 실패했습니다.",
            "Failed to analyze metadata.": "메타데이터 분석에 실패했습니다.",
            "Failed to create the search index.": "검색 인덱스 생성에 실패했습니다.",
            "An internal error occurred.": "내부 오류가 발생했습니다.",
            "AI search indexing is in progress.": "AI 검색 인덱싱을 진행 중에 있습니다.",
            "This analysis failed.": "이 분석에 실패했습니다.",
            "This analysis is outside the supported range.": "이 분석은 지원 범위를 벗어났습니다.",
            "This analysis was only partially indexed.": "이 분석은 일부만 인덱싱되었습니다.",
            "Only part of the source was analyzed.": "소스의 일부만 분석되었습니다.",
            "Only some index entries were created.": "인덱스 항목의 일부만 생성되었습니다.",
            "Some parts were not indexed, so this asset may not appear in all AI search results.": "일부가 인덱싱되지 않아 AI 검색 결과에 모두 나오지 않을 수 있습니다.",
            "Click the button on the badge to retry.": "뱃지의 버튼을 클릭하면 재시도를 할 수 있습니다.",
            "You can find this asset in AI search.": "AI 검색에서 이 자산을 찾을 수 있습니다.",
            "Assets that have not finished indexing may not appear in AI search results.": "인덱싱이 완료되지 않은 자산은 AI 검색 결과에 나오지 않을 수 있습니다.",
            "No results for \"{{keyword}}\".": "'{{keyword}}'에 대한 결과가 없습니다.",
            "Depending on indexing status, some assets may not appear in AI search results.": "인덱싱 상태에 따라 일부 자산은 검색 결과에 나오지 않을 수 있습니다.",
            "The index is already up to date.": "인덱스가 이미 최신 상태입니다.",
            "Failed to request reindexing.": "재인덱싱 요청에 실패했습니다.",
            "Granted roles will be deleted.": "승인된 역할이 삭제됩니다.",
            "Has scheduled lineups.": "스케쥴된 라인업이 있습니다.",
            "Hi, {{name}}": "안녕하세요, {{name}}",
            "http(s)://~ or s3://~": "http(s)://~ 또는 s3://~",
            "Hyper Browser is an enterprise cloud storage client.<0/>Accelerate a variety of workloads with a multi-CDN integration environment and powerful features such as multi-part upload/download, purge and pre-patch.": "하이퍼 브라우저 엔터프라이즈 클라우드 스토리지 클라이언트입니다. 멀티 CDN 통합 환경과 워크로드 및 멀티 파트 업로드 / 다운로드, 퍼지 및 사전 패치와 같은 강력한 다양한 기능을 가속화 <0/>.",
            "If \\\"program duration\\\" is more than \\\"24 hours\\\", you can not repeat the schedule.": "\"프로그램 재생 시간\"이 24시간을 초과하면 반복 재생 할 수 없습니다.",
            "If it is not the scheduled time, it automatically changes the state of the channel to 'Idle'.": "예약된 시간이 아닌 경우 채널의 상태를 자동으로 '유휴'로 변경합니다",
            "If the value is the same, next event has the highest priority": "값이 동일하다면, 다음 이벤트가 가장 높은 우선 순위를 가집니다",
            "If you are not a member yet, please sign up and use.": "아직 멤버가 아니시면, 가입 후 사용해주세요.",
            "If you delete <0>{{name}}</0>, it will also be removed from Related the videos.": "<0>{{name}}</0> 삭제 시 연관된 비디오가 제거됩니다.",
            "If you delete <0>{{deleteLineupTargetName}}</0>, only future events including this one will be deleted.": "<0>{{deleteLineupTargetName}}</0>삭제 시, 미래 이벤트가 제거됩니다.",
            "If you delete <0>{{name}}</0>, only future events including this one will be deleted.<1/>Are you sure you want to delete <0>{{name}}</0>?": "<0>{{name}}</0>를 삭제하면 여기에 포함된 예약 된 이벤트만 삭제 됩니다. <1/><0>{{name}}</0>를 삭제 하시겠습니까?",
            "If you delete <0>{{name}}</0>, the scheduled lineups will be deleted together.<1/>Are you sure you want to delete <0>{{name}}</0>?": "<0>{{name}}</0>를 삭제하려면 예약된 라인업이 함께 삭제됩니다. <1/><0>{{name}}</0>를 삭제 하시겠습니까?",
            "If you delete a lineup that is set to repeat, all future schedule will be deleted.": "반복 라인업 제거 시 모든 미래 스케줄이 제거됩니다.",
            "If you have a problem with your account, or would like to use the cloud <0/>Platform, please contact our sales team. We'll assist you with more details.": "계정이나 클라우드 플랫폼 사용 중 문제가 발생하시면,<0/>세일즈 팀에 연락 바랍니다. 더 상세한 정보로 도와드리겠습니다.",
            "If you have any problem using the stage,<0/> please contact Megazone.": "Stage 사용 중 문제가 발생시 <0/>Megazone으로 연락 바랍니다.",
            "If you have any problem using this space,<0/> please contact Megazone Cloud.": "Space 사용 중 문제가 발생시 <0/>Megazone Cloud로 연락 바랍니다.",
            "If you want to access this page, please contact your administrator.": "이 페이지에 액세스하려면 관리자에게 문의하시기 바랍니다.",
            "Indexing faces and get a complete analysis of facial attributes, <0/>including confidence scores.": "얼굴 인덱싱 진행 시 신뢰도 점수를 포함한<0/>얼굴 속성 분석을 얻을 수 있습니다.",
            "Ingest path setting for pipeline is required. Please contact your manager.": "파이프라인에 인제스트 경로가 필수 입니다. 관리자에게 연락해주세요.",
            "Input assets will be automatically deleted after specified days": "인풋 자산이 지정된 일 후에 자동으로 삭제됩니다",
            "Input name is required.": "인풋 이름이 필요합니다.",
            "Internal server error": "내부 서버 오류",
            "Invalid CIDR. It must be in pattern of xxx.xxx.xxx.xxx/zz.": "CIDR이 유효하지 않습니다. xxx.xxx.xxx.xxx/zz의 패턴 형태여야 합니다.",
            "Invalid upload path": "유효하지 않은 업로드 경로",
            "Multiple image files can be selected.": "여러 이미지 파일을 선택할 수 있습니다.",
            "No {{name}} is set.<0/>Please set the {{name}} and try again.": "설정된 {{name}}(이)가 없습니다.<br/>{{name}} 설정 후 다시 시도해주세요.",
            "No {{name}} searched.": "검색된 {{name}}(이)가 없습니다.",
            "No members is granted": "승인된 구성원이 아닙니다.",
            "No aduits is granted.": "감사가 허용되지 않습니다.",
            "No role is granted": "부여된 역할이 없습니다",
            "One stream can be selected.": "하나의 스트림을 선택할 수 있습니다.",
            "Page not found": "페이지를 찾을 수 없습니다",
            "This page is not supported on mobile.": "모바일에서 지원하지 않는 페이지 입니다.",
            "Please use the button below to go back to the previous page.": "아래 버튼을 통해 이전 페이지로 이동해 주세요",
            "Path was not created. Please set again.": "경로가 생성되지 않았습니다. 다시 설정하십시오.",
            "Pending to upload...": "업로드 대기 중...",
            "Please add a caption to use.": "사용하기 위해 캡션 자산을 추가하세요.",
            "Please add a custom field to use.": "사용할 커스텀 필드를 추가하세요.",
            "Please add a poster assets to use.": "사용 할 포스터 자산을 추가 하세요.",
            "Please add images to use.": "이미지를 추가 하세요.",
            "Please add people images.": "피플 이미지를 추가 하세요.",
            "Please check and try again": "확인하고 다시 시도 해주세요.",
            "Please check the support format and try again.": "지원 포맷을 확인하고 다시 시도하십시오.",
            "Please check valid single IP, IP range or CIDR.": "유효한 단일 IP, IP 범위 또는 CIDR을 확인하시기 바랍니다.",
            "Please contact your stage administrator to access the project.": "프로젝트에 접근하기 위해 스테이지 관리자에게 문의하십시오.",
            "Please go back to the main with the button below.": "아래 버튼을 통해 메인 페이지로 이동해 주시기 바랍니다.",
            "Please select a file to add": "추가 할 파일을 선택하세요",
            "Please select a file to add.": "추가 할 파일을 선택하십시오.",
            "Please select a valid file.": "올바른 파일을 선택하세요.",
            "Please select the project of the stage you want to access.": "액세스하려는 스테이지의 프로젝트를 선택하십시오.",
            "Please try again.": "다시 시도해주세요.",
            "Prefix cannot be empty": "접두사는 비워 둘 수 없습니다",
            "Prefix must begin with s3://": "접두사는 반드시 s3:// 로 시작해야합니다",
            "Remove connected medialive input.": "연결된 MediaLive 인풋을 제거해주세요.",
            "Request a channel approval after creation": "생성 후 채널 승인 요청",
            "Save the origin source as an asset": "원본 소스를 자산으로 저장",
            "Schedule repeat can not be modified after setting. (Repeated lineups can only be deleted)": "설정 후 스케줄 반복을 수정할 수 없습니다. (반복 된 라인업은 삭제할 수 있습니다)",
            "Search for faces in the video using saved face information.": "저장된 얼굴 정보로 비디오에서 얼굴을 검색하세요.",
            "Select a metadata": "메타데이터를 선택하세요",
            "Select AI analysis item": "AI 분석 항목을 선택",
            "Select an face to analyze <0/>From the list of registered images on the left.": "왼쪽에 등록된 이미지 목록에서<br/>분석을 원하는 얼굴을 선택하세요.",
            "Select an face to index <0/>From the list of registered images on the left.": "왼쪽의 등록 된 이미지 목록에서<br/>인덱싱할 얼굴을 선택 하십시오.",
            "Select files from the image type of assets.": "이미지 타입 자산에서 파일을 선택하십시오.",
            "Select one caption file.": "캡션 파일을 선택하세요.",
            "Source must be selected in order to request a channel approval.": "채널 승인을 요청하기 위해서는 소스를 반드시 선택해야 합니다.",
            "Source selection is done after channel creation": "소스 선택은 채널 생성 후 수행됩니다",
            "Special chacters are not allowed": "특수 문자는 허용되지 않습니다",
            "Special chacters can not be entered.": "특수 문자는 입력할 수 없습니다.",
            "The \\\"End time\\\" must be later than \\\"Start time\\\"": "\\\"종료 시간\\\"은 \\\"시작 시간\\\"보다 이후 여야 합니다.",
            "The \\\"Loop To Fill Lineup Duration\\\" setting applies only when the duration of the video is more than \\\"1 minute\\\".": "비디오의 재생 시간이 1분 이상일 때에만 \\\"라인업 시간 반복 채우기\\\" 설정이 적용됩니다.",
            "The asset list is missing.": "자산 목록이 없습니다.",
            "The asset is only MP4 type video.": "자산은 MP4 유형의 비디오여야 합니다.",
            "The base video is applied only when the source type is schedules": "소스 타입이 리스팅일 경우에만 기본 비디오를 사용할 수 있습니다.",
            "The begin date time can not be past time.": "시작 시간은 지금 보다 과거 일 수 없습니다.",
            "The begin date time must be registered after 2 minutes on the current time basis.": "시작 시간은 현재 시간을 기준으로 2 분 후에 등록해야합니다.",
            "The changed roles will be applied to users below.": "변경된 역할은 다음 사용자에게 적용됩니다.",
            "The comment field can be up to {{byte}} byte long.": "코멘트 필드는 최대 {{byte}}byte 입니다.",
            "The description can be up to {{byte}} byte": "설명 필드는 최대 {{byte}}byte입니다.",
            "The description field can be up to {{limit}} byte long.": "설명 필드는 최대 {{limit}}byte 입니다.",
            "The file is not valid.": "파일이 유효하지 않습니다.",
            "The file source list is missing.": "파일 소스가 없습니다.",
            "The key field be up to {{tag}} byte long.": "키 필드 최대 {{tag}}byte 입니다.",
            "The lineup Name field be up to {{name}} byte long.": "라인업 이름 필드의 최대 길이는 {{name}} 바이트입니다.",
            "The lineup priority field is greater than 0 and less than 100.": "라인업 우선 순위 필드는 0보다 크고 100 미만 입니다.",
            "The name field be up to {{title}} byte long.": "이름 필드는 최대 {{title}}byte 입니다.",
            "The name field can be up to {{limit}} byte long.": "이름 필드는 최대 {{limit}}byte 입니다.",
            "The name field is required": "이름 필드는 필수 입니다.",
            "The page you requested could not be found.": "요청하신 페이지를 찾을 수 있습니다.",
            "The same file could not be found": "파일을 찾을 수 없습니다.",
            "The selected Whitelist rules can be modified.": "선택한 화이트리스트 규칙을 수정할 수 있습니다.",
            "The team has no members.": "팀에 멤버가 없습니다.",
            "The value field be up to {{tag}} byte long.": "값 필드 최대 길이는 {{tag}}byte 입니다.",
            "There is an event in the listing or a linked channel, so you can not delete that stream": "리스팅이나 채널에 연결된 이벤트가 있어서 이 스트림은 삭제할 수 없습니다.",
            "There is no analyzable item. Only non-DRM MP4 types are supported for analysis.": "분석 가능 항목이 없습니다. non-DRM MP4 타입만 분석 가능합니다.",
            "There is no input to select.": "선택할 인풋이 없습니다.",
            "There is no schedules to select.": "선택 가능한 스케줄이 없습니다.",
            "There is no project available to access.": "액세스 가능한 프로젝트가 없습니다.",
            "There is work in progress. Would you really go out?": "진행 중인 작업이 있습니다. 정말 나가시겠습니까?",
            "{{count}} upload(s) transferring — do not close or reload this page": "업로드 {{count}}개 전송 중 — 이 페이지를 닫거나 새로고침하지 마세요",
            "Processing continues on the server.": "이후 처리는 서버에서 계속됩니다",
            "Moving between menus or closing this panel is fine.": "메뉴를 이동하거나 이 패널을 닫는 것은 괜찮습니다",
            "{{count}} upload(s) transferred — you can close this page": "업로드 {{count}}개 전송 완료 — 이제 이 페이지를 닫아도 됩니다",
            "Uploading. Do not close or refresh this page.": "업로드 중입니다. 이 페이지를 닫거나 새로고침하지 마세요",
            "There is work in progress. Would you really leave the page?": "진행중인 작업이 있습니다. 정말로 나가시겠습니까?",
            "There was either CORS or network error.": "CORS나 네트워크 오류가 발생했습니다.",
            "This field can be up to {{maxByte}} bytes.": "이 필드는 최대 {{maxByte}} 바이트까지 입력 가능합니다.",
            "This field must pass today's datetime.": "이 필드는 오늘의 데이터 시간을 초과해야 합니다.",
            "This file format is not supported.": "지원하지 않는 파일 포멧 입니다.",
            "This is not a valid URL pattern.": "URL 패턴이 유효하지 않습니다.",
            "This schedules has updated information.<0/>Please refresh and try again. Do you want to refresh now?": "이 리스팅 정보를 업데이트 했습니다. <BR/> 새로고침 하고 다시 시도하십시오. 지금 새로고침 하시겠습니까?",
            "This stage is not accessible.": "이 스테이지는 액세스 할 수 없습니다.",
            "This space is not accessible.": "이 스페이스는 액세스 할 수 없습니다.",
            "This whitelist field is required.": "화이트리스트 필드는 필수입니다.",
            "To request a channel approval, you must select a source.": "채널 승인을 요청 하려면 소스를 선택하세요.",
            "View only <0>requested channels</0>": "<0>요청된 채널만</0> 보기",
            "We're sorry!": "죄송합니다!",
            "You can enter up to {{count}} whitelist rules": "화이트리스트 규칙은 최대 {{count}}개까지 입력할 수 있습니다.",
            "You can only enter {{count}} whitelist rules": "최대 {{count}}개까지 화이트리스트 규칙을 입력할 수 있습니다.",
            "You can upload files up to 500KB in size.": "500KB 사이즈까지 업로드할 수 있습니다.",
            "You can watch preview for 1 minute": "1분 미리보기를 볼 수 있습니다.",
            "You do not have permission to access.": "엑세스 권한이 없습니다.",
            "You don't have any {{name}} to select.": "선택할 수 있는 {{name}}이 없습니다.",
            "You don't have permission to view this page.": "이 페이지를 볼 수있는 권한이 없습니다.",
            "You need to sign in a Megazone Accounts account to get started.": "시작하기 위해 Megazone Accounts 계정을 가입해야 합니다.",
            "Please select a project you want to access.": "액세스하려는 프로젝트를 선택하십시오.",
            "You have no site access.": "사이트 접근 권한이 없습니다.",
            "There is already a folder with the same name. Please change it to a different name.": "같은 이름의 폴더가 이미 있습니다. 다른 이름으로 변경해 주세요.",
            "{{target}} names can’t contain “/”.": "{{target}} 이름은 “/”를 포함할 수 없습니다.",
            "There is already a {{target}} with the same name. Please change it to a different name.": "같은 이름의 {{target}}이(가) 이미 있습니다. 다른 이름으로 변경해 주세요.",
            "Sync requested.": "동기화가 요청되었습니다.",
            "deleteModalReferenceNesting1": "$t(common::msg::deleteModalReferenceKey1)<1/>$t(common::msg::deleteModalReferenceKey3)",
            "deleteModalReferenceNesting2": "$t(common::msg::deleteModalReferenceKey2)<1/>$t(common::msg::deleteModalReferenceKey3)",
            "deleteModalReferenceKey1": "<0>{{name}}</0> 삭제 시 연결된 모든 컨텐츠가 제거되며, 되돌릴 수 없습니다{{dot}}",
            "deleteModalReferenceKey2": "<0>{{name}}</0> 삭제 시 되돌릴 수 없습니다{{dot}}",
            "deleteModalReferenceKey3": "정말 <0>{{name}}</0>을 삭제하시겠습니까?",
            "Don’t ask again": "다시 묻지 않기",
            "If you delete <0>{{name}}</0>, You won’t be able to revert this.<1/>Are you sure you want to delete <0>{{name}}</0>?": "<0>{{name}}</0> 삭제 시 되돌릴 수 없습니다.<1/>정말 삭제하시겠습니까?",
            "Deleting {{currentIndex}} of {{deleteItemLength}}": "삭제 중({{currentIndex}}/{{deleteItemLength}})",
            "You have selected <0>{{name}}</0>": "<0>{{name}}</0>이 선택되었습니다",
            "Remove from category <0>{{name}}</0>": "카테고리<0>{{name}}</0>에서 제거합니다",
            "Delete completely from Assets": "자산에서 완전히 삭제합니다",
            "It will also be removed from Reference and you won’t be able to revert this.": "참조와 함께 제거되며, 되돌릴 수 없습니다.",
            "Inactivated by error": "상태 변경 중 에러로 인해 비활성화 되었습니다.",
            "Error while inactivating": "비활성화 중 에러가 발생했습니다. 다시 시도해주세요.",
            "Error while activating": "활성화 중 에러가 발생했습니다. 다시 시도해주세요.",
            "An attempt to 'Archive' failed.": "'아카이브' 시도에 실패했습니다.",
            "An attempt to 'Restore' failed. Please try again.": "'복원' 시도에 실패했습니다. 다시 시도해주세요.",
            "An attempt to 'Archive' failed. Please try again.": "'아카이브' 시도에 실패했습니다. 다시 시도해주세요.",
            "An attempts to change the status from 'Active' to 'Inactive' failed. Please try again.": "상태를 'Active'에서 'Inactive'(으)로 변경하지 못했습니다. 다시 시도해주세요.",
            "If you archive the asset, you will be charged <0>the {{n}}-day</0> archive amount immediately.": "자산을 아카이브하면 <0>{{n}}일</0> 아카이브 금액이 즉시 청구됩니다.",
            "Are you sure you want to archive?": "아카이브하시겠습니까?",
            "If you restore the Archived Asset, You will be charged for the <0>remaining {{remainingDays}} days.</0>": "아카이브된 자산을 복원하면 <0>남은 {{remainingDays}}일</0>에 대한 요금이 청구됩니다.",
            "Are you sure you want to restore?": "복원하시겠습니까?",
            "Of the <0>{{currentDate}}</0> schedule, <0>only {{lineupCount}}</0> excluding the repeat lineup will be a all Copy to. Lineups with repeat lineups are excluded from the all copy to.": "<0>{{currentDate}}</0> 일정 중 반복 라인업을 제외한 <0>{{lineupCount}}개</0>만 전체 복사됩니다. 반복 라인업이 포함된 라인업은 전체 복사에서 제외됩니다.",
            "Are you sure you all copy to?": "전체 복사하시겠습니까?",
            "There is a schedule on that date and it cannot be selected.<0/>Please delete the schedule for the selected date or select a different date.": "해당 날짜에 일정이 있어 선택할 수 없습니다.<0/>선택한 날짜의 일정을 삭제하거나 다른 날짜를 선택해주세요.",
            "The <0> {{lineupCount}} lineups </0> included in the <0>{{currentDate}}</0> schedule will be all Copy to. <1/>However, the repeat lineups of the selected lineup will stop repeating this and future schedules.": "<0>{{currentDate}}</0> 일정에 포함된 <0> {{lineupCount}}개 라인업 </0>이 전체 복사됩니다. <1/>단, 선택한 라인업의 반복 라인업은 이번 및 향후 일정에서 반복이 중지됩니다.",
            "<0>{{x}}</0> day(s) remaining": "<0>{{x}}</0>일 남음",
            "Past broadcast lineup cannot be deleted.": "과거 방송 라인업은 삭제할 수 없습니다.",
            "Lineup currently being broadcast cannot be delete.": "현재 방송 중인 라인업은 삭제할 수 없습니다.",
            "Schedules within 1 minute from the current time cannot be deleted.": "현재 시간으로부터 1분 이내의 일정은 삭제할 수 없습니다.",
            "If you want All Copy to, lineups with the repeat schedule will stop repeating this and future schedules.": "전체 복사하면 반복 일정이 있는 라인업은 이번 및 향후 일정에서 반복이 중지됩니다.",
            "If you want to delete lineups with repeat schedule, you cannot delete the past lineup that was broadcast, but you can delete future Lineups including this one will be deleted.": "반복 일정이 있는 라인업을 삭제할 경우, 이미 방송된 과거 라인업은 삭제할 수 없으나 이번 라인업을 포함한 향후 라인업은 삭제됩니다.",
            "Set up a YouTube account to publish.": "게시하려면 YouTube 계정을 설정해주세요.",
            "To add the channels of the account you want to publish, sign in to Youtube with that account.": "게시할 계정의 채널을 추가하려면 해당 계정으로 YouTube에 로그인해주세요.",
            "Duplicate login status.": "중복 로그인 상태입니다.",
            "You are currently logged in from another web browser with your information, the connection is terminated and you are directed to the welcome page.": "현재 동일한 정보로 다른 웹 브라우저에서 로그인되어 있어 연결이 종료되고 시작 페이지로 이동합니다.",
            "Your account has been expired.": "계정이 만료되었습니다.",
            "Your account has been inactivated.": "계정이 비활성화되었습니다.",
            "Your account has been deleted.": "계정이 삭제되었습니다.",
            "You cannot access the project.<0/>The connection is terminated and you are directed to the welcome page.": "프로젝트에 접근할 수 없습니다.<0/>연결이 종료되고 시작 페이지로 이동합니다.",
            "After starting the channel, you can watch past broadcasts by changing the playback position for up to 14 days.": "채널 시작 후, 최대 14일 이전까지 재생 위치를 변경해 과거 방송을 시청하실 수 있습니다.",
            "Find objects by prefix": "접두사로 객체 검색",
            "A total of <0>{{type}}</0> participants can be invited per account, and participants must be divided into the schedule of the channels to be created.": "계정 당 총 <0>{{type}}</0> 참가자를 초대 할 수 있으며, 생성 할 채널의 일정에 따라 참가자를 분할 해야합니다.",
            "Megazone Accounts members, please sign in through the button below.": "메가존 계정 회원은 아래 버튼을 통해 로그인 해주세요.",
            "Megazone Login users, please sign in through the button below.": "메가존 로그인 사용자는 아래 버튼을 통해 로그인 해주세요.",
            "If you do not have an account yet, please sign up through": "아직 계정이 없으시면 가입하시기 바랍니다.",
            "If you don’t have an account yet, please ask your Organization Administrator.": "아직 계정이없는 경우 조직 관리자에게 문의하세요.",
            "Go to log in with": "다음으로 로그인하기",
            "You need to sign in a {{Megazone Accounts}} {{or}} {{Megazone Login}} account to get started.": "시작하려면 {{Megazone Accounts}} {{or}} {{Megazone Login}} 계정으로 로그인해야 합니다.",
            "You do not have permission to Show Hidden Metadata.": "숨겨진 메타데이터를 표시할 권한이 없습니다.",
            "If you to Show Hidden Metadata, please ask your administration.": "숨겨진 메타데이터를 표시하려면 관리자에게 문의해주세요.",
            "Select a one file from the audio type of assets.": "오디오 자산에서 파일을 선택하세요.",
            "Select a one file from the image type of assets.": "이미지 자산에서 파일을 선택하세요.",
            "Please add a {{name}} assets to use.": "{{name}} 자산을 추가하세요.",
            "You can't access the space.": "Space에 액세스 할 수 없습니다.",
            "The space is inaccessible because your account has expired or has been deleted.": "계정이 만료되었거나 삭제 되었기 때문에 Space에 접근 할 수 없습니다.",
            "Please contact your space manager.": "Space Manager에 문의하십시오.",
            "If you have issues with Space approval, please contact Megazone Cloud.": "승인에 문제가있는 경우 Megazone Cloud에 문의하십시오.",
            "If you want to site access, please contact your space manager.": "사이트에 접근하려면 Space Manager에게 문의하십시오.",
            "You need access": "액세스가 필요합니다",
            "If you want to check the assets you have selected, <0/> please ask for access.": "선택한 자산을 확인하려면 <0 /> 액세스를 요청하십시오.",
            "Request sent": "요청을 보냈습니다.",
            "You will be notified by email <0/> whether the asset has been shared.": "자산이 공유되었는지 여부를 <0/> 이메일로 알려드립니다.",
            "Enter Display Name or Username": "표시 이름 또는 사용자 이름을 입력하세요",
            "This asset has been deleted.": "이 자산은 삭제되었습니다.",
            "The deleted asset is removed from the Requested to Share.": "삭제 된 자산은 공유 요청에서 제거됩니다.",
            "If necessary, contact the administrator.": "필요한 경우 관리자에게 문의하십시오.",
            "Are you sure you want to reject sharing request for <0>{{name}}</0>?": "<0>{{name}}</0> 에 대한 공유 요청을 거부 하시겠습니까?",
            "Reason for rejection of sharing request (optional)": "공유 요청 거부 사유 (선택)",
            "There is no analytics data.": "분석 데이터가 없습니다.",
            "Detailed view of <0> {{number}} </0> tasks": "<0> {{number}} </0> 개의 작업에 대한 상세보기",
            "files to the <0>{{name}}</0>": "파일을 <0>{{name}}</0> 에",
            "An item with the name '<0>{{name}}</0>' is already in this location.": "<0>{{name}}</0>' 파일이 이미 있습니다.",
            "Do you want to overwrite it with the target file?": "해당 파일로 덮어쓰시겠습니까?",
            "Renaming in <0>{{name}}</0>": "<0>{{name}}</0> 에서 이름 바꾸기 중",
            "Moving <0>{{totalCount}}</0> files from the <0>{{sourceFolderName}}</0> to the <0>{{distFolderName}}</0>": "<0>{{sourceFolderName}}</0> 에서 <0>{{distFolderName}}</0> 으로 <0>{{totalCount}}</0> 파일 이동 중",
            "Copying <0>{{totalCount}}</0> files from the <0>{{sourceFolderName}}</0> to the <0>{{distFolderName}}</0>": "<0>{{sourceFolderName}}</0> 에서 <0>{{distFolderName}}</0> 으로 <0>{{totalCount}}</0> 파일 복사 중",
            "All linked video source assets have been deleted, <0/> so the video preview cannot be seen.": "연결된 모든 비디오 소스 자산이 삭제되었으므로 <0 /> 비디오 미리보기를 볼 수 없습니다.",
            "There are no items for video AI analysis.": "비디오 AI 분석 항목이 없습니다.",
            "Please add music file.": "음악 파일을 추가하세요.",
            "Select files from the Audio type of assets.": "자산의 오디오 유형에서 파일을 선택하십시오.",
            "Cannot change settings from Project Settings.": "프로젝트 관리자에서 설정을 변경할 수 없습니다.",
            "Cannot change settings from Console.": "콘솔에서 설정을 변경할 수 없습니다.",
            "Add one caption asset to use.<0/>The kind of caption can only select subtitles.": "사용할 캡션 애셋을 하나 추가하세요. <0/> 캡션 종류는 자막 만 선택할 수 있습니다.",
            "Select files from the video type of assets.": "자산의 비디오 유형에서 파일 선택하세요.",
            "Please add itemSet for metadata.": "메타데이터용 항목집합을 추가하십시오.",
            "There is no ItemSet to select. Please add a ItemSet.": "선택할 항목 집합이 없습니다. 항목 집합을 추가하십시오.",
            "The caption of the program can be edited in the caption of the <0> {{number}} </0>": "프로그램의 캡션은 <0> {{number}} </0> 캡션에서 편집할 수 있습니다.",
            "There is a duplicate language among the captions applied to the <0> {{name}} </0>": "<0> {{name}} </0>에 적용된 캡션 중 중복된 언어가 있습니다.",
            "Please create a lineup after editing in the video as it is difficult to create a lineup if there are duplicate languages.": "언어가 중복될 경우 라인업 생성이 어려우므로 영상 편집 후 라인업을 생성해주세요.",
            "Changed data exists. Are you sure you want to escape?": "변경된 데이터가 존재합니다. 정말로 벗어나겠습니까?",
            "Add attendees to join the Group Chatting": "그룹 채팅에 참여할 참석자 추가",
            "Enter Email Address": "이메일 주소 입력",
            "Saving of changes to '{{tab}}' failed.": "'{{tab}}' 에 대한 변경 사항을 저장하지 못했습니다.",
            "Changes to the '{{tab}}' have been saved.": "'{{tab}}' 에 대한 변경 사항이 저장되었습니다.",
            "File upload failed.": "파일 업로드에 실패하였습니다.",
            "An invalid input file was selected.": "유효하지 않은 파일입니다.",
            "Asset creation failed.": "자산 생성에 실패하였습니다.",
            "The input file is in an unsupported format.": "지원되지 않는 형식의 파일입니다.",
            "The transcoding operation failed due to an unexpected problem.": "예기치 못한 문제로 인해 트랜스코딩 작업에 실패하였습니다.",
            "If the problem persists, please contact the management.": "문제가 계속될 경우 운영진에게 문의하여 주시기 바랍니다.",
            "Please use a different file after checking the file upload rules.": "파일 업로드 규칙을 확인한 후 다른 파일을 사용하여주시기 바랍니다.",
            "The media information may not be queried, or an invalid file may have been entered.": "미디어 정보를 조회할 수 없는 파일이거나, 유효하지 않은 파일이 입력되었을 수 있습니다.",
            "Use streaming software to send live streams to Amazon IVS, providing users with low-latency live stream services and interactive video experiences.": "스트리밍 소프트웨어를 사용하여 Amazon IVS로 라이브 스트림을 전송하여 사용자에게 짧은 지연 시간으로 라이브 스트림 서비스와 대화형 동영상 환경을 제공합니다.",
            "Provides real-time communication components such as online conferencing services by leveraging messaging, audio, video and screen sharing capabilities to web or mobile applications.": "웹 또는 모바일 애플리케이션에 메시징, 오디오, 비디오 및 화면 공유 기능을 활용하여 온라인 회의 서비스와 같은 실시간 통신 구성 요소를 제공합니다.",
            "Broadcast and deliver live video in up to Full HD.": "최대 Full HD로 라이브 비디오를 브로드캐스트하고 전송합니다.",
            "Broadcast and deliver live video in up to SD.": "최대 SD로 라이브 비디오를 브로드캐스트하고 전송합니다.",
            "Best for near real-time interactions with viewers.": "시청자와의 거의 실시간 상호 작용에 가장 적합합니다.",
            "Enable if real-time interactivity with viewers is not required. May improve reliability in certain regions.": "시청자와의 실시간 상호 작용이 필요하지 않은 경우 활성화합니다. 특정 리전에서 안정성을 개선할 수 있습니다.",
            "Enable token-authorization requirement for video playback.": "비디오 재생에 대한 토큰 권한 부여 요구 사항을 활성화합니다.",
            "Channel’s live stream is automatically recorded and created as Videos and Assets.": "채널의 라이브 스트림이 자동으로 기록되고, Videos와 Assets로 생성됩니다.",
            "A chat where all attendees on the channel can join the chat.": "채널의 모든 참석자들 모두 채팅에 참여할 수 있는 채팅입니다.",
            "A chat that allows for close interaction between invited attendees.": "초대받은 참석자들 사이 가까운 상호 작용을 할 수있는 채팅입니다.",
            "If the chat type is modified after channel creation, all previously set values are initialized.": "채널 생성이후 변경 이후에 채팅 타입을 수정할 경우 기존 설정된 값들이 모두 초기화 됩니다.",
            "Failed to save changes": "변경 사항을 저장하지 못했습니다.",
            "Search for files in Assets.": "자산에서 파일을 검색합니다.",
            "You are about to revoke site access for <0>{{name}}</0>.<1/>This user won’t be able to use your space. You can give them access at any time.<1/>Are you sure you want to revoke site access for this user?": "<0>{{name}}</0>에 대한 사이트 액세스 권한을 취소하려고 합니다.<1/>이 사용자는 귀하의 공간을 사용할 수 없습니다. 언제든지 액세스 권한을 부여할 수 있습니다.<1/>이 사용자의 사이트 액세스 권한을 취소하시겠습니까?",
            "You are about to remove  <0>{{name}}</0> from space.<1/>This user will no longer have access to the space. Your space will still keep all of this user’s contributions.<1/>Are you sure you want to remove user from space?": "공간에서 <0>{{name}}</0>을(를) 제거하려고 합니다.<1/>이 사용자는 더 이상 공간에 액세스할 수 없습니다. 내 공간에는 이 사용자의 모든 기여가 계속 유지됩니다.<1/>공간에서 사용자를 삭제하시겠습니까?",
            "Bucket names must be between 3 and 63 characters long.": "버킷 이름은 3자에서 63자 사이여야 합니다.",
            "Bucket names can consist only of lowercase letters, numbers, dots (.), and hyphens (-).": "버킷 이름은 소문자, 숫자, 점(.) 및 하이픈(-)으로만 구성될 수 있습니다.",
            "Bucket names must begin and end with a letter or number.": "버킷 이름은 문자 또는 숫자로 시작하고 끝나야 합니다.",
            "Bucket names must not be formatted as an IP address (for example, 192.168.5.4).": "버킷 이름은 IP 주소 형식(예: 192.168.5.4)을 사용하지 않습니다.",
            "Bucket names must not start with the prefix xn--.": "버킷 이름은 접두사 xn--로 시작해서는 안됩니다.",
            "Bucket names must not end with the suffix -s3alias.": "버킷 이름은 접미사 -s3alias로 끝나서는 안됩니다.",
            "Bucket names cannot have consecutive periods.": "버킷 이름에는 연속된 마침표를 사용할 수 없습니다.",
            "You can enter up to 10 users.": "최대 10명의 사용자를 입력할 수 있습니다.",
            "Of the selected assets, {{createItemLength}} out of {{selectedItemLength}} can be created as photos. <1/>Choose whether you want <0>the {{createItemLength}} assets</0> to be multiple photos or a single photo.": "선택한 에셋 중 {{selectedItemLength}} 중 {{createItemLength}}를 사진으로 생성할 수 있습니다. <1/><0>{{createItemLength}} 자산</0>을 여러 장의 사진으로 할지 아니면 한 장의 사진으로 할지 선택합니다.",
            "The {{createItemLength}} selected assets have been selected to be created as multiple photos.<0/>Would you like to create a photo now?": "선택한 자산 {{createItemLength}}개가 여러 장의 사진으로 생성되도록 선택되었습니다.<0/>지금 사진을 생성하시겠습니까?",
            "The photo name is applied to the name being used in the asset, and metadata can be edited in the created photo.": "에셋에서 사용 중인 이름에 사진 이름이 적용되며, 생성된 사진에서 메타데이터를 수정할 수 있습니다.",
            "Would you like to log out from the account service as well?": "계정 서비스에서도 로그아웃하시겠습니까?",
            "Conveniently apply to asset types through the Apply All Over option.": "전체 적용 옵션을 통해 자산 유형에 편리하게 적용합니다.",
            "There is a history of individual modification of some metadata among assets of this asset type.": "이 자산 유형의 자산 중 일부 메타데이터를 개별적으로 수정한 이력이 있습니다.",
            "If you save, all the changed metadata will be applied.": "저장하면 변경된 모든 메타데이터가 적용됩니다.",
            "Are you sure you want to fix it though?": "그래도 수정하시겠습니까?",
            "When applied, all default metadata is applied.": "적용하면 모든 기본 메타데이터가 적용됩니다.",
            "Do you still want to apply?": "그래도 신청하시겠습니까?",
            "Changes made to files in the storage list are not updated here.": "스토리지 목록에서 파일은 변경하더라도 여기서는 갱신되지 않습니다.",
            "If you want to change the file, you must close the ‘Create Asset Bulk’ screen and re-enter after making changes in the storage list.": "만약, 파일을 변경하고자 할 경우 ‘에셋 벌크 생성’ 화면을 닫으시고, 스토리지 목록에서 변경 후에 다시 진입하셔야 합니다.",
            "If the asset contains only one single file": "에셋 안에 1개의 단일 파일만 포함하고 있을 경우",
            "If the asset contains multiple files": "에셋 안에 다수의 파일을 포함하고 있을 경우",
            "If the language code for the file is appended after the file name (_), the language and label are automatically applied.": "파일명(_) 뒤에 파일에 맞는 언어코드를 붙이면, 자동으로 언어와 레이블이 적용됩니다.",
            "If the language code is not applied after the file name (_), the language and label are applied in English (United States).": "만약, 파일명(_)뒤에 언어코드를 적용하지 않을 경우 언어와 레이블은 영어(Unitied States)로 적용됩니다.",
            "Add files in the first step, Add Files to Bulk.": "첫 번째 단계인 벌크 파일 추가에서 파일을 추가합니다.",
            "Language and label are automatically applied language and label.": "언어와 레이블은 자동으로 언어와 레이블이 적용됩니다.",
            "Language and labels apply in English (United States).": "언어와 레이블은 English (United States)로 적용됩니다.",
            "Kind default is applied as caption type.": "캡션 유형은 종류 기본값이 적용됩니다.",
            "Creation for {{count}} assets requested.": "{{count}}개의 에셋 생성 요청됨.",
            "It may take some time for stable processing because it is downloading a file from a location far away from the current location (overseas) or a large file.": "현재 위치에서 멀리 떨어진 곳(해외)에서 파일을 다운로드 받거나 대용량 파일을 다운로드 하기 때문에 안정적인 처리에 다소 시간이 소요될 수 있습니다.",
            "If you want to check the file you have selected, <0/> Please contact your space administrator.": "선택한 파일을 확인하려면 스페이스 관리자에게 문의하십시오.",
            "If it is an item in the 'Current Project', all functions can be used.": "‘현재 프로젝트’ 내 아이템일 경우, 모든 기능을 사용할 수 있습니다.",
            "If it is an accessible 'Not Accessible' item, all functions cannot be used.": "‘접근 불가’의 아이템일 경우, 모든 기능을 사용할 수 없습니다.",
            "If it is an accessible 'other project' item, you can use the download function.": "접근 가능한 ‘타 프로젝트’의 아이템일 경우, 다운로드 기능을 사용할 수 있습니다.",
            "To check the folder, select the project to which the bucket the folder<0/>belongs to, and then switch the site to the selected project.": "해당 폴더를 확인하시려면, 폴더가 속한 버킷이 할당된 프로젝트를 고르신 후에,<0/>선택한 프로젝트로 사이트를 전환해야 합니다.",
            "Are you sure you want to check the folder<0/>after switching to the selected project?": "선택하신 프로젝트로 전환 후, <0/>해당 폴더를 확인하시겠습니까?",
            "Download period is up to <0>{{totalCount}}</0> days, and the number of downloads is up to <0>{{sourceFolderName}}</0> times.": "다운로드 기간은 최대 <0>{{totalCount}}</0>일, 다운로드 횟수는 최대 <0>{{sourceFolderName}}</0>회입니다.",
            "The download period is up to <0> {{number}} </0> days.": "다운로드 기간은 최대 <0> {{number}} </0>일입니다.",
            "The number of downloads is up to <0/> times.": "다운로드 횟수는 최대 <0/>회입니다.",
            "The download period is up to <0>{{period}}</0> days,<1/>and the number of downloads is up to <0>{{count}}</0> times left.": "다운로드 기간은 최대 <0>{{period}}</0>일,<1/>다운로드 횟수는 최대 <0>{{count}}</0>회 남았습니다.",
            "The password is wrong <0>{{count}}</0> times. Please check the password.": "비밀번호가 <0>{{count}}</0>번 잘못되었습니다. 비밀번호를 확인해주세요.",
            "In case of error <0>{{count}}</0> times, the download link URL is no longer available.": "<0>{{count}}</0>번 오류가 발생하면 다운로드 링크 URL을 더 이상 사용할 수 없습니다.",
            "If you want to continue downloading,<0/>please get the download link URL back.": "다운로드를 계속하려면<0/>다운로드 링크 URL을 다시 받으십시오.",
            "The requested page may have disappeared or the path may be incorrect.<0/>Please check and try again.": "요청한 페이지가 사라졌거나 경로가 올바르지 않을 수 있습니다.<0/>확인하고 다시 시도하십시오.",
            "The download period is up to <0>{{period}}</0> days.": "다운로드 기간은 최대 <0>{{period}}</0>일입니다.",
            "up to <0> {{number}} </0> days.": "최대 <0> {{number}} </0>일.",
            "up to <0/> times.": "최대 <0/>회.",
            "Are you sure you want to approval the selected<0/><1>{{name}}</1>?": "선택한<0/><1>{{name}}</1>을(를) 승인하시겠습니까?",
            "Are you sure you want to reject the selected<0/><1>{{name}}</1>?": "선택한<0/><1>{{name}}</1>을(를) 거부하시겠습니까?",
            "If you remove <0>{{name}}</0>, the item is deleted from the view.": "<0>{{name}}</0>을 지우면, 해당 항목은 뷰에서 제거됩니다.",
            "Other users will still have access.": "다른 유저는 계속 액세스가 가능합니다.",
            "Are you sure you want to remove the item?": "정말 항목을 지우시겠습니까?",
            "If you remove <0>{{number}}</0> other then <0>{{name}}</0>, the items is deleted from the view.": "<0>{{name}}</0> 외 <0>{{number}}</0>개 파일을 지우면, 해당 항목들은 뷰에서 제거됩니다.",
            "Are you sure you want to remove the items?": "정말 항목들을 지우시겠습니까?",
            "Also, all shared users will no longer have access and will be removed from the shared list.": "또한 모든 공유 사용자는 더 이상 액세스할 수 없으며 공유 목록에서 제거됩니다.",
            "Select the folder path. If not specified, it is stored in the top-level path.": "폴더 경로를 선택하세요. 지정하지 않을 경우 최상위 경로에 저장됩니다.",
            "The folder path of the asset is a virtual path specified by the user and is different from the actual S3 folder path.": "자산의 폴더 경로는 사용자가 직접 지정한 가상의 경로로 실제 S3 폴더 경로와 상이합니다.",
            "Deleting {{currentIndex}} of <0>{{deleteItemLength}}</0> assets": "자산 <0>{{deleteItemLength}}</0>개 중 {{currentIndex}} 삭제 중",
            "If you delete <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to delete?": "<0>{{name}}</0>을 삭제할 경우, 되돌릴 수 없습니다.<1/>정말 삭제하시겠습니까?",
            "If you delete <0>{{name}}</0>,  will also be removed from reference and you won’t be able to revert this.<1/>Are you sure you want to delete?": "<0>{{name}}</0>을 삭제할 경우, 참조에서도 제거되며 되돌릴 수 없습니다.<1/>정말 삭제하시겠습니까?",
            "The download period is up to <0>{{period}}</0> days left.": "다운로드 기간은 최대 <0>{{period}}</0>일 남았습니다.",
            "File {{item}} has been shared": "파일 {{item}}이 공유 되었습니다",
            "Asset {{item}} has been shared": "에셋 {{item}}이 공유 되었습니다",
            "There was an error removing file {{item}}": "{{item}} 파일을 제거하는 중에 오류가 발생했습니다.",
            "There was an error removing asset {{item}}": "{{item}} 에셋을 제거하는 중에 오류가 발생했습니다.",
            "Asset {{item}} and {{length}} other items have been removed.": "자산 {{item}}외 {{length}}개의 항목의 제거가 완료되었습니다.",
            "File {{item}} and {{length}} other items have been removed.": "파일 {{item}}외 {{length}}개의 항목의 제거가 완료되었습니다.",
            "Asset {{item}} has been removed.": "자산 {{item}}의 제거가 완료되었습니다.",
            "File {{item}} has been removed.": "파일 {{item}}의 제거가 완료되었습니다.",
            "There was an error removing file {{item}} and {{length}} other items.": "파일 {{item}}외 {{length}}개의 항목을 제거하는 도중 오류가 발생했습니다.",
            "There was an error removing asset {{item}} and {{length}} other items.": "자산 {{item}}외 {{length}}개의 항목을 제거하는 도중 오류가 발생했습니다.",
            "There was an error removing file {{item}}.": "파일 {{item}}을 제거하는 도중 오류가 발생했습니다.",
            "There was an error removing asset {{item}}.": "자산 {{item}}을 제거하는 도중 오류가 발생했습니다.",
            "There was an error sharing file {{item}}.": "{{item}} 파일을 공유하는 중에 오류가 발생했습니다.",
            "There was an error sharing asset {{item}}.": "{{item}} 에셋을 공유하는 중에 오류가 발생했습니다.",
            "Since this is a category group that is not used in assets, you can check the created assets in 'categories not classified in assets'.": "자산에서 사용하지 않는 카테고리 그룹임으로, 생성된 자산은 ‘에셋에 분류되지 않은 카테고리’에서 확인하실 수 있습니다.",
            "There was an error deleting folder {{item}}.": "{{item}} 폴더를 삭제하는 중에 오류가 발생했습니다.",
            "Deletion of folder {{item}} has been completed.": "{{item}} 폴더 삭제가 완료되었습니다.",
            "Creation of new folder {{item}} is completed.": "{{item}} 폴더 생성이 완료되었습니다.",
            "There was an error creating the new folder {{item}}.": "{{item}} 폴더 생성하는 중에 오류가 발생했습니다.",
            "Discard unsaved changes?": "저장되지 않은 변경사항을 삭제하시겠습니까?",
            "If you delete <0>{{name}}</0>, you won't be able to revert this.": "<0>{{name}}</0>을 삭제하면 되돌릴 수 없습니다.",
            "Move completed from {{item1}} to {{item2}}.": "{{item1}}에서 {{item2}}(으)로 이동이 완료되었습니다.",
            "Moved '{{item1}}' into '{{item2}}'.": "'{{item1}}'을(를) '{{item2}}' 안으로 이동했습니다.",
            "Failed to save the folder order change. Reverted to the original state.": "폴더 순서 변경 저장에 실패했습니다. 원래 상태로 되돌렸습니다.",
            "Failed to save the folder move. Reverted to the original state.": "폴더 이동 저장에 실패했습니다. 원래 상태로 되돌렸습니다.",
            "Refreshing the folder tree. Please try again.": "폴더 트리를 최신 정보로 갱신합니다. 다시 시도해 주세요.",
            "Error moving from {{item1}} to {{item2}}.": "{{item1}}에서 {{item2}}(으)로 이동하는 중에 오류가 발생했습니다.",
            "Error renaming from {{item1}} to {{item2}}.": "{{item1}}에서 {{item2}}(으)로 이름을 바꾸는 중 오류가 발생했습니다.",
            "This folder contains assets.": "이 폴더에는 자산이 포함되어 있습니다.",
            "Rename completed from {{item1}} to {{item2}}.": "{{item1}}에서 {{item2}}(으)로 이름 변경이 완료되었습니다.",
            "The sharing period for this file has expired. <0/> If you want to check the file you have selected, <0/> Please ask the sharer to share.": "이 파일의 공유 기간이 만료되었습니다. <0/> 선택한 파일을 확인하려면 <0/> 공유자에게 공유를 요청하세요.",
            "There was an error creating event trigger.": "이벤트 트리거를 생성하는 중에 문제가 발생했습니다.",
            "Creation of event trigger has been completed.": "이벤트 트리거 생성이 완료되었습니다.",
            "If you delete \"<0>{{name}}</0>\", you won’t be able to revert this.<1/>Are you sure you want to delete?": "\"<0>{{name}}</0>\"을(를) 삭제하면 되돌릴 수 없습니다.<1/>삭제하시겠습니까?",
            "Deleting <0>{{currentIndex}}</0>  of <0>{{deleteItemLength}}</0> assets": "자산 <0>{{deleteItemLength}}</0>개 중 <0>{{currentIndex}}</0>개 삭제 중",
            "If you archive the asset, you will be charged the <0>90-day</0> archive<1/> amount immediately.<1/>Are you sure you want to archive?": "자산을 보관하면 즉시 <0>90일</0> 보관<1/> 금액이 청구됩니다.<1/>정말로 보관하시겠습니까?",
            "Error deleting asset '{{name}}'. {{line}} Please refresh the page and try again.": "자산 '{{name}}'을(를) 삭제 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Asset '{{name}}' has been deleted.": "자산 '{{name}}'이(가) 삭제되었습니다.",
            "Error deleting asset '{{name}}' and {{count}} others. {{line}} Please refresh the page and try again.": "자산 '{{name}}' 외 {{count}}개를 삭제 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Asset '{{name}}' and {{count}} other assets have been deleted.": "자산 '{{name}}' 외 {{count}}개의 자산이 삭제되었습니다.",
            "Error archiving asset '{{name}}'. {{line}} Please refresh the page and try again.": "자산 '{{name}}'을(를) 아카이브 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Asset '{{name}}' has been restored.": "자산 '{{name}}'이(가) 복원되었습니다.",
            "Error restoring asset '{{name}}'. {{line}} Please refresh the page and try again.": "자산 '{{name}}'을(를) 복원 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Error saving changes to {{resource}} settings. {{line}} Please refresh the page and try again.": "{{resource}} 설정의 변경사항을 저장 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Changes to your {{resource}} settings have been saved.": "{{resource}} 설정의 변경사항이 저장되었습니다.",
            "Event trigger '{{name}}' has been added.": "이벤트 트리거 '{{name}}'이(가) 추가되었습니다.",
            "Error adding event trigger '{{name}}'. {{line}} Please refresh the page and try again.": "이벤트 트리거 '{{name}}'을(를) 추가 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "You don't have access. {{line}} Please contact the manager.": "접근권한이 없습니다. {{line}} 관리자에게 문의하세요.",
            "Error adding asset '{{name}}'. {{line}} Please refresh the page and try again.": "자산 '{{name}}'을(를) 추가 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Error adding asset '{{name}}' and {{count}} others. {{line}} Please refresh the page and try again.": "자산 '{{name}}' 외 {{count}}개를 추가 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Asset '{{name}}' has been added.": "자산 '{{name}}'이(가) 추가되었습니다.",
            "Asset '{{name}}' and {{count}} other assets have been added.": "자산 '{{name}}' 외 {{count}}개의 자산이 추가되었습니다.",
            "The access of asset '{{name}}' has been updated to private.": "자산 '{{name}}'의 접근 권한이 비공개로 업데이트되었습니다.",
            "The access of asset '{{name}}' has been updated to public.": "자산 '{{name}}'의 접근 권한이 공개로 업데이트되었습니다.",
            "Error updating asset '{{name}}' with access to private. {{line}} Please refresh the page and try again.": "자산 '{{name}}'의 접근 권한이 비공개로 업데이트 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Error updating asset '{{name}}' with access to public. {{line}} Please refresh the page and try again.": "자산 '{{name}}'의 접근 권한이 공개로 업데이트 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Event trigger '{{name}}' has been deleted.": "이벤트 트리거 '{{name}}'이(가) 삭제되었습니다.",
            "Error deleting event trigger '{{name}}'. {{line}} Please refresh the page and try again.": "이벤트 트리거 '{{name}}'을(를) 삭제 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "The name has been updated.": "이름이 업데이트되었습니다.",
            "Attributions has been updated.": "속성이 업데이트되었습니다.",
            "Tags has been updated.": "태그이 업데이트되었습니다.",
            "Error updating the name. {{line}} Please refresh the page and try again.": "이름을 업데이트 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Error updating the description. {{line}} Please refresh the page and try again.": "설명을 업데이트 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Error updating attributions. {{line}} Please refresh the page and try again.": "속성을 업데이트 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Error updating Tags. {{line}} Please refresh the page and try again.": "태그를 업데이트 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Error updating status to active. {{line}} Please refresh the page and try again.": "상태를 활성으로 업데이트 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Error updating status to inactive. {{line}} Please refresh the page and try again.": "상태를 비활성으로 업데이트 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Error updating conditions. {{line}} Please refresh the page and try again.": "조건을 업데이트 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Error updating Actions. {{line}} Please refresh the page and try again.": "액션을 업데이트 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Status updated to active.": "상태가 활성으로 업데이트되었습니다.",
            "Status updated to inactive.": "상태가 비활성으로 업데이트되었습니다.",
            "The description has been updated.": "설명이 업데이트되었습니다.",
            "Conditions has been updated.": "조건이 업데이트되었습니다.",
            "Actions has been updated.": "액션이 업데이트되었습니다.",
            "You don't have permission to access this item.": "이 항목에 액세스할 수 있는 권한이 없습니다.",
            "Page not found. {{line}} The page you are looking for doesn't exist or an other error occurred.": "페이지를 찾을 수 없습니다. {{line}} 찾고 있는 페이지가 존재하지 않거나 다른 오류가 발생했습니다.",
            "That's an error. {{line}} Please try again later.": "오류가 발생했습니다. {{line}} 나중에 다시 시도 해주세요.",
            "Your request resulted in an error. {{line}} please try again.": "요청사항으로 인해 오류가 발생했습니다. {{line}} 다시 시도하세요.",
            "The download of asset '{{name}}' has been requested.": "자산 '{{name}}'의 다운로드가 요청되었습니다.",
            "Error requesting download of asset '{{name}}'. {{line}} Please refresh the page and try again.": "자산 '{{name}}'의 다운로드 요청 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "The file has been updated.": "파일이 업데이트되었습니다.",
            "Error updating the file. {{line}} Please refresh the page and try again.": "파일을 업데이트 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "\"<0>{{name}}</0>\" will be deleted forever and you won’t be abled to restore it.": "\"<0>{{name}}</0>\" 은 완전히 삭제되며 복원할 수 없습니다.",
            "If you navigate away from this page,<1/>your changes cannot be saved.": "이 페이지에서 벗어나면<1/>변경 사항을 저장할 수 없습니다.",
            "“{{name}}” will be deleted forever and you won’t be abled to restore it.": "\"{{name}}\" 은 완전히 삭제되며 복원할 수 없습니다.",
            "It can only be deleted if there are no assets in the folder.": "폴더 내에 에셋이 없는 경우에만 삭제할 수 있습니다.",
            "Specify the folder location?": "폴더 위치를 지정하시겠습니까?",
            "It may take time to send mail when there are {{count}} or more shared files or folders. (Approximately 3 minutes per 1GB)": "공유되는 파일이 {{count}}개 이상 혹은 폴더일 경우 메일 발송에 시간이 소요될 수 있습니다. (1GB 당 약 3분 소요)",
            "Depending on the size of the shared file, it may take time to send the email. (Approximately 3 minutes per 1GB)": "공유되는 파일의 용량에 따라 메일 발송에 시간이 소요될 수 있습니다. (1GB당 약 3분 소요)",
            "If you restore this item now, you will also be charged for the <NewLine>remaining <Strong>{{n}} days.</Strong></NewLine>": "지금 복원하면 남은 <Strong>{{n}}일</Strong>에 대한 비용도 같이 청구됩니다.",
            "No search results found.": "검색 결과가 없습니다.",
            "Search for the owner of the asset.": "자산의 소유자를 검색하세요.",
            "Enter after typing": "입력 후 엔터",
            "Enter the extension in lowercase without a dot. (e.g. mp4)": "확장자는 점(.) 없이 소문자로 입력하세요. (예: mp4)",
            "The download of asset '{{name}}' and {{count}} other have been requested.": "자산 '{{name}}' 외 {{count}}개의 다운로드가 요청되었습니다.",
            "Please select the project you wish to access.": "액세스하려는 프로젝트를 선택하세요.",
            "Please search by asset name.": "자산 이름으로 검색해주세요.",
            "Please enter the name.": "이름을 입력하세요.",
            "Please enter the description.": "설명을 입력하세요.",
            "Error saving changes to project details. {{line}} Please refresh the page and try again.": "프로젝트 세부 정보의 변경사항을 저장 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Changes to your project details settings have been saved.": "프로젝트 세부 정보의 변경사항이 저장되었습니다.",
            "Error adding project '{{name}}'. {{line}} Please refresh the page and try again.": "프로젝트 '{{name}}'을(를) 추가 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Project '{{name}}' has been added.": "프로젝트 '{{name}}'이(가) 추가되었습니다.",
            "The project lead has been updated.": "프로젝트 리더가 업데이트되었습니다.",
            "Error updating the project lead. {{line}} Please refresh the page and try again.": "프로젝트 리더를 업데이트 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Asset '{{name}}' has been archived.": "자산 '{{name}}'이(가) 아카이브되었습니다.",
            "Bucket '{{name}}' is feature locked for other users.": "버킷 '{{name}}'이(가) 다른 사용자에 대한 기능 잠금이 설정되었습니다.",
            "Bucket '{{name}}' is feature unlocked for another user.": "버킷 '{{name}}'이(가) 다른 사용자에 대한 기능 잠금이 해제되었습니다.",
            "Error occurred while feature-locking bucket '{{name}}' for another user. {{line}} Please refresh the page and try again.": "버킷 '{{name}}'을(를) 다른 사용자에 대한 기능 잠금을 하던 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "Error occurred while attempting to feature unlock bucket '{{name}}' for another user. {{line}} Please refresh the page and try again.": "버킷 '{{name}}'을(를) 다른 사용자에 대한 기능 잠금 해제를 하던 중 오류가 발생했습니다. {{line}} 페이지를 새로고침한 후 다시 시도하세요.",
            "This setting can lock the bucket so that other users cannot use the storage’s features (Copy, Move, Rename, Delete).": "이 설정은 스토리지의 기능(복사, 이동, 이름 변경, 삭제)을 다른 사용자가 사용할 수 없도록 버킷을 잠금 처리할 수 있습니다.",
            "This bucket is locked by another user and can only be downloaded.": "이 버킷은 다른 사용자에 의해 잠겼으며 다운로드만 가능합니다.",
            "No items match this filter": "이 필터와 일치하는 항목이 없습니다",
            "None of achives matched this search": "이 검색과 일치하는 아카이브가 없습니다",
            "Find items using another filter option.": "다른 필터 옵션을 사용하여 항목을 탐색하세요.",
            "Try another search, <br/> or use the search option to find an asset.": "다른 검색을 시도하거나<br/> 검색 옵션을 사용해 자산을 탐색하세요.",
            "You can archive by selecting the items you want to <br/> archive under “Assets”.": "\"자산\"에서 <br/> 보관할 항목을 선택하여 아카이브할 수 있습니다.",
            "No items have been archived yet.": "아카이브된 항목이 없습니다.",
            "Enter Asset Name": "에셋 이름을 입력하세요",
            "Enter Archived ID": "아카이브 ID를 입력하세요",
            "Enter Asset ID": "에셋 ID를 입력하세요",
            "Enter Archived by": "아카이브 작업자를 입력하세요",
            "Enter Owner": "소유자를 입력하세요",
            "Welcome": "환영합니다",
            "You need to log in to your Megazone account to start CloudPlex.": "CloudPlex를 시작하려면 메가존 계정에 로그인해야 합니다.",
            "Login with your Megazone account": "메가존 계정으로 로그인",
            "Size of files Option : Number of files option is required. <NewLine/> Number of files option : Can be set without checking size of files.": "파일 크기 옵션 : 파일 수 옵션이 필요합니다. <NewLine/> 파일 개수 옵션 : 파일 크기를 확인하지 않고 설정할 수 있습니다.",
            "If you archive the assets, you will be charged the <0>{{n}}-day</0> archive<1/> amount immediately.": "자산을 보관하면 <0>{{n}}일</0> 보관금액이 즉시 청구됩니다.",
            "If you archive the asset, you will be charged the <0>{{n}}-day</0> archive<1/> amount immediately.": "자산을 보관하면 즉시 <0>{{n}}일</0> 보관금액이 청구됩니다.",
            "If you restore this item now, you will also be charged for the <NewLine/>remaining days per asset.": "지금 이 항목을 복원하면 <NewLine/>자산당 남은 일수에 대해서도 비용이 청구됩니다.",
            "Getting Access Token...": "액세스 토큰 가져오는 중...",
            "Get Access Token": "액세스 토큰 가져오기",
            "To use CloudPlex Delivery's CDN, an Access Token must be issued.": "CloudPlex Delivery CDN을 사용하려면, 액세스 토큰 발급이 필요합니다.",
            "Please search by asset name or ID.": "자산 이름이나 ID로 검색해주세요.",
            "No collection items yet.": "컬렉션이 없습니다.",
            "Add it using the “Create” button.": "\"생성\" 버튼을 사용하여 추가해주세요.",
            "No linked collection yet.": "연결된 컬렉션이 없습니다.",
            "No assets yet.": "자산이 없습니다.",
            "Add it using the “+” button.": "\"+\" 버튼을 사용하여 추가해주세요.",
            "Please search by collection name.": "컬렉션 이름으로 검색해주세요.",
            "Selected assets can be archived by selecting the storage <NewLine/> class to be archived.": "보관할 스토리지 클래스를 선택하여 <NewLine/> 선택한 자산을 보관할 수 있습니다.",
            "Selected assets can be restored by selecting a restore <NewLine/>option based on how they were archived.": "선택한 자산은 아카이브된 방법에 따라 복원 <NewLine/> 옵션을 선택하여 복원할 수 있습니다.",
            "“{{name}}” and {{count}} others will be deleted forever and you won’t be abled to restore it.": "”{{name}}” 외 {{count}}개가 완전히 삭제되며 복원할 수 없습니다.",
            "However, assets included in the collection are not deleted.": "단, 컬렉션에 포함된 자산은 삭제되지 않습니다.",
            "Deletion of collection {{item}} has been completed.": "컬렉션 {{item}} 삭제가 완료되었습니다.",
            "Partial deletion of collection {{item}} and {{count}} others have been completed.": "컬렉션 {{item}} 외 {{count}}개 컬렉션의 부분 삭제가 완료되었습니다.",
            "Deletion of collection {{item}} and {{count}} others have been completed.": "컬렉션 {{item}} 외 {{count}}개 삭제가 완료되었습니다.",
            "There was an error deleting collection": "컬렉션을 삭제하는 중에 오류가 발생했습니다.",
            "There was an error deleting collections": "컬렉션을 삭제하는 중에 오류가 발생했습니다.",
            "Size of files Option : If you choose your own assets, you can have up to {{maxAssets}}. <NewLine/> Keep the number of selected assets under {{maxAssets}}.": "파일 크기 옵션: 자신만의 자산을 선택하는 경우 최대 {{maxAssets}}개까지 보유할 수 있습니다. <NewLine/> 선택한 자산 수를 {{maxAssets}} 미만으로 유지하세요.",
            "Select assets through search to put them in your collection.": "검색을 통해 자산을 선택하여 컬렉션에 넣으세요.",
            "Select the folder containing the assets you want to put in your collection.": "컬렉션에 넣고 싶은 자산이 포함된 폴더를 선택하세요.",
            "Select collections through search to put them in your collection.": "검색을 통해 컬렉션을 선택하여 컬렉션에 담으세요.",
            "The maximum number of tags, {{maxCount}}, has been exceeded.": "최대 태그 수인 {{maxCount}}개를 초과했습니다.",
            "Please search by collection name or ID.": "컬렉션 이름 혹은 ID로 검색해주세요.",
            "Deletion of content schema {{item}} has been completed.": "콘텐츠 스키마 {{item}} 삭제가 완료되었습니다.",
            "There was an error deleting content schema.": "콘텐츠 스키마를 삭제하는 중에 오류가 발생했습니다.",
            "Content schema '{{name}}' has been added.": "콘텐츠 스키마 '{{name}}'이(가) 추가되었습니다.",
            "Up to 50 {{referenceType}}s can be registered": "최대 50개의 {{referenceType}}을 등록할 수 있습니다.",
            "You can activate a fortress field right away, and you can additionally turn the field into a user camp.": "요새 필드를 바로 활성화할 수 있으며, 추가로 필드를 유저 캠프로 전환할 수도 있습니다.",
            "No projects are in use yet.": "아직 사용 중인 프로젝트가 없습니다.",
            "You must add at least 1 field for “Reference Fields”.<NewLine/> Only then can the schema status be changed to “active” and used in the project.": "“참조 필드”에는 최소 1개 이상의 필드를 추가해야 합니다.<NewLine/> 그래야만 스키마 상태가 “활성”으로 변경되어 프로젝트에서 사용할 수 있습니다.",
            "After opening the Fields panel via the “Add Fields” button,<NewLine/> add fields by dragging them to the “{{isReference}} Fields” layout.": "\"필드 추가\" 버튼을 통해 필드 패널을 연 후 <NewLine/> 필드를 \"{{isReference}} 필드\" 레이아웃으로 드래그하여 추가합니다.",
            "The name starts with English, contains at least 2 letters, and can only contain English, spaces, and numbers.": "이름은 영어로 시작하고 2자 이상이어야 하며, 영어, 공백, 숫자만 포함할 수 있습니다.",
            "No items yet.": "아직 항목이 없습니다.",
            "Add it using the “Add {{name}}” button.": "“{{name}} 추가” 버튼을 이용하여 추가하세요.",
            "“{{name}}” will be removed.": "”{{name}}”가 제거됩니다.",
            "“{{name}}” and {{count}} others will be removed.": "”{{name}}” 외 {{count}}개가 제거됩니다.",
            "None of collection matched this search. {{line}} Try another search.": "이 검색과 일치하는 컬렉션이 없습니다. {{line}} 다른 검색을 시도해 보세요.",
            "Delete the item?": "항목을 삭제하시겠습니까?",
            "Delete these items?": "항목들을 삭제하시겠습니까?",
            "However, assets and content contained in {{schemaName}} are not deleted.": "하지만, {{schemaName}}에 포함된 에셋과 콘텐츠는 삭제되지 않습니다.",
            "Select preview image through search to put them in your content.": "검색을 통해 프리뷰 이미지를 선택하여 콘텐츠에 넣으세요.",
            "Deletion of custom content {{item}} and {{count}} others has been completed.": "커스텀 콘텐츠 {{item}} 외 {{count}}개 삭제가 완료되었습니다.",
            "Deletion of custom content {{item}} has been completed.": "커스텀 콘텐츠 {{item}} 삭제가 완료되었습니다.",
            "Please search by name or ID.": "이름 혹은 ID로 검색해주세요.",
            "Please search by {{resourceType}} name or ID.": "{{resourceType}} 이름 혹은 ID로 검색해주세요.",
            "Try another search to find an content.": "콘텐츠를 찾으려면 다른 검색을 시도해 보세요.",
            "You must enter your authentication information to use the engine.": "엔진을 사용하기 위해서는 인증정보를 입력해야 합니다.",
            "Delete message?": "메세지를 삭제하시겠습니까?",
            "Deleting a message cannot be canceled.": "메세지 삭제는 취소할 수 없습니다.",
            "This message was deleted.": "이 메세지는 삭제되었습니다.",
            "Please enter your message.": "메세지를 입력해주세요.",
            "Up to 50 {{referenceType}} can be registered": "최대 50개의 {{referenceType}}을 등록할 수 있습니다.",
            "Would you like to make a private comment?": "비공개 댓글을 만드시겠습니까?",
            "Please enter a private comment name.": "비공개 댓글 이름을 입력해주세요.",
            "Add users to participate in private comments.": "비공개 댓글 참여 유저를 추가해주세요.",
            "you can add users of the project to communicate with them.": "프로젝트의 사용자를 추가하여 이들과 소통할 수 있습니다.",
            "Would you like to change your private comment name?": "비공개 댓글 이름을 변경하시겠습니까?",
            "Are you sure you want to delete the private comment?": "비공개 댓글을 제거하시겠습니까?",
            "If you delete <0>\"{{name}}\"</0>, all messages will be deleted and cannot be restored after deletion.": "<0>\"{{name}}\"</0>을(를) 삭제하면 모든 메시지가 삭제되며 삭제 후에는 복원할 수 없습니다.",
            "This is a message window where all the basics of the project can be seen.": "프로젝트 모든 멤버가 볼 수 있는 메시지창입니다.",
            "By entering @mention, you can send a comment to the designated member.": "@멘션을 입력하면 지목한 멤버에게 댓글을 보낼 수 있습니다.",
            "This is a message window that only added members can see.": "추가된 멤버만 볼 수 있는 메시지창입니다.",
            "Please enter your user email.": "사용자 이메일을 입력 후 엔터키를 눌러주세요.",
            "Projects you want to allow access to": "액세스를 허용하려는 프로젝트",
            "Select the project you want to allow access to.": "액세스를 허용하려는 프로젝트를 선택하세요.",
            "Select the role you want to grant.": "부여하려는 역할을 선택합니다.",
            "Search by user email.": "사용자 이메일로 검색하세요.",
            "Deletion of {{domain}} {{item}} has been completed.": "{{domain}} {{item}} 삭제가 완료되었습니다.",
            "Duplication of {{domain}} {{item}} has been completed.": "{{domain}} {{item}} 복제가 완료되었습니다.",
            "Creation of {{domain}} {{item}} has been completed.": "{{domain}} {{item}} 생성이 완료되었습니다.",
            "Delete this role?": "이 권한을 제거하시겠습니까?",
            "Please enter a message. (Optional)": "메세지를 입력해주세요. (선택)",
            "Please enter user's name.": "사용자 이름을 입력해주세요.",
            "Select assets.": "자산을 선택하세요.",
            "If you change the applied custom metadata, all data entered will be lost.": "적용된 사용자 정의 메타데이터를 변경하면 입력한 모든 데이터가 손실됩니다.",
            "After AI analyzes the content, the field values of the selected content schema are automatically filled in. Only one schema can be selected.": "AI가 콘텐츠 분석 후, 선택한 콘텐츠 스키마의 필드 값을 자동으로 채웁니다. 스키마는 1개만 선택할 수 있습니다.",
            "Search by custom metadata name.": "커스텀 메타데이터 이름으로 검색하세요.",
            "There are no private comments.": "비공개 댓글이 없습니다.",
            "Use the \"Create private comment\" button Make it.": "\"비공개 댓글 만들기\" 버튼을 이용하여 만드세요.",
            "Enter name or email": "이름 또는 이메일을 입력해주세요",
            "Please enter a message for your request (Optional)": "요청에 대한 메세지를 입력해주세요 (선택)",
            "Folder can only be deleted if there are no assets in the folder.": "폴더에 자산이 없는 경우에만 폴더를 삭제할 수 있습니다.",
            "Select collections in a specific folder?": "특정 폴더의 컬렉션을 선택하시겠습니까?",
            "This field is required.": "이 필드는 필수입니다.",
            "Invalid invitation code or Your invitation link may have expired.": "잘못된 초대 코드 또는 귀하의 초대 링크가 만료되었을 수 있습니다.",
            "Please contact your administrator to request a new invitation link.": "새 초대 링크를 요청하려면 관리자에게 문의하세요.",
            "Hello,<NewLine/>Welcome to LX Hausys Design Library.": "안녕하세요,<NewLine/>LX하우시스 디자인 라이브러리에 오신 것을 환영합니다.",
            "Up to <strong>{{number}}</strong> attachments are allowed.": "첨부파일은 최대 <strong>{{number}}</strong>개까지 가능합니다.",
            "Please select up to <strong>{{number}}</strong> files and try again.": "최대 <strong>{{number}}</strong>개 파일을 선택하여 다시 시도해주세요.",
            "You are currently planning to upload <strong>{{added}}</strong> files. If you would like to attach another file, please remove the file and try again.": "현재 <strong>{{added}}</strong>개 파일을 업로드할 예정이며, 다른 파일을 첨부하고 싶으시면 해당 파일을 제거 후 다시 시도해주세요.",
            "You are currently planning to upload <strong>{{added}}</strong> files. Please select and attach up to <strong>{{remaining}}</strong> additional files.": "현재 <strong>{{added}}</strong>개 파일을 업로드할 예정이며, 추가 파일을 최대 <strong>{{remaining}}</strong>개까지 선택하여 첨부해주세요.",
            "The maximum capacity per attachment is up to <strong>{{maxSize}}</strong>.": "첨부파일당 최대 용량은 <strong>{{maxSize}}</strong>입니다.",
            "The current file has exceeded its capacity. Please check the file to attach and try again.": "현재 파일이 용량을 초과했습니다. 첨부할 파일을 확이나신 후 다시 시도해주세요.",
            "Asset {{item}} duplication completed.": "에셋 {{item}}의 복제가 완료되었습니다.",
            "\"Custom Metadata\" can be applied to an asset’s custom metadata and is available when its status is enabled.": "“커스텀 메타데이터”는 자산의 커스텀 메타데이터에 적용할 수 있으며, 해당 상태가 활성화되면 사용 할 수 있습니다.",
            "Enter required fields for “{{name}}” <0>{{count}}</0>/{{total}}": "“{{name}}”의 필수 항목 입력 <0>{{count}}</0>/{{total}}",
            "and <0>{{count}}</0> more": "외 <0>{{count}}</0>개",
            "There is no data for this widget.": "이 위젯에 대한 데이터가 없습니다.",
            "Are you sure you want to turn off applying custom metadata?": "커스텀 메타데이터 적용을 끄시겠습니까?",
            "Failed to load preview image. Please again.": "미리보기 이미지를 불러오지 못 했습니다. 다시 시도해 주세요.",
            "Preview image Creating...": "미리보기 이미지 생성 중...",
            "Failed to load preview image. <NewLine/>please try again.": "미리보기 이미지를 불러오지 못 했습니다. <NewLine/>다시 시도해 주세요.",
            "Some assets are missing required metadata for electronic payment.<NewLine/> Please change the metadata type to Roll or Artwork and submit.": "전자결재를 위한 필수 메타데이터가 누락된 자산이 있습니다.<NewLine/> 메타데이터 타입을 Roll 혹은 Artwork로 변경 후 상신해주세요.",
            "Asset '{{name}}' has been requested.": "자산 '{{name}}'이(가) 요청되었습니다.",
            "Asset '{{name}}' and {{count}} other assets have been requested.": "자산 '{{name}}' 외 {{count}}개의 자산이 요청되었습니다.",
            "Attribution cannot be empty. Please enter a valid attribution.": "속성은 비워둘 수 없습니다. 유효한 속성을 입력하세요.",
            "If you turn off Custom Apply All Data, your input data is gone and cannot be recovered.": "사용자 정의 모든 데이터 적용을 끄면 입력 데이터가 사라지고 복구할 수 없습니다.",
            "There is no custom metadata yet.": "아직 커스텀 메타데이터가 없습니다.",
            "To enter metadata, select one of the custom metadata options.": "메타데이터를 입력하려면 커스텀 메타데이터 옵션 중 하나를 선택하세요.",
            "Please search by role name": "권한명으로 검색해주세요",
            "Deleting the role “{{roleName}}” removes all permissions for users and groups set by that role.": "“{{roleName}}” 역할을 삭제하면 해당 역할에 의해 설정된 사용자 및 그룹의 모든 권한이 제거됩니다.",
            "The corresponding menu is selected in the project first entry screen settings above. If you do not want to display the menu, turn off the above settings.": "위의 프로젝트 첫 번째 진입 화면 설정에서 해당 메뉴가 선택됩니다. 메뉴를 표시하지 않으려면 위 설정을 끄세요.",
            "Creating access token.": "액세스 토큰 발급 중입니다.",
            "Sucessfully created access token. Please check from the requested client.": "액세스 토큰이 발급되었습니다. 요청하신 클라이언트에서 확인해주세요.",
            "Failed to create access token. Please try again from the requested client.": "액세스 토큰 발급이 실패했습니다. 요청하신 클라이언트에서 다시 시도해주세요.",
            "Please select files to add": "추가할 파일을 선택하세요.",
            "“{{name}}’ is in use in projects.<0/> If you wish to delete it, please disable the schema in the project you are using.": "{{name}}'은(는) 프로젝트에서 사용 중입니다.<0/> 삭제하려면 사용 중인 프로젝트에서 스키마를 비활성화하세요.",
            "Select {{resourceType}} through search to put them in your custom content.": "검색을 통해 {{resourceType}}을(를) 선택하여 커스텀 컨텐츠에 넣으세요.",
            "The selected item is rejected": "선택한 항목이 거부되었습니다.",
            "The selected item is approved": "선택한 항목이 승인되었습니다.",
            "The private comment is deleted.": "비공개 댓글방이 제거되었습니다.",
            "There is no data": "데이터가 없습니다",
            "The selected item has been requested to be archived.": "선택한 항목이 아카이브 요청되었습니다.",
            "Please search by name": "이름으로 검색하세요",
            "Are you sure you want to delete that export file?": "해당 내보내기 파일을 삭제하시겠습니까?",
            "If you delete a exported metadata, all settings and downloadable files will be deleted.": "메타데이터 내보내기를 삭제하면, 설정과 다운로드 가능한 파일이 모두 삭제됩니다.",
            "Contains an overview of all selected assets.<NewLine/> The contents of hidden fields are revealed in the exported file.": "선택한 모든 에셋의 개요가 포함됩니다.<NewLine/> 히든 필드의 내용은 내보낸 파일에서 공개됩니다.",
            "There are no projects selected.": "선택된 프로젝트가 없습니다.",
            "Search for a project.": "프로젝트를 검색하세요.",
            "Creation of new Metadata Export {{item}} is completed": "새 메타데이터 내보내기 {{item}} 생성이 완료되었습니다.",
            "No {{name}} items yet.": "아직  {{name}} 항목이 없습니다.",
            "The selected items have been requested to be archived.": "선택한 항목이 아카이브 요청되었습니다.",
            "You can choose a storage class to store your assets.": "스토리지 클래스를 선택하여 자산을 보관할 수 있습니다.",
            "Please search by content schema name": "콘텐츠 스키마 이름으로 검색하세요.",
            "Please search by DisplayAs or SoundsLike.": "표시할 단어 또는 발음과 비슷한 단어를 검색해주세요.",
            "A preview setting of '{{name}}' have been requested.": "'{{name}}'의 미리보기 설정이 요청되었습니다.",
            "This file size can be up to {{maxByte}} bytes.": "이 파일 크기는 최대 {{maxByte}}바이트까지 가능합니다.",
            "Things to keep in mind when entering words": "단어 입력 시 주의사항",
            "Words similar to spoken sounds - Only Korean characters can be entered.": "음성과 유사한 단어 - 한글만 입력 가능합니다.",
            "If you want to create a URL, please change the status to Published.": "URL을 생성하려면 상태를 게시됨으로 변경하세요.",
            "The changed options is applied when it is ‘ACTIVE’, and if it is ‘INACTIVE’, the options is reset when the pop-up is closed.": "변경된 옵션은 'ACTIVE'일 때 적용되며, 'INACTIVE'일 경우 팝업 종료 시 옵션이 초기화됩니다.",
            "Please search by audit log resourceId.": "감사 로그 리소스 ID로 검색해주세요.",
            "Please search by vocabulary book name.": "단어장 이름으로 검색해주세요.",
            "You can enter English, numbers, spaces, and special characters (~!@#$%^&*()-_=+[{]}|;:’”,<.>/?).": "영문, 숫자, 공백, 특수문자(~!@#$%^&*()-_=+[{]}|;:'\",<.>/?)를 입력할 수 있습니다.",
            "Only English, -(Hyphen) can be entered.": "영문, -(하이픈)만 입력 가능합니다.",
            "You can enter Korean, English, numbers, spaces, and special characters (~!@#$%^&*()-_=+[{]}|;:’”,<.>/?).": "한글, 영문, 숫자, 공백, 특수문자(~!@#$%^&*()-_=+[{]}|;:'\",<.>/?)를 입력할 수 있습니다.",
            "Only Korean can be entered.": "한국어만 입력 가능합니다.",
            "An email will be sent to users with space admin permission.": "스페이스 어드민 권한이 있는 사용자에게 메일 발송됩니다.",
            "No reports have been sent yet.": "아직 발송된 리포트가 없습니다.",
            "{{action}} completed.": "{{action}}이 완료되었습니다.",
            "When you enable automatic archiving, <0>you will be billed immediately for 90 or 180 days</0>, depending on the storage class option you select.": "자동 아카이브를 활성화하면 선택한 스토리지 클래스 옵션에 따라 <0>90일 또는 180일간의 비용이 즉시 청구</0>됩니다.",
            "This storage class is billed for <0>180 days</0> immediately after archiving.": "해당 스트리지 클래스는 아카이브 즉시 <0>180일</0>간의 비용이 청구됩니다.",
            "Video images cannot be captured.": "비디오 이미지를 캡처할 수 없습니다.",
            "To capture video images, the original source must contain an <0>mp4 or mov</0> file. <1/> Try capturing from a video or asset that has an mp4 or mov file.": "비디오 이미지를 캡처하려면 원본 소스에 <0>mp4 또는 mov</0> 파일이 포함되어 있어야 합니다. <1/> mp4 또는 mov 파일이 포함된 동영상 또는 자산에서 캡처해 보세요.",
            "Are you sure you want to delete the link??": "링크를 삭제하시겠습니까??",
            "Deleted links cannot be restored.": "삭제된 링크는 다시 복구할 수 없습니다.",
            "This recipient will no longer be able to download from this link. Revoked access cannot be restored.": "이 수신자는 더 이상 이 링크로 내려받을 수 없습니다. 회수한 권한은 되돌릴 수 없습니다.",
            "Access has been revoked.": "권한이 회수되었습니다.",
            "Revoke this download link?": "다운로드 링크를 회수할까요?",
            "'{{subject}}' shared with {{sharedWith}} will no longer be downloadable.": "{{sharedWith}}에게 공유한 '{{subject}}'을(를) 더 이상 다운로드할 수 없게 됩니다.",
            "A revoked link cannot be restored. Share again to send a new link.": "회수한 링크는 되돌릴 수 없습니다. 다시 공유하면 새 링크가 발송됩니다.",
            "Download link revoked.": "다운로드 링크를 회수했습니다.",
            "Please add a link.": "참조 링크를 추가해주세요.",
            "This field must be in URL format.": "이 필드는 URL 형식이어야 합니다.",
            "Are you sure you want to delete this group?": "이 그룹을 삭제하시겠습니까?",
            "Deleting the {{groupName}} group removes all permissions from users and roles set by that group.": "{{groupName}} 그룹을 삭제하면 해당 그룹에서 설정한 사용자 및 역할의 모든 권한이 제거됩니다.",
            "If the problem persists, <0/> please contact the administrator.": "문제가 지속될 경우, 관리자에게 문의하시기 바랍니다.",
            "Up to {{limit}} {{referenceType}} can be registered": "최대 {{limit}}개의 {{referenceType}}을 등록할 수 있습니다.",
            "Select Category Group": "카테고리 그룹을 선택하세요.",
            "Each menu (e.g. Assets) can be categorized into one category group.": "각 메뉴(예 : 자산)은 1개의 카테고리 그룹을 설정하여 아이템들을 분류할 수 있습니다.",
            "Make sure the category group is in use <label>In use</label> status.": "사용중<label>사용중</label>인 카테고리 그룹이 맞는지 확인하세요.",
            "If you apply a different category group, you can check the items in the <strong>'Uncategorized'</strong> in the category view.": "만약 다른 카테고리 그룹 적용할 경우, 해당 아이템들은 카테고리 보기의 <strong>'자산에 분류되지 않은 카테고리'</strong>에서 확인할 수 있습니다.",
            "There are no assets selected.": "선택한 애셋이 없습니다.",
            "Please select an item to enter the menu": "메뉴에 들어갈 항목을 선택해주세요.",
            "Search by category name": "카테고리 이름으로 검색하세요.",
            "There are no menus configured.": "구성된 메뉴가 없습니다.",
            "Use the \"Add Menu\" button to add it.": "\"메뉴 추가\" 버튼을 사용하여 추가하세요.",
            "'{{item}}' has been created.": "{{item}}이(가) 생성되었습니다.",
            "This menu is set as the first entry screen of the project and cannot be hidden.": "이 메뉴는 프로젝트의 첫 진입 화면으로 설정되어 있어 숨길 수 없습니다.",
            "Please enter the menu name.": "메뉴 이름을 입력하세요.",
            "Menu name can be up to {{maxByte}} bytes.": "메뉴 이름은 최대 {{maxByte}}바이트까지 가능합니다.",
            "Please search by name.": "이름으로 검색하세요.",
            "Deletion of vocabulary book {{item}} has been completed.": "단어장 {{item}}의 삭제가 완료되었습니다.",
            "Deletion of vocabulary book {{item}} and {{count}} others has been completed.": "단어장 {{item}} 외 {{count}}개의 삭제가 완료되었습니다.",
            "Content schema '{{name}}' has been created.": "콘텐츠 스키마 '{{name}}'이(가) 추가되었습니다.",
            "Content schema '{{name}}' has been updated.": "콘텐츠 스키마 '{{name}}'이(가) 수정되었습니다.",
            "Enter last name": "성을 입력해주세요.",
            "Enter first name": "이름을 입력해주세요.",
            "It's not possible to proceed as the archived menu isn't being used.": "아카이브 메뉴를 사용하지 않아 이동이 불가능합니다.",
            "Asset lock has been disabled.": "에셋 잠김 기능이 해제되었습니다.",
            "Asset lock has been enabled.": "에셋 잠김 기능이 활성화되었습니다.",
            "Lock this asset": "이 자산을 잠금설정 합니다",
            "Select a category from the category group.": "카테고리 그룹에서 카테고리를 선택하세요.",
            "Sharing Period and Number of Downloads have expired. You can reset it.": "공유 기간 및 다운로드 수가 만료되었습니다. 재설정할 수 있습니다.",
            "Number of Downloads has expired. You can reset it.": "다운로드 횟수가 만료되었습니다. 재설정할 수 있습니다.",
            "Sharing Period has expired. You can reset it.": "공유 기간이 만료되었습니다. 재설정할 수 있습니다.",
            "There are no shared users.": "공유 사용자가 없습니다.",
            "Processing download request...": "다운로드 요청 진행중...",
            "There are no jobs yet.": "아직 작업이 없습니다.",
            "If you delete “{{name}}”, this property will be removed from all assets using this content schema, and it cannot be recovered.": "{{name}}을 삭제하면, 이 콘텐츠 스키마를 사용하는 모든 에셋에서 해당 속성이 함께 제거되며, 복구할 수 없습니다.",
            "Drag and drop your file here, or upload a file from your PC or cloud.": "파일을 이 곳에 드래그앤드랍 하거나, PC 또는 클라우드의 파일을 업로드 하세요.",
            "Go to the start page and select a project you have access to.": "시작 페이지로 이동하여 접근 권한이 있는 프로젝트로 선택하세요.",
            "If you don’t have access to any projects, please contact your administrator.": "접근 가능한 프로젝트가 없을 경우 관리자에게 문의하시기 바랍니다.",
            "Please use the button below to go to the start page.": "아래 버튼을 통해 시작 페이지로 이동해 주시기 바랍니다.",
            "There is no page available for this comment.": "이 댓글로 이동할 수 있는 페이지가 없습니다.",
            "You do not have permission to access the page.": "페이지에 접근할 수 있는 권한이 없습니다.",
            "The custom metadata used in the asset is disabled.": "에셋에 사용된 커스텀 메타데이터가 비활성화 되어 있습니다.",
            "Selecting Use will make your project assets visible in the full asset search results. This may take some time to apply, depending on the amount of data.": "사용을 선택하면 프로젝트 자산이 전체 자산 검색 결과에 표시됩니다. 데이터 양에 따라 적용하는 데 시간이 걸릴 수 있습니다.",
            "Data accessed through expedited retrieval for all objects except the largest archive objects (250MB or larger) is typically available within 1-5 minutes.": "가장 큰 아카이브 객체(250MB 이상)를 제외한 모든 객체에 대해 신속 처리 검색을 통해 액세스하는 데이터는 일반적으로 1~5분 이내에 사용 가능합니다.",
            "When restoring, Deep Archive storage will be charged for a minimum of 180 days, and other storage classes will be charged for a minimum of 90 days.": "복원 시, Deep Archive 스토리지의 경우 최소 180일, 그 외 스토리지 클래스는 최소 90일의 저장 요금이 청구됩니다.",
            "You will be charged when restoring an asset.": "자산을 복원할 때 비용이 청구됩니다.",
            "AI analysis identifies people, actions, and risk factors in videos and can automatically generate subtitles and text.": "AI 분석은 영상에서 인물, 동작, 위험 요소를 식별하고 자동으로 자막과 텍스트를 생성할 수 있습니다.",
            "Please save or cancel your changes before adding a new task.": "새 작업을 추가하기 전에 변경 사항을 저장하거나 취소해 주세요.",
            "Please set the Input Path.": "입력 경로를 설정해주세요.",
            "Are you sure you want to delete the task?": "작업을 삭제하시겠습니까?",
            "Deleting a task will cause all entered information to disappear and cannot be recovered.": "작업을 삭제하면 입력한 모든 정보는 사라지며, 다시 복구할 수 없습니다.",
            "Please enter your email address and press Enter.": "이메일을 입력 후 엔터키를 눌러주세요.",
            "Share request to {{userName}}": "{{userName}}에게 공유 요청",
            "Changed share options to {{permission}} permission": "{{permission}} 권한으로 공유 옵션 변경",
            "Changed share options to {{permission}} permission until {{expireDate}}": "{{permission}} 권한으로 {{expireDate}}까지 공유 옵션 변경",
            "Changed share options to {{permission}} permission until {{expireDate}} with max {{maxDownloads}} downloads": "{{permission}} 권한으로 {{expireDate}}까지 최대 {{maxDownloads}}회 다운로드로 공유 옵션 변경",
            "Changed share options to {{permission}} permission with max {{maxDownloads}} downloads": "{{permission}} 권한으로 최대 {{maxDownloads}}회 다운로드로 공유 옵션 변경",
            "Sharing with {{user}} was updated": "{{user}}와(과)의 공유 변경",
            "Sharing with {{user}} was removed": "{{user}}와(과)의 공유 해제",
            "Shared with {{user}}": "{{user}}에게 공유",
            "Shared with {{grantees}} permission": "{{grantees}} 권한으로 공유",
            "Shared with {{grantees}} permission until {{expireDate}}": "{{grantees}} 권한으로 {{expireDate}}까지 공유",
            "Shared with {{grantees}} permission until {{expireDate}} with max {{maxDownloads}} downloads": "{{grantees}} 권한으로 {{expireDate}}까지 최대 {{maxDownloads}}회 다운로드로 공유",
            "Shared with {{grantees}} permission with max {{maxDownloads}} downloads": "{{grantees}} 권한으로 최대 {{maxDownloads}}회 다운로드로 공유",
            "Shared link to {{names}}": "{{names}}에게 링크 공유",
            "It's not possible to proceed as the {{menuName}} menu isn't being used.": "{{menuName}} 메뉴를 사용하지 않아 이동이 불가능합니다.",
            "No users have been registered yet.": "아직 등록된 사용자가 없습니다.",
            "Click the User invitation button at the top to add a user.": "상단의 ‘사용자 초대’ 버튼을 눌러 사용자를 추가하세요.",
            "Please search by name or email": "이름 또는 이메일로 검색하세요.",
            "Search by project name": "프로젝트 이름으로 검색하세요",
            "Search by bucket name": "버킷이름으로 검색하세요",
            "\"{{name}}\" will be deleted forever and you won't be abled to restore it.": "“{{name}}“은(는) 영구적으로 삭제되며, 복구할 수 없습니다.",
            "\"{{name}}\" and {{count}} others will be deleted forever and you won't be abled to restore it.": "“{{name}}“ 외 {{count}}개는 영구적으로 삭제되며, 복구할 수 없습니다.",
            "The service is located in {{region}}.": "서비스가 {{region}}에 위치해 있습니다.",
            "Please select a region.": "지역을 선택해 주세요.",
            "Please copy the JSON below to create an IAM Permission.": "아래 JSON을 복사하여 IAM Permission을 생성해주세요.",
            "Please apply the role trust relationship by replacing {REPLACE_WITH_YOUR_EXTERNAL_ACCOUNT_ID} in the JSON below with the account ID you want to use.": "아래 JSON에서 {REPLACE_WITH_YOUR_EXTERNAL_ACCOUNT_ID}를 사용하시려는 계정 ID로 치환해서 Role의 Trust relationship에 적용해주세요.",
            "Please copy the Role ARN and paste it into the external account input field for <0>AWS account connection</0>.": "Role ARN을 복사하여 <0>AWS 계정 연결</0> 타계정 입력 란에 붙여넣기 해주세요.",
            "Please enter the AWS Role ARN.": "AWS Role ARN을 입력해주세요.",
            "Please search by user name.": "사용자 이름으로 검색하세요.",
            "Please search by group name.": "그룹 이름으로 검색하세요.",
            "Please select a new owner": "새 소유자를 선택해주세요",
            "Changing the owner may result in the existing owner losing permissions and some features being restricted.": "소유자를 변경하면 기존 소유자는 권한이 사라지고 일부 기능이 제한될 수 있습니다.",
            "Are you sure you want to delete this?": "이것을 삭제하시겠습니까?",
            "Please click Add roles button to grant roles to this user.": "이 사용자에게 역할을 부여하려면 역할 추가 버튼을 클릭하세요.",
            "No group is granted": "부여된 그룹이 없습니다.",
            "There are no groups yet.": "아직 그룹이 없습니다.",
            "Please click Manage Access button to add group to this project.": "이 프로젝트에 그룹을 추가하려면 액세스 관리 버튼을 클릭하세요.",
            "There are no users yet.": "아직 사용자가 없습니다.",
            "Please click Manage Access button to add user to this project.": "이 프로젝트에 사용자를 추가하려면 액세스 관리 버튼을 클릭하세요.",
            "You can create up to {{n}} tags.": "태그는 최대 {{n}}개까지 생성됩니다.",
            "Update owner to {{name}}": "{{name}}으로 소유자 변경",
            "URL not found": "URL을 찾을 수 없습니다",
            "The URL has been deleted or the menu does not exist.": "URL이 삭제되었거나 메뉴가 존재하지 않습니다.",
            "You must enter your credentials to use the engine.": "인증 정보를 입력해야 엔진을 사용할 수 있습니다.",
            "When uploading via pop-up, empty folders are excluded.<NewLine/> To upload empty folders as well, please drag the folders directly into the asset list.": "팝업으로 업로드할 경우 빈 폴더는 제외됩니다.<NewLine/> 빈 폴더도 함께 업로드하려면 에셋 목록에 폴더를 직접 드래그해 주세요.",
            "If the capacity is more than {{limit}}, the print file will be automatically extracted and automatic captions will be generated.": "용량이 {{limit}}가 넘을 경우 자동으로 음성 파일 추출 후 오토 캡션이 생성됩니다.",
            "It is only available at the all project level.": "전체 프로젝트 기준에서만 확인 가능합니다.",
            "There is no data available.": "해당 데이터가 없습니다.",
            "The maximum upload size is {{size}}.": "업로드 가능한 최대 객체 크기는 {{size}}입니다.",
            "Please select a repository.": "저장소를 선택해 주세요.",
            "Remove user from role?": "해당 사용자를 제거하시겠습니까?",
            "If you remove the user {{userName}}, assigned permission will be removed.": "\"{{userName}}” 사용자를 제거하면 할당된 모든 역할 권한이 제거됩니다.",
            "Remove group from role?": "해당 그룹을 제거하시겠습니까?",
            "If you remove the group {{groupName}}, assigned permission will be removed.": "\"{{groupName}}” 그룹을 제거하면 할당된 모든 역할 권한이 제거됩니다.",
            "There is no file.": "파일이 없습니다.",
            "mentioned you in a comment": "님이 댓글에서 귀하를 멘션했습니다.",
            "replied to your comment": "님이 내 댓글에 댓글을 작성했습니다.",
            "invited you to a private comment": "님이 귀하를 댓글방에 초대했습니다.",
            "There are no notifications yet.": "알림이 없습니다.",
            "Notifications will be deleted after 7 days.": "알림 메세지는 7일 후 삭제됩니다.",
            "The item does not exist": "해당 항목이 존재하지 않습니다.",
            "Analysis completed, but there are no results for {{name}}.": "분석을 완료했으나, {{name}}에 대한 결과가 없습니다.",
            "An error occurred during analysis and the operation could not be completed.": "분석 중 오류가 발생하여 작업을 완료하지 못했습니다.",
            "Analyzing now uses the proxy video.": "지금 분석하면 프록시 영상으로 처리됩니다.",
            "The proxy video is still being created, so analyzing now uses the original and takes longer.": "프록시 영상을 만들고 있어, 지금 분석하면 원본으로 처리되어 더 오래 걸립니다.",
            "The proxy video could not be created, so it is analyzed with the original.": "프록시 영상을 만들지 못해 원본으로 분석됩니다.",
            "There is no proxy video, so it is analyzed with the original.": "프록시 영상이 없어 원본으로 분석됩니다.",
            "Proxy videos are only created for assets registered after auto generation is turned on.": "프록시 자동 생성은 켠 뒤 등록된 영상에만 적용됩니다.",
            "There was a problem for a moment.": "잠시 문제가 발생했어요",
            "There was a problem processing your request. Please try again later.": "요청을 처리하는 데 문제가 생겼습니다. 잠시 후 다시 시도해 주세요.",
            "AI usage quota has been exceeded.": "AI 사용량 한도를 초과했습니다.",
            "You have reached the AI usage limit. Please contact your administrator to increase the quota.": "AI 사용량 한도에 도달했습니다. 사용량 증대가 필요한 경우 관리자에게 문의해주세요.",
            "No values were extracted.": "추출된 값이 없습니다",
            "The analysis finished, but no values matching the schema fields were returned. Retrying may produce the same result.": "분석은 완료했지만 스키마 항목에 맞는 값을 가져오지 못했습니다. 다시 시도해도 같은 결과가 나올 수 있습니다.",
            "I recommend the video highlights.": "영상 하이라이트 추천드립니다.",
            "Enter a prompt for AI": "AI 프롬프트를 입력하세요",
            "What can I help with?": "무엇을 도와드릴까요?",
            "Please enter the prompt.": "프롬프트를 입력해 주세요.",
            "Preset status has been updated.": "프리셋 상태가 업데이트되었습니다.",
            "Deletion of preset {{item}} has been completed.": "프리셋 {{item}} 삭제가 완료되었습니다.",
            "Preset has been duplicated successfully.": "프리셋이 성공적으로 복제되었습니다.",
            "Failed to send the prompt preset.": "프롬프트 프리셋 전송에 실패했습니다.",
            "'{{name}}' will be deleted forever and you won't be able to restore it.": "‘{{name}}’은(는) 영구적으로 삭제되며 복구할 수 없습니다.",
            "No preset items yet.": "아직 프리셋 항목이 없습니다.",
            "No content schema items yet.": "아직 콘텐츠 스키마 항목이 없습니다.",
            "Create it using the “Create” button.": "\"생성\" 버튼을 사용하여 생성해주세요.",
            "To use the AI-Workspace, the original source must contain an <0>mp4 or mov</0> file.": "AI-Workspace를 사용하려면 원본 소스에 <0>mp4 또는 mov</0> 파일이 포함되어 있어야 합니다.",
            "Name is required.": "이름은 필수입니다.",
            "Prompt is required.": "프롬프트는 필수입니다.",
            "Please select the required items from the recommended tags.": "추천된 태그 중 필요한 항목을 선택해 주세요.",
            "The selected tags have been saved to the metadata.": "선택된 태그가 메타데이터에 저장되었습니다.",
            "Please select a template.": "템플릿을 선택해주세요.",
            "Your session has expired. Please start a new conversation.": "만료된 세션입니다. 새 대화를 시작해주세요.",
            "Generating results": "결과를 생성하고 있습니다",
            "There is no description yet. Bring an AI description or enter it directly.": "설명이 아직 없습니다. AI 설명을 가져오거나 직접 입력하세요.",
            "Please write a description.": "설명을 작성해 주세요.",
            "To capture video images, it must be an <0>mp4 or mov</0> file. <1/> Try capturing from mp4 or mov assets.": "비디오 이미지를 캡처하려면 <0>mp4 또는 mov</0> 파일이어야 합니다. <1/> mp4 또는 mov 자산에서 캡처를 시도해 보세요.",
            "The video cannot be edited.": "비디오를 편집할 수 없습니다.",
            "To edit a video, it must be an <0>mp4 or mov</0> file. <1/> Edit in mp4 or mov assets.": "비디오를 편집하려면 <0>mp4 또는 mov</0> 파일이어야 합니다. <1/> mp4 또는 mov 자산에서 편집하세요.",
            "To edit a video, the original source must contain an <0>mp4 or mov</0> file. <1/> Edit videos or assets that contain mp4 or mov files.": "비디오를 편집하려면 원본 소스에 <0>mp4 또는 mov</0> 파일이 포함되어 있어야 합니다. <1/> mp4 또는 mov 파일이 포함된 동영상 또는 자산에서 편집하세요.",
            "You can play it directly on mobile with the QR code.": "QR 코드로 모바일에서 바로 재생할 수 있습니다.",
            "Analyze videos with AI": "영상을 AI로 분석하여",
            "to easily manage your videos.": "비디오를 손쉽게 관리해 보세요.",
            "Video AI analysis can extract labels for specific people, objects, patterns, and actions in videos, and manage inappropriate or dangerous content.": "영상 AI 분석은 영상의 특정 인물, 물체, 패턴, 행동 등을 라벨로 추출할 수 있고, 부적절하거나 위험한 콘텐츠를 관리할 수 있습니다.",
            "Additionally, it can automatically convert video audio to text and automatically generate captions to easily manage videos.": "또한, 자동으로 영상의 음성을 텍스트로 변환할 수 있고, 자막을 자동으로 생성하여 비디오를 쉽게 관리할 수 있습니다.",
            "{{resourceName}} '{{name}}' has been added.": "{{resourceName}} '{{name}}'이 추가되었습니다.",
            "{{resourceName}} '{{name}}' and {{count}} others have been added.": "{{resourceName}} '{{name}}' 외 {{count}}개가 추가되었습니다.",
            "This field can be up to {{maxLength}} characters.": "이 필드는 최대 {{maxLength}} 자까지 입력 가능합니다.",
            "The description can be up to {{maxLength}} characters long.": "설명은 최대 {{maxLength}} 자까지 입력 가능합니다.",
            "The comment field can be up to {{maxLength}} characters long.": "코멘트 필드는 최대 {{maxLength}} 자까지 입력 가능합니다.",
            "Menu name can be up to {{maxLength}} bytes.": "메뉴 이름은 최대 {{maxLength}} 자까지 입력 가능합니다.",
            "The description can be up to {{maxLength}} characters": "설명은 최대 {{maxLength}} 자까지 입력 가능합니다",
            "Request to create download link successfully": "링크를 성공적으로 공유했습니다.",
            "Auto set by {{name}}": "{{name}}에 의해 자동 설정 되었습니다.",
            "request completed": "요청이 완료되었습니다",
            "Each menu (e.g. Asset) can categorize items by setting one category group.": "각 메뉴(예 : 자산)은 1개의 카테고리 그룹을 설정하여 아이템들을 분류할 수 있습니다.",
            "Make sure the category group is currently <InUse>In Use</InUse> for the target menu (e.g. Asset).": "적용할 메뉴(예:자산)에 사용중 In Use 인 카테고리 그룹이 맞는지 확인하세요.",
            "If you apply a different category group, those items can be found under '<NotClassified>Categories Not Classified into Assets</NotClassified>' in the category view.": "만약, 다른 카테고리 그룹 적용할 경우, 해당 아이템들은 카테고리 보기의 '자산에 분류되지 않은 카테고리'에서 확인할 수 있습니다.",
            "Category groups allow you to classify and manage items conveniently.": "카테고리 그룹을 사용하면, 아이템을 분류하여 편리하게 관리할 수 있습니다.",
            "Assets can be created successfully only when no values are empty. If not used, please delete.": "비워져 있는 값이 없어야 성공적으로 자산을 만들 수 있습니다. 사용을 하지 않을 경우 삭제하시기 바랍니다.",
            "The name field be up to {{title}} characters long.": "이름 필드는 최대 {{title}}자 입니다.",
            "The selected {{type}} has been saved to the metadata.": "선택된 {{type}}이 메타데이터에 저장되었습니다.",
            "No Collection items yet.": "컬렉션이 없습니다.",
            "Add it using the “Add Collection” button.": "\"컬렉션 추가\" 버튼을 사용하여 추가해주세요.",
            "If you archive the asset, you will be charged <0>the 90-day</0> archive amount immediately.": "자산을 아카이브하면 <0>90일</0> 아카이브 금액이 즉시 청구됩니다.",
            "You will receive an email letting you know that <0/> the asset has been shared with you.": "자산이 공유되었음을 알리는 <0/> 이메일이 발송됩니다.",
            "Please use a different file after checking the 'Supported File Formats' of the file upload rules.": "파일 업로드 규칙의 '지원되는 파일 형식'을 확인한 후 다른 파일을 사용해 주세요.",
            "Asset '{{name}}' has been moved from '{{fromFolder}}' to Folder '{{toFolder}}'.": "자산 '{{name}}'이(가) '{{fromFolder}}'에서 폴더 '{{toFolder}}'(으)로 이동되었습니다.",
            "Asset '{{name}}' and {{count}} other has been moved from '{{fromFolder}}' to Folder '{{toFolder}}'.": "자산 '{{name}}' 외 {{count}}개가 '{{fromFolder}}'에서 폴더 '{{toFolder}}'(으)로 이동되었습니다.",
            "This operation was not entirely successful.": "이 작업은 완전히 성공하지 못했습니다.",
            "ㆍCIDR : xxx.xxx.xxx.xxx/yy\n \n ㆍseparate by newlines": "ㆍCIDR : xxx.xxx.xxx.xxx/yy\n \n ㆍ줄 바꿈으로 구분",
            "This is not a valid URL pattern": "유효한 URL 패턴이 아닙니다.",
            "Please search by folder name": "폴더 이름으로 검색해주세요.",
            "Folder": "폴더",
            "invited you to a thread": "님이 스레드에 초대했습니다.",
            "The status has been changed.": "상태가 변경되었습니다.",
            "Are you sure you want to delete this workflow?": "이 워크플로우를 삭제하시겠습니까?",
            "If you delete this workflow, it cannot be recovered.": "워크플로우를 삭제하면 복구할 수 없습니다.",
            "An event that triggers the workflow to run.": "워크플로우 실행을 트리거하는 이벤트입니다.",
            "Branches the workflow based on conditions.": "조건에 따라 워크플로우를 분기합니다.",
            "Proceeds to the next step when the task is completed.": "작업이 완료되면 다음 스텝으로 진행합니다.",
            "When the created asset's media type is {{values}}": "생성된 자산의 미디어 타입이 {{values}}일 때",
            "When the file extension is {{values}}": "파일 확장자가 {{values}}일 때",
            "Branch files based on file extension": "파일을 확장자 기준으로 분기",
            "Branch files based on file size": "파일을 크기 기준으로 분기",
            "Branch files based on media type": "자산을 미디어 타입 기준으로 분기",
            "Branch files based on asset size": "자산을 크기 기준으로 분기",
            "When an object is created in the S3 bucket": "S3 버킷에 오브젝트가 생성되면",
            "When an asset is created in the current project": "현재 프로젝트에 자산이 생성되면",
            "Submit transcode task to pipeline": "파이프라인에 트랜스코드 작업을 제출합니다",
            "Create an asset from a file (waits until preview extraction completes)": "파일로부터 자산을 생성합니다 (프리뷰 추출 완료까지 대기)",
            "Attach metadata to asset": "자산에 메타데이터를 연결합니다",
            "System preset-based single type job": "시스템 프리셋 기반 싱글 타입 작업",
            "Archive to the specified storage class": "지정한 스토리지 클래스로 아카이브합니다",
            "Publish a video to SNS": "비디오를 SNS에 퍼블리시합니다",
            "This trigger has no additional conditions.": "이 트리거에는 추가 조건이 없습니다.",
            "Exactly one of {{keys}} is required": "{{keys}} 중 정확히 하나가 필요합니다",
            "One of {{keys}} is required": "{{keys}} 중 하나가 필요합니다",
            "{{keys}} cannot be used together": "{{keys}} 항목은 함께 사용할 수 없습니다",
            "Use AI workspace metadata.": "AI 워크스페이스 메타데이터를 사용합니다.",
            "Enter manually.": "직접 입력합니다.",
            "Data updated at {{timestamp}} ({{offset}})": "데이터 업데이트 일시 : {{timestamp}} {{offset}} 기준",
            "Based on {{start}} ~ {{end}} ({{offset}})": "{{start}} ~ {{end}} {{offset}} 기준",
            "{{month}} settlement confirmed": "{{month}} 마감 확정",
            "{{percent}}% in use": "{{percent}}% 사용 중",
            "Concurrent session limit {{max}}": "최대 동시 세션 한도 {{max}}",
            "Monthly base fee {{fee}}": "월 기본료 {{fee}}",
            "Monthly base fee none": "월 기본료 없음",
            "Base fee : {{fee}}": "월 기본료 : {{fee}}",
            "Base fee : none": "월 기본료 : 없음",
            "Usage fee : {{minutes}} min × {{rate}}": "사용료 : {{minutes}}분 × {{rate}}",
            "Usage fee : {{minutes}} min": "사용료 : {{minutes}}분",
            "{{days}} days": "{{days}}일",
            "Failed to load billing information.": "요금 정보를 불러오지 못했습니다.",
            "There is no active subscription for this tenant.": "이 테넌트에는 활성 구독이 없습니다.",
            "ㆍSingle IP : xxx.xxx.xxx.xxx\nㆍIP Range : xxx.xxx.xxx.xxx~zzz.zzz.zzz.zzz\nㆍCIDR : xxx.xxx.xxx.xxx/yy\nㆍSeparate by newlines": "ㆍ단일 IP : xxx.xxx.xxx.xxx\nㆍIP 범위 : xxx.xxx.xxx.xxx~zzz.zzz.zzz.zzz\nㆍCIDR : xxx.xxx.xxx.xxx/yy\nㆍ줄바꿈으로 구분",
            "ㆍCIDR : xxx.xxx.xxx.xxx/yy\nㆍseparate by newlines": "ㆍCIDR : xxx.xxx.xxx.xxx/yy\nㆍ줄바꿈으로 구분",
            "Clicking apply replaces the matching field of the custom metadata below the video with the extracted value.": "적용을 클릭하면 영상 하단 커스텀 메타데이터의 일치하는 필드가 추출값으로 교체됩니다.",
            "This segment has no duration, so it cannot be added.": "재생 구간이 없어 추가할 수 없습니다.",
            "Replaces the current metadata with the selected preset schema's metadata and saves it. Changes cannot be undone.": "현재 메타데이터를 선택한 프리셋 스키마의 메타데이터로 교체하고 저장합니다. 변경된 내용은 되돌릴 수 없습니다.",
            "The current metadata is replaced with the metadata from the selected preset schema. You can revert to the previous state until the metadata is saved.": "현재 메타데이터가 선택한 프리셋 스키마의 메타데이터로 교체됩니다. 메타데이터를 저장하기 전까지는 이전 상태로 되돌릴 수 있습니다.",
            "Replaces the current metadata with the selected preset schema's metadata. You cannot save if required fields are empty. Enter the required values and then save.": "현재 메타데이터를 선택한 프리셋 스키마의 메타데이터로 교체합니다. 필수 항목이 입력되지 않은 경우 메타데이터를 저장할 수 없습니다. 필수 값을 입력한 후 저장해 주세요.",
            "Saving deletes the existing custom metadata and replaces it with the AI-extracted metadata. Changes cannot be undone. Do you want to continue?": "저장하면 기존 커스텀 메타데이터가 삭제되고, AI가 추출한 메타데이터로 변경됩니다. 변경된 내용은 되돌릴 수 없습니다. 계속 저장하시겠습니까?",
            "Saving deletes the existing custom metadata and replaces it with the current settings. Changes cannot be undone. Do you want to continue?": "저장하면 기존 커스텀 메타데이터가 삭제되고, 현재 설정한 정보로 변경됩니다. 변경된 내용은 되돌릴 수 없습니다. 계속 저장하시겠습니까?",
            "Select the items to save as custom metadata from the extracted values. You can edit the values before saving.": "추출된 값 중 커스텀 메타데이터에 저장할 항목을 선택해 주세요. 저장 전에 값을 수정할 수 있습니다.",
            "The metadata has been saved.": "메타데이터가 저장되었습니다.",
            "This asset uses the <0>'{{current}}'</0> schema, which differs from the preset schema({{preset}}). Field-level replacement is not available; replacing the schema applies all extracted values and clears the existing input data.": "이 자산에는 <0>'{{current}}'</0> 스키마가 적용되어 있어 프리셋 스키마({{preset}})와 다릅니다. 필드 단위 교체는 불가하며, 스키마를 교체하면 추출값이 전체 적용되고 기존 입력 데이터는 사라집니다.",
            "Setting the preset schema({{preset}}) applies all extracted values.": "프리셋 스키마({{preset}})로 설정하면 추출값이 모두 적용됩니다.",
            "Set the preset schema to show it here.": "프리셋 스키마로 설정하면 여기에 표시됩니다.",
            "Do you want to unpublish the public URL?": "공개 URL을 해제하시겠습니까?",
            "Due to CDN cache, it may take up to a few minutes to actually block access.": "CDN 캐시로 인해 실제 차단까지 최대 수 분이 걸릴 수 있습니다.",
            "Each URL stays the same even if you update the file.": "파일을 업데이트해도 각 URL은 동일하게 유지됩니다.",
            "Failed to copy the URL.": "URL 복사에 실패했습니다.",
            "Failed to open the URL.": "URL 열기에 실패했습니다.",
            "Failed to publish. Please try again later.": "게시에 실패했습니다. 잠시 후 다시 시도해 주세요.",
            "Failed to publish. Unpublish and try publishing again.": "게시에 실패했습니다. 게시 해제 후 다시 게시해 주세요.",
            "Failed to unpublish. Please try again later.": "게시 해제에 실패했습니다. 잠시 후 다시 시도해 주세요.",
            "Publishing the public URL has been requested.": "공개 URL 게시를 요청했습니다.",
            "Publishing {{count}} captions has been requested.": "자막 {{count}}개 게시를 요청했습니다.",
            "Publishing {{count}} images has been requested.": "이미지 {{count}}개 게시를 요청했습니다.",
            "The public URL has been copied.": "URL이 복사되었습니다.",
            "The public URL has been unpublished.": "공개 URL이 해제되었습니다.",
            "The public URL of <0>{{target}}</0> will no longer be accessible.": "<0>{{target}}</0>의 공개 URL이 더 이상 접근되지 않습니다.",
            "There is no published asset.": "공개 중인 자산이 없습니다.",
            "This asset is published via CDN. The issued URL stays the same even if you update the file.": "이 자산을 CDN을 통해 공개합니다. 발급된 URL은 파일을 업데이트해도 동일하게 유지됩니다.",
            "To share privately with specific users, use <0>Actions → Share link</0>.": "특정 사용자에게 비공개로 임시 공유하려면 <0>동작 → 링크</0> 공유를 이용하세요.",
            "Failed to load the public URL list.": "공개 URL 목록을 불러오지 못했습니다.",
            "You do not have permission to publish this asset.": "이 자산을 게시할 권한이 없습니다.",
            "{{count}} captions have been unpublished.": "자막 {{count}}개가 해제되었습니다.",
            "{{count}} images have been unpublished.": "이미지 {{count}}개가 해제되었습니다.",
            "Invalid pattern.": "형식이 올바르지 않습니다.",
            "This field should be a number.": "이 필드는 숫자여야 합니다.",
            "This field can be from {{min}} characters.": "이 필드는 {{min}}자부터 입력 가능합니다.",
            "This field can be up to {{max}}.": "이 필드는 최대 {{max}}까지 입력 가능합니다.",
            "This field can be at least {{min}}.": "이 필드는 최소 {{min}} 이상이어야 합니다.",
            "Duplicate value.": "중복된 값입니다.",
            "Already exists. Try something else.": "이미 존재합니다. 다른 값을 사용하세요.",
            "If you detach <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to detach <0>{{name}}</0>?": "<0>{{name}}</0>을(를) 분리하면 되돌릴 수 없습니다.<1/>정말 <0>{{name}}</0>을(를) 분리하시겠습니까?",
            "The asset has <0>{{count}}</0> elements attached.<1/>If the asset is detached, the elements are also detached.": "이 에셋에는 <0>{{count}}</0>개의 요소가 연결되어 있습니다.<1/>에셋을 분리하면 요소도 함께 분리됩니다.",
            "Remove connected MediaLive input.": "연결된 MediaLive 입력을 제거합니다.",
            "<0>{{name}}</0> is in use.<1/> If you delete this template, you won’t be able to revert this.<1/> Are you sure you want to delete?": "<0>{{name}}</0>은(는) 사용 중입니다.<1/> 이 템플릿을 삭제하면 되돌릴 수 없습니다.<1/> 정말 삭제하시겠습니까?",
            "Empty values must be filled in when actually used.": "실제 사용할 경우에는 비워져 있는 값은 필수로 입력해야 합니다.",
            "If you delete <0>{{count}}</0> other than <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to delete <0>{{count}}</0> other than <0>{{name}}</0>?": "<0>{{name}}</0> 외 <0>{{count}}</0>개를 삭제하면 되돌릴 수 없습니다.<1/>정말 <0>{{name}}</0> 외 <0>{{count}}</0>개를 삭제하시겠습니까?",
            "If you remove all shares on <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to remove all shares on <0>{{name}}</0>?": "<0>{{name}}</0>의 공유를 모두 해제하면 되돌릴 수 없습니다.<1/>정말 <0>{{name}}</0>의 공유를 모두 해제하시겠습니까?",
            "If you remove all shares on <0>{{count}}</0> other than <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to remove all shares on <0>{{count}}</0> other than <0>{{name}}</0>?": "<0>{{name}}</0> 외 <0>{{count}}</0>개의 공유를 모두 해제하면 되돌릴 수 없습니다.<1/>정말 <0>{{name}}</0> 외 <0>{{count}}</0>개의 공유를 모두 해제하시겠습니까?",
            "If you remove <0>{{name}}</0>, the item is deleted from the view.<1/>Other users will still have access.<1/>Are you sure you want to remove the item?": "<0>{{name}}</0>을(를) 제거하면 목록에서 삭제됩니다.<1/>다른 사용자는 계속 접근할 수 있습니다.<1/>정말 항목을 제거하시겠습니까?",
            "If you remove <0>{{count}}</0> other than <0>{{name}}</0>, the item is deleted from the view.<1/>Other users will still have access.<1/>Are you sure you want to remove the item?": "<0>{{name}}</0> 외 <0>{{count}}</0>개를 제거하면 목록에서 삭제됩니다.<1/>다른 사용자는 계속 접근할 수 있습니다.<1/>정말 항목을 제거하시겠습니까?",
            "Share request completed": "공유 요청이 완료되었습니다.",
            "The selected item is restored": "선택한 항목이 복원되었습니다.",
            "Error occurs!": "오류가 발생했습니다.",
            "Create Completed.": "생성이 완료되었습니다.",
            "Overlap other processing": "다른 처리와 겹칩니다.",
            "Users and teams added.": "사용자와 팀이 추가되었습니다.",
            "Please enter the subject.": "제목을 입력하세요.",
            "Lineups still exist on date": "해당 날짜에 라인업이 남아 있습니다.",
            "Approval completed.": "승인이 완료되었습니다.",
            "Rejection completed.": "반려가 완료되었습니다.",
            "The Shared with list is Changed": "공유 대상 목록이 변경되었습니다.",
            "The selected item is Approved": "선택한 항목이 승인되었습니다.",
            "The selected item is Rejected": "선택한 항목이 반려되었습니다.",
            "The selected item is Deleted": "선택한 항목이 삭제되었습니다.",
            "This page isn't working. {{line}} Please contact the manager.": "이 페이지는 동작하지 않습니다. {{line}} 관리자에게 문의하세요.",
            "Select {{resourceType}} through search to put them in your content.": "검색을 통해 {{resourceType}}을(를) 선택하여 콘텐츠에 넣으세요.",
            "Words to display - You can enter English, numbers, spaces, and special characters (~\\!@#$%^&*()-_=+[{]}\\|;:'”,<.>/?).": "표시할 단어 - 영문, 숫자, 공백, 특수문자(~\\!@#$%^&*()-_=+[{]}\\|;:'”,<.>/?)를 입력할 수 있습니다.",
            "Words similar to spoken sounds - Only English, -(Hyphen) can be entered.": "음성소리와 유사한 단어 - 영어, -(하이픈)만 입력할 수 있습니다.",
            "Words to display - You can enter Korean, English, numbers, spaces, and special characters (~\\!@#$%^&*()-_=+[{]}\\|;:'”,<.>/?).": "표시할 단어 - 한글, 영문, 숫자, 공백, 특수문자(~\\!@#$%^&*()-_=+[{]}\\|;:'”,<.>/?)를 입력할 수 있습니다.",
            "Deletion of vocabulary phrase {{item}} has been completed.": "단어 {{item}}의 삭제가 완료되었습니다.",
            "Deletion of vocabulary phrase {{item}} and {{count}} others has been completed.": "단어 {{item}} 외 {{count}}개의 삭제가 완료되었습니다.",
            "Failed to load analysis results.": "분석 결과를 불러오지 못했습니다.",
            "There are no video segments to edit for the selected labels.": "선택한 라벨에 편집할 수 있는 구간이 없습니다.",
            "Imported {{segmentCount}} segments of {{labels}} selected in {{engine}} as edit segments.": "<2>{{engine}}</2>에서 선택한 <1>{{labels}}</1>의 등장 구간 <0>{{segmentCount}}개</0>를 편집 구간으로 가져왔습니다.",
            "You can select up to {{max}} labels.": "최대 {{max}}개까지 선택할 수 있습니다.",
            "All {{max}} timestamps selected. Deselect one to add another.": "타임스탬프를 {{max}}개 모두 선택했습니다. 더 추가하려면 선택을 해제하세요.",
            "AI analysis uses the proxy video.": "AI 분석에 프록시 영상을 사용합니다.",
            "Creating a proxy video. Analyzing now uses the original and takes longer.": "프록시 영상을 만들고 있습니다. 지금 분석하면 원본으로 처리되어 더 오래 걸립니다.",
            "The proxy video could not be created. AI analysis will use the original.": "프록시 영상을 만들지 못했습니다. AI 분석은 원본으로 처리됩니다.",
            "The proxy video is used by AI Analysis, AI Workspace, and the Adobe plugin.": "프록시 영상은 AI 분석, AI 워크스페이스, Adobe 플러그인에서 쓰입니다.",
            "Without it, AI Analysis runs on the original and can be slow or fail on size limits, and the Adobe plugin downloads the original file. This choice applies to assets created from now on.": "없으면 AI 분석은 원본으로 처리되어 느리거나 용량 제한으로 실패할 수 있고, Adobe 플러그인은 원본을 그대로 내려받습니다. 이 선택은 앞으로 만들어지는 자산부터 적용됩니다.",
            "No proxy video. Proxy auto-generation applies only to videos registered after it was selected.": "프록시 영상이 없습니다. 프록시 자동 생성은 켠 뒤 등록된 영상에만 적용됩니다.",
            "Proxy video - a small copy used for AI analysis and preview.": "프록시 영상 — AI 분석·미리보기에 쓰는 저용량 사본입니다.",
            "The start date must be on or before the end date.": "시작일은 종료일과 같거나 앞선 날짜여야 합니다.",
            "Finish or cancel the field being edited before saving.": "편집 중인 필드를 완료하거나 취소한 뒤 저장할 수 있습니다.",
            "This value is not one of the allowed options.": "허용된 옵션에 없는 값입니다.",
            "Assets closer to the top <0>match your search more accurately</0>.": "위쪽일수록 검색어와 <0>더 정확히 일치</0>하는 자산입니다.",
            "Requests that failed. The file may have been deleted or the URL may have been unpublished.": "실패한 요청 수입니다. 파일이 삭제되었거나 URL 게시가 해제되었을 수 있습니다."
        },
        "code": {
            "WORKFLOW_EMPTY_TREE_INCOMPLETE": "워크플로우가 비어 있습니다.",
            "WORKFLOW_MISSING_TRIGGER_INCOMPLETE": "트리거(TRIGGER) 스텝이 필요합니다.",
            "WORKFLOW_MISSING_END_INCOMPLETE": "종료(END) 스텝이 필요합니다.",
            "WORKFLOW_MISSING_TASK_INCOMPLETE": "작업(TASK) 스텝을 1개 이상 추가해야 합니다.",
            "WORKFLOW_START_NO_NEXT_INCOMPLETE": "시작(START) 스텝에는 다음 스텝이 연결되어야 합니다.",
            "WORKFLOW_UNTERMINATED_PATH_INCOMPLETE": "모든 경로는 종료(END) 스텝으로 끝나야 합니다.",
            "WORKFLOW_CHOICE_NO_NEXT_INCOMPLETE": "조건(CHOICE) 스텝에는 다음 스텝이 연결되어야 합니다.",
            "WORKFLOW_BRANCH_COUNT_INCOMPLETE": "병렬 블록은 2~5개의 분기가 필요합니다. 분기를 더 추가해 주세요.",
            "WORKFLOW_BRANCH_COUNT_FATAL": "병렬 블록의 분기는 2~5개만 허용됩니다.",
            "WORKFLOW_SHAPE_UNKNOWN_KEY_FATAL": "스텝에 허용되지 않은 속성이 있습니다.",
            "WORKFLOW_SHAPE_NAME_FATAL": "스텝 이름이 올바르지 않습니다.",
            "WORKFLOW_SHAPE_SCHEMA_FATAL": "스텝 스키마 정보가 올바르지 않습니다.",
            "WORKFLOW_SHAPE_CONDITION_FATAL": "스텝 조건 형식이 올바르지 않습니다.",
            "WORKFLOW_SHAPE_NEXT_FATAL": "스텝의 다음 연결 구조가 올바르지 않습니다.",
            "WORKFLOW_SHAPE_STEP_FATAL": "연결된 스텝의 구조가 올바르지 않습니다.",
            "WORKFLOW_NODE_CAP_FATAL": "워크플로우가 허용된 최대 스텝 수를 초과했습니다.",
            "WORKFLOW_BRANCH_NODE_CAP_FATAL": "병렬 분기가 허용된 최대 스텝 수를 초과했습니다.",
            "WORKFLOW_ROOT_NOT_START_FATAL": "워크플로우는 시작(START) 스텝으로 시작해야 합니다.",
            "WORKFLOW_DUPLICATE_START_FATAL": "시작(START) 스텝은 하나만 존재할 수 있습니다.",
            "WORKFLOW_DUPLICATE_TRIGGER_FATAL": "트리거(TRIGGER) 스텝은 하나만 존재할 수 있습니다.",
            "WORKFLOW_DUPLICATE_END_FATAL": "종료(END) 스텝은 하나만 존재할 수 있습니다.",
            "WORKFLOW_TRIGGER_NOT_AFTER_START_FATAL": "시작(START) 스텝 바로 다음에는 트리거(TRIGGER) 스텝이 와야 합니다.",
            "WORKFLOW_DUPLICATE_NAME_FATAL": "스텝 이름은 중복될 수 없습니다.",
            "WORKFLOW_MULTIPLE_PARALLEL_FATAL": "병렬 블록은 하나만 사용할 수 있습니다.",
            "WORKFLOW_NAME_CHARSET_FATAL": "스텝 이름에 사용할 수 없는 문자가 포함되어 있습니다.",
            "WORKFLOW_NAME_RESERVED_PREFIX_FATAL": "스텝 이름은 예약된 접두사(\"__\")로 시작할 수 없습니다.",
            "WORKFLOW_UNKNOWN_SCHEMA_FATAL": "스텝의 스키마가 카탈로그에 존재하지 않습니다.",
            "WORKFLOW_CONDITION_SPEC_DEFERRED": "스텝의 조건이 필수 사양을 충족하지 않습니다.",
            "WORKFLOW_END_HAS_NEXT_FATAL": "종료(END) 스텝에는 다음 스텝을 연결할 수 없습니다.",
            "WORKFLOW_START_BRANCHES_FATAL": "시작(START) 스텝은 병렬 블록으로 바로 분기할 수 없습니다.",
            "WORKFLOW_NEXT_IS_START_FATAL": "다른 스텝에서 시작(START) 스텝으로 연결할 수 없습니다.",
            "WORKFLOW_NESTED_PARALLEL_FATAL": "병렬 블록은 중첩할 수 없습니다.",
            "WORKFLOW_NOT_PARALLELIZABLE_FATAL": "이 스텝은 병렬 분기로 사용할 수 없습니다.",
            "WORKFLOW_FORBIDDEN_IN_BRANCH_FATAL": "시작(START)·트리거(TRIGGER)·종료(END) 스텝은 병렬 분기 내부에 사용할 수 없습니다.",
            "WORKFLOW_INPUT_NOT_SATISFIED_DEFERRED": "이전 스텝의 출력만으로는 스텝의 입력 조건을 충족할 수 없습니다.",
            "WORKFLOW_DSL_NOT_BINDABLE_FATAL": "이 필드에는 DSL 바인딩을 사용할 수 없습니다.",
            "WORKFLOW_DSL_MALFORMED_DEFERRED": "DSL 바인딩 형식이 올바르지 않습니다.",
            "WORKFLOW_DSL_TARGET_NOT_FOUND_DEFERRED": "DSL 바인딩이 존재하지 않는 스텝 또는 출력을 참조하고 있습니다.",
            "WORKFLOW_DSL_OUT_OF_SCOPE_DEFERRED": "DSL 바인딩이 참조할 수 없는 범위의 스텝을 가리키고 있습니다.",
            "OPERATION_ERROR": "스토리지 작업이 실패하였습니다.",
            "OPERATION_COMPLETED": "스토리지 작업이 성공적으로 수행되었습니다.",
            "OPERATION_PARTIAL_COMPLETED": "스토리지 작업이 수행 되었으나 실패한 작업이 존재합니다.",
            "SUCCESS": "작업이 성공하였습니다.",
            "S3_OPERATION_FAIL": "스토리지에 작업이 실패하였습니다.",
            "NOT_EXIST_OBJECT_FROM_S3": "스토리지에 파일이 존재하지 않습니다.",
            "NOT_EXIST_OBJECT_FROM_SOURCE_DB": "인덱스 DB에 레코드가 존재하지 않습니다.",
            "OVERLAP_OTHER_PROCESSING": "파일이 작업중이기 때문에 작업을 수행할 수 없습니다.",
            "FAIL_TO_CHANGE_STATUS": "파일 상태 변경 중 에러가 발생하였습니다.",
            "USER_DECISION_REQUIRED": "파일의 중복이 발생하여 덮어쓰기 또는 건너뛰기의 사용자 선택이 필요합니다.",
            "UNKNOWN_ERROR": "알 수 없는 에러가 발생하였습니다.",
            "DOWNLOAD_JOB_REJECTED_BY_SIZE": "다운로드 작업이 파일 크기 제한으로 인해 거절되었습니다.",
            "DOWNLOAD_JOB_REJECTED_BY_COUNT": "다운로드 작업이 파일 개수 제한으로 인해 거절되었습니다.",
            "DOWNLOAD_JOB_REJECTED_BY_FOLDER": "다운로드 작업이 요청에 폴더가 포함된 것으로 인해 거절되었습니다.",
            "RESOURCE_NOT_FOUND": "파일이 존재하지 않습니다.",
            "OPERATION_FAILED": "다운로드 작업이 실패하였습니다.",
            "OPERATION_ABORTED": "다운로드 작업이 중단되었습니다.",
            "INTERNAL_ERROR": "내부 오류가 발생하였습니다.",
            "CPA_INFO_PANEL_ASSETS_DESC_1": "자산은 디지털 방식으로 저장할 수 있는 모든 콘텐츠 파일이며, 파일에 대한 메타데이터가 포함되어 있습니다.",
            "CPA_INFO_PANEL_ASSETS_DESC_2": "자산 페이지에서는 등록한 자산의 목록을 확인하고, \"자산 추가\"를 통해 파일을 업로드하여 자산으로 만들거나 기존 자산의 정보를 수정/관리/다운로드할 수 있습니다.",
            "CPA_INFO_PANEL_ASSETS_ACTIONS_DESC": "<H4>동작</H4>\n파일을 자산으로 만들어 관리함으로써 다음과 같은 동작을 수행할 수 있습니다.\n<List>\n<ListItem>다양한 파일 유형의 이미지, 문서, 오디오 파일 및 비디오 파일을 추가</ListItem>\n<ListItem>파일에 대한 메타데이터 정보를 추가하거나 편집</ListItem>\n<ListItem>태그 또는 폴더를 통해 자산을 그룹화하여 자산을 관리</ListItem>\n<ListItem>에셋 이름, ID, 확장자, 파일 유형, 소유자, 생성일, 태그를 통한 검색</ListItem>\n</List>",
            "CPA_INFO_PANEL_ASSETS_GRID_DESC": "<H4>그리드/목록 레아이웃</H4>\n자산 목록은 그리드 또는 목록 레이아웃으로 확인할 수 있으며 목록 레이아웃으로 설정 시, 테이블의 열을 사용자가 직접 지정하여 노출 여부를 설정할 수 있습니다.\n(이름, 유형, 사이즈, 접근 권한, 소유자, 생성일, 마지막 수정일) ",
            "CPA_INFO_PANEL_ASSETS_ADD_DESC": "<H4>자산 추가</H4>\n\"자산 추가\" 버튼을 클릭하거나, 파일을 목록으로 드래그 앤 드롭을 하여 파일을 자산으로 만들 수 있습니다.",
            "CPA_INFO_PANEL_ASSET_DETAIL_DESC": "자산 상세에서는 자산의 세부 정보를 확인할 수 있습니다.",
            "CPA_INFO_PANEL_ASSET_DETAIL_OVERVIEW_DESC": "<H4>개요</H4>\n개요는 자산의 기본 세부 정보를 확인할 수 있으며, 접근 권한과 폴더 위치를 수정할 수 있습니다.",
            "CPA_INFO_PANEL_ASSET_DETAIL_METADATA_DESC": "<H4>메타데이터</H4>\n메타데이터는 속성과 태그를 확인 및 수정할 수 있습니다.",
            "CPA_INFO_PANEL_ASSET_DETAIL_ACTION_DESC": "<H4>동작</H4>\n해당 자산을 '다운로드/아카이브/삭제'할 수 있습니다. ",
            "CPA_INFO_PANEL_ASSET_DETAIL_ARCHIVE_DESC": "<H4>아카이브</H4>\n아카이브 옵션은 프로젝트 관리자가 프로젝트 설정에서 설정할 수 있으며, S3 Glacier Flexible Retrieval / S3 Glacier Deep Archive 중 하나를 선택하여 사용할 수 있습니다.<NewLine/> \n아카이브 된 파일은 요금이 저렴한 대신, 복구하는데 시간이 소요됩니다.",
            "CPA_INFO_PANEL_ASSET_SEARCH_DESC": "자산 목록에서 검색한 결과를 확인할 수 있습니다.<NewLine/>\n검색바에서 자산 이름으로 검색하거나 검색 옵션 창을 열어 세부 검색 조건을 적용하여 검색을 할 수 있습니다.",
            "CPA_INFO_PANEL_ASSET_SEARCH_OPTIONS_DESC": "<H4>검색 옵션<H4/>\n검색 옵션에는 자산의 이름, ID, 확장자, 유형, 소유자, 생성일, 태그가 있으며, 원하는 세부 옵션을 적용하여 자산의 세부 검색을 할 수 있습니다.",
            "CPA_INFO_PANEL_ASSET_SEARCH_GO_TO_DESC": "<H4>목록으로 가기</H4>\n자산 목록으로 돌아가려면 '목록으로 가기(←)' 버튼을 클릭하면 됩니다.",
            "CPA_INFO_PANEL_ADD_ASSETS_DESC": "여러 다양한 파일 유형을 자산으로 만들 수 있습니다. ",
            "CPA_INFO_PANEL_ADD_ASSETS_DETAILS_DESC": "<H4>자산 상세 정보</H4>\n파일을 직접 탐색하거나 드래그 앤 드롭한 후 선택된 파일을 확인하고, 선택된 파일의 이름을 원하는 자산 이름을 변경할 수 있습니다.<NewLine/> \n그리고 자산의 접근 권한 여부 선택 및 메타데이터를 작성하여 자산으로 등록할 수 있습니다. ",
            "CPA_INFO_PANEL_ADD_ASSETS_ACCESS_DESC": "<H4>접근 권한</H4>\n접근 권한은 공개/비공개로 선택할 수 있습니다.<NewLine/> \n공개를 선택 시 모두에게 공개되며, 비공개를 선택 시 모두에게 비공개 처리 됩니다.",
            "Project:Assets:Archive": "자산 아카이브 권한입니다.",
            "Project:Assets:Edit": "자산 편집 권한입니다.",
            "Project:Assets:Read": "자산 읽기 권한입니다.",
            "Project:Categories:Edit": "카테고리 편집 권한입니다.",
            "Project:Categories:Read": "카테고리 읽기 권한입니다.",
            "Project:Channels:Edit": "채널 편집 권한입니다.",
            "Project:Channels:Read": "채널 읽기 권한입니다.",
            "Project:Comments:Edit": "댓글 편집 권한입니다.",
            "Project:Comments:Read": "댓글 읽기 권한입니다.",
            "Project:CustomContents:Edit": "커스텀 콘텐츠 편집 권한입니다.",
            "Project:CustomContents:Read": "커스텀 콘텐츠 읽기 권한입니다.",
            "Project:Dashboard:Edit": "대시보드 편집 권한입니다.",
            "Project:Dashboard:Read": "대시보드 읽기 권한입니다.",
            "Project:Download:Download": "다운로드 권한입니다.",
            "Project:Folders:Edit": "폴더 편집 권한입니다.",
            "Project:Folders:Read": "폴더 읽기 권한입니다.",
            "Project:IntegratedSearch:Read": "통합 검색 읽기 권한입니다.",
            "Project:InteractiveVideos:Edit": "인터랙티브 비디오 편집 권한입니다.",
            "Project:InteractiveVideos:Read": "인터랙티브 비디오 읽기 권한입니다.",
            "Project:Music:Edit": "뮤직 편집 권한입니다.",
            "Project:Music:Read": "뮤직 읽기 권한입니다.",
            "Project:People:Edit": "인물 편집 권한입니다.",
            "Project:People:Read": "인물 읽기 권한입니다.",
            "Project:Photo:Edit": "포토 편집 권한입니다.",
            "Project:Photo:Read": "포토 읽기 권한입니다.",
            "Project:Shares:External": "링크 공유 권한입니다.",
            "Project:Shares:Internal": "내부 공유 권한입니다.",
            "Project:Statistics:Edit": "통계 편집 권한입니다.",
            "Project:Statistics:Read": "통계 읽기 권한입니다.",
            "Project:Storages:Edit": "저장소 편집 권한입니다.",
            "Project:Storages:Read": "저장소 읽기 권한입니다.",
            "Project:Users&Groups:Read": "사용자 및 그룹 읽기 권한입니다.",
            "Project:Videos:Edit": "비디오 편집 권한입니다.",
            "Project:Videos:Publish": "비디오 게시 권한입니다.",
            "Project:Videos:Read": "비디오 읽기 권한입니다.",
            "Project:Shares:InternalRequest": "내부 요청 권한입니다."
        },
        "audit": {
            "Retrieve list of Actions": "액션 목록 조회",
            "Retrieve list of AI Face collections": "AI 얼굴 컬렉션 목록 조회",
            "Delete AI Face collection": "AI 얼굴 컬렉션 삭제",
            "Update AI Face collection": "AI 얼굴 컬렉션 수정",
            "Retrieve list of archived assets": "보관 완료된 자산 목록 조회",
            "Retrieve archived asset details": "보관 완료된 자산 상세 조회",
            "Restore archived asset": "보관 완료된 자산에 대한 복원 요청",
            "Retrieve list of assets": "자산 목록 조회",
            "Create asset": "자산 생성",
            "Retrieve asset details": "자산 상세 조회",
            "Update asset": "자산 수정",
            "Delete asset": "자산 삭제",
            "Activate asset": "자산 활성화",
            "Archive asset": "자산 보관 요청",
            "Create file in asset": "자산에 파일 생성",
            "Add files to asset": "자산에 파일 추가",
            "Delete file from asset": "자산에서 파일 삭제",
            "Update file in asset": "자산의 파일 수정",
            "Update tags of asset": "자산의 태그 수정",
            "Delete tag from asset": "자산에서 태그 삭제",
            "Inactivate asset": "자산 비활성화",
            "Attach People to asset": "자산에 인물 연결",
            "Detach People from asset": "자산에서 인물 연결 해제",
            "Retrieve asset status": "자산 상태 조회",
            "Retrieve upload URL for asset": "자산 업로드용 URL 발급",
            "Retrieve list of audit logs": "관리 감사 로그 목록 조회",
            "Retrieve audit log details": "관리 감사 로그 상세 조회",
            "Send HEAD request to storage file": "저장소 파일에 HEAD 요청",
            "Retrieve list of category groups": "카테고리 그룹 목록 조회",
            "Retrieve category group details": "카테고리 그룹 상세 조회",
            "Update category group": "카테고리 그룹 수정",
            "Delete category group": "카테고리 그룹 삭제",
            "Retrieve list of categories": "카테고리 목록 조회",
            "Create category": "카테고리 생성",
            "Delete categories in bulk": "카테고리 대량 삭제",
            "Retrieve category details": "카테고리 상세 조회",
            "Update category": "카테고리 수정",
            "Delete category": "카테고리 삭제",
            "Retrieve list of CDNs": "CDN 목록 조회",
            "Create CDN": "CDN 생성",
            "Retrieve CDN details": "CDN 상세 조회",
            "Update CDN": "CDN 수정",
            "Delete CDN": "CDN 삭제",
            "Retrieve list of channels": "채널 목록 조회",
            "Create channel": "채널 생성",
            "Retrieve channel details": "채널 상세 조회",
            "Update channel": "채널 수정",
            "Delete channel": "채널 삭제",
            "Update channel case": "채널 요청 사유 수정",
            "Retrieve list of channel inputs": "채널 인풋 목록 조회",
            "Retrieve channel input details": "채널 인풋 상세 조회",
            "Retrieve channel encoder details": "채널 인코더 정보 상세 조회",
            "Reclaim channel": "채널 회수",
            "Request channel approval": "채널 승인 요청",
            "Retrieve list of channel schedules": "채널 자동시작 일정 목록 조회",
            "Update channel schedules in bulk": "채널 자동시작 일정 대량 수정",
            "Delete channel schedules in bulk": "채널 자동시작 일정 대량 삭제",
            "Delete channel schedule": "채널 자동시작 일정 삭제",
            "Retrieve channel schedule details": "채널 자동시작 일정 상세 조회",
            "Update channel schedule": "채널 자동시작 일정 수정",
            "Start channel": "채널 시작",
            "Retrieve channel state": "채널 상태 조회",
            "Stop channel": "채널 중지",
            "Request DRM token for video": "영상 재생을 위한 DRM 토큰 요청",
            "Retrieve Presigned URL of Master file for container format video": "컨테이너 형식의 영상의 Master 파일의 Presigned URL 조회",
            "Retrieve Presigned URL of Daughter file for container format video": "컨테이너 형식의 영상의 Daughter 파일의 Presigned URL 조회",
            "Retrieve list of transcode jobs": "트랜스코드 작업 목록 조회",
            "Create transcode job": "트랜스코드 작업 생성",
            "Create and start transcode job": "트랜스코드 작업 생성 및 시작 요청",
            "Retrieve upload URL for transcode job": "트랜스코드 작업을 위한 업로드 URL 요청",
            "Retrieve transcode job details": "트랜스코드 작업 상세 조회",
            "Update transcode job": "트랜스코드 작업 수정",
            "Delete transcode job": "트랜스코드 작업 삭제",
            "Cancel transcode job": "트랜스코드 작업 실행 취소",
            "Retrieve transcode job status": "트랜스코드 작업 상태 조회",
            "Correct transcode job status": "트랜스코드 작업 상태 보정",
            "Start transcode job": "트랜스코드 작업 시작 요청",
            "Retrieve list of listings": "리스팅 목록 조회",
            "Create listing": "리스팅 생성",
            "Retrieve listing details": "리스팅 상세 조회",
            "Update listing": "리스팅 수정",
            "Delete listing": "리스팅 삭제",
            "Retrieve list of lineups": "라인업 목록 조회",
            "Create lineup": "라인업 생성",
            "Delete lineups in bulk": "라인업 대량 삭제",
            "Create lineups in bulk": "라인업 대량 생성",
            "Retrieve lineup details": "라인업 상세 조회",
            "Update lineup": "라인업 수정",
            "Delete lineup": "라인업 삭제",
            "Retrieve list of scheduled lineups after current time": "현재 시간 이후의 라인업 목록 조회",
            "Retrieve list of localization resources": "다국어 리소스 목록 조회",
            "Retrieve localization resource details": "다국어 리소스 상세 조회",
            "Retrieve current user information": "사용자(자신) 정보 조회",
            "Retrieve list of Actions allowed for current user in project": "프로젝트에 사용자(자신)에게 허용된 액션 목록 조회",
            "Retrieve list of Actions allowed for current user in space": "스페이스에 사용자(자신)에게 허용된 액션 목록 조회",
            "Request PoPs user synchronization": "PoPs 사용자 동기화 요청",
            "Retrieve list of metadata fields": "메타데이터 필드 목록 조회",
            "Create metadata field": "메타데이터 필드 생성",
            "Retrieve metadata field details": "메타데이터 필드 상세 조회",
            "Update metadata field": "메타데이터 필드 수정",
            "Delete metadata field": "메타데이터 필드 삭제",
            "Retrieve list of metadata schemas": "메타데이터 목록 조회",
            "Create metadata schema": "메타데이터 생성",
            "Register metadata schema": "메타데이터 등록",
            "Retrieve metadata schema details": "메타데이터 상세 조회",
            "Update metadata schema": "메타데이터 수정",
            "Delete metadata schema": "메타데이터 삭제",
            "Retrieve list of People": "인물 목록 조회",
            "Create People": "인물 생성",
            "Update People": "인물 수정",
            "Delete People": "인물 삭제",
            "Retrieve People details": "인물 상세 조회",
            "Retrieve list of transcode pipelines": "트랜스코드 파이프라인 목록 조회",
            "Retrieve transcode pipeline details": "트랜스코드 파이프라인 상세 조회",
            "Retrieve embed URL": "임베드 URL 조회",
            "Retrieve shared URL": "게시 URL 조회",
            "Retrieve list of SNS accounts": "SNS 계정 목록 조회",
            "Create SNS account": "SNS 계정 연결",
            "Retrieve SNS account details": "SNS 계정 상세 조회",
            "Delete SNS account": "SNS 계정 연결 해제",
            "Update SNS account": "SNS 계정 수정",
            "Retrieve SNS posting history": "SNS 포스팅 내역 조회",
            "Retrieve list of videos posted to SNS": "SNS 포스팅된 비디오 목록 조회",
            "Post video to SNS": "SNS에 비디오 포스팅",
            "Retrieve SNS video details": "SNS 비디오 상세 조회",
            "Retrieve transcode profile details": "트랜스코드 프로필 상세 조회",
            "Retrieve list of programmes": "프로그램 목록 조회",
            "Create programme": "프로그램 생성",
            "Retrieve programme details": "프로그램 상세 조회",
            "Update programme": "프로그램 수정",
            "Delete programme": "프로그램 삭제",
            "Retrieve list of projects": "프로젝트 목록 조회",
            "Create project": "프로젝트 생성",
            "Delete project": "프로젝트 삭제",
            "Retrieve project details": "프로젝트 상세 조회",
            "Update project": "프로젝트 수정",
            "Retrieve list of assignable members to project": "프로젝트에 할당 가능한 멤버 목록 조회",
            "Retrieve list of assignable teams to project": "프로젝트에 할당 가능한 그룹 목록 조회",
            "Retrieve list of assigned project members": "프로젝트 멤버 목록 조회",
            "Retrieve list of assigned project teams": "프로젝트 그룹 목록 조회",
            "Retrieve list of project members": "프로젝트 멤버 목록 조회",
            "Assign member to project": "프로젝트에 멤버 할당",
            "Unassign member from project": "프로젝트에서 멤버 할당 해제",
            "Add storages to project": "프로젝트에 스토리지 추가",
            "Update project storages": "프로젝트 스토리지 수정",
            "Retrieve list of project teams": "프로젝트 그룹 목록 조회",
            "Assign team to project": "프로젝트에 그룹 할당",
            "Unassign team from project": "프로젝트에서 그룹 할당 해제",
            "Create player": "플레이어 생성",
            "Retrieve list of players": "플레이어 목록 조회",
            "Create player profile": "플레이어 프로파일 생성",
            "Retrieve list of player profiles": "플레이어 프로파일 목록 조회",
            "Retrieve player profile details": "플레이어 프로파일 상세 조회",
            "Update player profile": "플레이어 프로파일 수정",
            "Delete player profile": "플레이어 프로파일 삭제",
            "Retrieve player details": "플레이어 상세 조회",
            "Update player": "플레이어 수정",
            "Delete player": "플레이어 삭제",
            "Create player resource": "플레이어 리소스 생성",
            "Retrieve list of player resources": "플레이어 리소스 목록 조회",
            "Retrieve player resource details": "플레이어 리소스 상세 조회",
            "Update player resource": "플레이어 리소스 수정",
            "Delete player resource": "플레이어 리소스 삭제",
            "Retrieve upload URL for resource": "리소스 업로드 URL 획득",
            "Create role": "역할 생성",
            "Retrieve list of roles": "역할 목록 조회",
            "Retrieve role details": "역할 상세 조회",
            "Update role": "역할 수정",
            "Delete role": "역할 삭제",
            "Attach permissions to role": "역할에 권한 추가",
            "Retrieve list of permissions in role": "역할의 권한 목록 조회",
            "Detach permission from role": "역할에서 권한 제거",
            "Retrieve list of settings": "설정 목록 조회",
            "Create project settings": "프로젝트 설정 생성",
            "Delete project settings": "프로젝트 설정 삭제",
            "Create space settings": "스페이스 설정 생성",
            "Delete space settings": "스페이스 설정 삭제",
            "Create statistics": "통계 생성",
            "Retrieve list of statistics widget groups": "통계 위젯 그룹 목록 조회",
            "Create statistics widget group": "통계 위젯 그룹 생성",
            "Delete statistics widget group": "통계 위젯 그룹 삭제",
            "Retrieve list of widgets in specific statistics widget group": "특정 통계 위젯 그룹 안의 위젯 목록 조회",
            "Update statistics widgets": "통계 위젯 수정",
            "Retrieve list of statistics widgets": "통계 위젯 목록 조회",
            "Create statistics Aggregation": "통계 Aggregation 생성",
            "Create statistics Feature": "통계 Feature 생성",
            "Create statistics Resource": "통계 Resource 생성",
            "Retrieve list of stream inputs": "스트림 인풋 목록 조회",
            "Create stream input": "스트림 인풋 생성",
            "Retrieve list of whitelists": "화이트리스트 목록 조회",
            "Retrieve stream input details": "스트림 인풋 상세 조회",
            "Update stream input": "스트림 인풋 수정",
            "Delete stream input": "스트림 인풋 삭제",
            "Retrieve list of teams": "그룹 목록 조회",
            "Retrieve team details": "그룹 상세 조회",
            "Retrieve list of team members": "그룹 멤버 목록 조회",
            "Retrieve list of event triggers": "이벤트 트리거 목록 조회",
            "Create event trigger": "이벤트 트리거 생성",
            "Retrieve event trigger details": "이벤트 트리거 상세 조회",
            "Delete event trigger": "이벤트 트리거 삭제",
            "Update event trigger": "이벤트 트리거 수정",
            "Retrieve upload URL for event trigger": "이벤트 트리거 업로드 URL 획득",
            "Retrieve list of users": "사용자 목록 조회",
            "Retrieve user details": "사용자 상세 조회",
            "Update user": "사용자 정보 수정",
            "Delete user": "사용자 삭제",
            "Retrieve list of videos": "비디오 목록 조회",
            "Create video": "비디오 생성",
            "Retrieve video details": "비디오 상세 조회",
            "Update video": "비디오 수정",
            "Delete video": "비디오 삭제",
            "Activate video": "비디오 활성화",
            "Request caption creation via video": "비디오를 통한 자막 생성 요청",
            "Delete caption from video": "비디오의 자막 삭제",
            "Update caption in video": "비디오의 자막 수정",
            "Inactivate video": "비디오 비활성화",
            "Attach People to video": "비디오에 인물 연결",
            "Detach People from video": "비디오에서 인물 연결 해제",
            "Create posters for video in bulk": "비디오 포스터 대량 생성",
            "Delete poster from video": "비디오 포스터 삭제",
            "Create SNS posting for video": "비디오 SNS 포스팅 생성",
            "Retrieve video status": "비디오 상태 조회",
            "Retrieve Thumbnail profiles for video": "비디오 썸네일 프로필 조회",
            "Create category group": "카테고리 그룹 생성",
            "Retrieve list of Resource Buckets": "리소스 버킷 목록 조회",
            "Create Resource Buckets in bulk": "리소스 버킷 대량 생성",
            "Retrieve list of files in asset": "자산의 파일 목록 조회",
            "Retrieve list of Searchable Buckets": "검색 버킷 목록 조회",
            "Create Searchable Bucket": "검색 버킷 생성",
            "Delete Searchable Bucket": "검색 버킷 삭제",
            "Retrieve Searchable Bucket details": "검색 버킷 상세 조회",
            "Update Searchable Bucket": "검색 버킷 수정",
            "Register Searchable Bucket": "검색 버킷 등록",
            "Delete schedule": "일정 삭제",
            "Retrieve list of asset types": "자산 유형 목록 조회",
            "Create asset type": "자산 유형 생성",
            "Retrieve list of asset extensions": "자산 확장자 목록 조회",
            "Create asset extension": "자산 확장자 생성",
            "Retrieve schedule details": "일정 상세 조회",
            "Retrieve list of schedules": "일정 목록 조회",
            "Delete schedules in bulk": "일정 삭제",
            "Update schedule": "일정 수정",
            "Create schedules in bulk": "일정 대량 생성",
            "Start schedule": "일정 시작 요청",
            "Stop schedule": "일정 중지 요청",
            "Lock schedule": "일정 잠금 요청",
            "End schedule": "일정 종료 요청",
            "Request asset download": "자산 다운로드 요청",
            "Retrieve asset download details": "자산 다운로드 상세 조회",
            "Retrieve schedule history details": "일정 히스토리 상세 조회",
            "Retrieve list of schedule histories": "일정 히스토리 목록 조회",
            "Retrieve hidden metadata field value": "감춤 처리된 필드 값 조회",
            "Retrieve list of shared configurations for video": "비디오 게시 구성 목록 조회",
            "Create shared configuration for video": "비디오 게시 구성 생성",
            "Retrieve shared configuration details for video": "비디오 게시 구성 상세 조회",
            "Update shared configuration for video": "비디오 게시 구성 수정",
            "Delete shared configuration from video": "비디오 게시 구성 삭제",
            "Retrieve list of content schemas": "콘텐츠 스키마 목록 조회",
            "Attach teaser images to video in bulk": "비디오 티져 이미지 대량 연결",
            "Detach teaser image from video": "비디오 티져 이미지 연결 해제",
            "Attach teaser videos to video in bulk": "비디오 티져 비디오 대량 연결",
            "Detach teaser video from video": "비디오 티져 비디오 연결 해제",
            "Retrieve list of music": "뮤직 목록 조회",
            "Retrieve music details": "뮤직 상세 조회",
            "Update music": "뮤직 수정",
            "Delete music": "뮤직 삭제",
            "Create music": "뮤직 생성",
            "Add file to music": "뮤직에 파일 추가",
            "Update file in music": "뮤직의 파일 수정",
            "Delete file from music": "뮤직에서 파일 삭제",
            "Retrieve list of photos": "포토 목록 조회",
            "Retrieve photo details": "포토 상세 조회",
            "Update photo": "포토 수정",
            "Delete photo": "포토 삭제",
            "Create photo": "포토 생성",
            "Add file to photo": "포토에 파일 추가",
            "Update file in photo": "포토의 파일 수정",
            "Delete file from photo": "포토에서 파일 삭제",
            "Retrieve asset file download link": "자산 파일 다운로드 링크 요청",
            "Retrieve download information": "다운로드 정보 조회",
            "Search": "통합 검색",
            "Retrieve list of attributions": "어트리뷰트 목록 조회",
            "Create attribution": "어트리뷰트 생성",
            "Retrieve attribution details": "어트리뷰트 상세 조회",
            "Update attribution": "어트리뷰트 수정",
            "Delete attribution": "어트리뷰트 삭제",
            "Retrieve list of asset files": "자산의 파일 목록 조회",
            "Retrieve list of file versions in asset": "자산의 파일 버젼 목록 조회",
            "Attach categories to asset in bulk": "자산에 카테고리 설정",
            "Detach categories from asset in bulk": "자산에서 카테고리 해제",
            "Retrieve list of attribution keys": "어트리뷰트 키 목록 조회",
            "Update owner of asset": "자산의 소유자 변경",
            "Retrieve dashboard data": "대시보드 데이터 조회",
            "Retrieve list of Actions for role": "역할의 액션 목록 조회",
            "Retrieve list of file meta keys": "자산의 파일 메타 키 목록 조회",
            "Update project member": "프로젝트 멤버 수정",
            "Update project team": "프로젝트 그룹 수정",
            "Retrieve list of related contents in asset": "자산의 연관된 콘텐츠 목록 조회",
            "Retrieve list of asynchronous Jobs": "비동기 작업 목록 조회",
            "Create asynchronous Job": "비동기 작업 생성",
            "Update asynchronous Job": "비동기 작업 수정",
            "Create asynchronous Job Action": "비동기 작업 액션 생성",
            "Retrieve list of Tasks in asynchronous Job": "비동기 작업의 태스크 목록 조회",
            "Create Task in asynchronous Job": "비동기 작업에 태스크 생성",
            "Update Task in asynchronous Job": "비동기 작업의 태스크 수정",
            "Request action on specific storage": "특정 스토리지에 액션 요청",
            "Retrieve asynchronous Job details": "비동기 작업 상세 조회",
            "Retrieve asynchronous Job Alias": "비동기 작업 Alias 조회",
            "Create Alias for asynchronous Job": "비동기 작업에 Alias\"생성",
            "Retrieve list of asynchronous Job Types": "비동기 작업 유형 목록 조회",
            "Create asynchronous Job Type": "비동기 작업 유형 생성",
            "Retrieve asynchronous Job Type details": "비동기 작업 유형 상세 조회",
            "Update asynchronous Job Type": "비동기 작업 유형 수정",
            "Delete asynchronous Job Type": "비동기 작업 유형 삭제",
            "Retrieve list of Actions in asynchronous Job Type": "비동기 작업 유형의 액션 목록 조회",
            "Create Action in asynchronous Job Type": "비동기 작업 유형에 액션 생성",
            "Update Action in asynchronous Job Type": "비동기 작업 유형의 액션 수정",
            "Delete Action in asynchronous Job Type": "비동기 작업 유형의 액션 삭제",
            "Update music in bulk": "뮤직 대량 수정",
            "Update photos in bulk": "포토 대량 수정",
            "Retrieve list of hidden metadata": "메타데이터에서 숨겨진 메타데이터 목록 조회",
            "Update People in bulk": "인물 대량 수정",
            "Retrieve list of item sets for metadata": "메타데이터용 항목 세트 목록 조회",
            "Create item set for metadata": "메타데이터용 항목 세트 생성",
            "Update item set for metadata": "메타데이터용 항목 세트 수정",
            "Delete item set for metadata": "메타데이터용 항목 세트 삭제",
            "Retrieve list of elements in item set": "메타데이터용 항목 세트의 항목 목록 조회",
            "Update videos in bulk": "비디오 대량 수정",
            "Start asynchronous Job": "비동기 작업 시작 처리",
            "Complete asynchronous Job": "비동기 작업 완료 처리",
            "Start Task in asynchronous Job": "비동기 작업의 태스크 시작 처리",
            "Complete Task in asynchronous Job": "비동기 작업의 태스크 완료 처리",
            "Create asynchronous Job Alias": "비동기 작업 Alias 생성",
            "Retrieve asynchronous Job Alias details": "비동기 작업 Alias 목록 조회",
            "Request fms action on specific storage": "특정 스토리지에 액션 요청",
            "Retrieve list of Searchable Buckets by admin": "검색 버킷 목록 조회",
            "Retrieve list of download jobs": "다운로드 작업 목록 조회",
            "Request download": "다운로드 요청",
            "Retrieve download job details": "다운로드 작업 상세 조회",
            "Retrieve list of download job tasks": "다운로드 작업 태스크 목록 조회",
            "Retrieve download job task details": "다운로드 작업 태스크 상세 조회",
            "Retrieve download link": "다운로드 링크 조회",
            "Retrieve list of Batch Jobs": "배치 작업 목록 조회",
            "Create Batch Job": "배치 작업 생성",
            "Retrieve Batch Job details": "배치 작업 상세 조회",
            "Retrieve list of Batch Job Tasks": "배치 작업 태스크 목록 조회",
            "Retrieve Batch Job Task details": "배치 작업 태스크 상세 조회",
            "Retrieve Presigned URL for S3 file": "S3 파일에 대한 Presigned URL 생성",
            "Initiate multipart upload session for S3 file": "S3 파일에 대한 멀티파트 업로드 세션 생성",
            "Complete multipart upload for S3 file": "S3 파일에 대한 멀티파트 업로드 완료",
            "Abort multipart upload for S3 file": "S3 파일에 대한 멀티파트 업로드 취소",
            "Retrieve Presigned URL for part upload in S3 file": "S3 파일의 파트 별 업로드 URL 생성",
            "Retrieve Presigned URL for upload in S3 file": "S3 파일의 업로드 URL 생성",
            "Retrieve integrated search list": "통합 검색 목록 조회",
            "Retrieve list of Resource Buckets assigned to me": "자신에게 할당된 리소스 버킷 목록 조회",
            "Retrieve Task details in asynchronous Job": "비동기 작업의 태스크 상세 조회",
            "Retrieve list of integrated search domains": "통합 검색 도메인 목록 조회",
            "Create integrated search domain": "통합 검색 도메인 생성",
            "Retrieve integrated search domain details": "통합 검색 도메인 상세 조회",
            "Delete integrated search domain": "통합 검색 도메인 삭제",
            "Retrieve list of shared links": "외부 공유 목록 조회",
            "Share link": "외부 공유",
            "Retrieve shared link details": "외부 공유 상세 조회",
            "Delete shared link": "외부 공유 삭제",
            "Retrieve list of AWS S3 buckets": "AWS S3 버킷 목록 조회",
            "Retrieve list of internal shares": "내부 공유 목록 조회",
            "Create internal share": "내부 공유",
            "Retrieve internal share details": "내부 공유 상세 조회",
            "Update internal share": "내부 공유 수정",
            "Update requester action in internal share": "내부 공유 요청자 액션 수정",
            "Update approver action in internal share": "내부 공유 수락자 액션 수정",
            "Retrieve list of approver candidates for internal share": "내부 공유 수락자 후보 목록 조회",
            "Retrieve list of shared resources": "공유된 리소스 목록 조회",
            "Share resource": "리소스 공유",
            "Retrieve shared resource details": "공유된 리소스 상세 조회",
            "Delete shared resource": "공유된 리소스 삭제",
            "Retrieve list of grantees for shared resource": "리소스 공유 대상 사용자 목록 조회",
            "Add grantee to shared resource": "리소스 공유 대상 사용자 추가",
            "Retrieve grantee details for shared resource": "리소스 공유 대상 사용자 상세 조회",
            "Update grantee for shared resource": "리소스 공유 대상 사용자 수정",
            "Remove grantee from shared resource": "리소스 공유 대상 사용자 삭제",
            "Check share permission": "공유 권한 체크",
            "Retrieve list of resources shared with me": "나에게 공유된 리소스 목록 조회",
            "Retrieve details of resource shared with me": "나에게 공유된 리소스 상세 조회",
            "Delete resource shared with me": "나에게 공유된 리소스 삭제",
            "Retrieve list of drives": "드라이브 목록 조회",
            "Retrieve drive details": "드라이브 상세 조회",
            "Update drive": "드라이브 수정",
            "Retrieve list of folders": "폴더 목록 조회",
            "Create folder": "폴더 생성",
            "Retrieve folder details": "폴더 상세 조회",
            "Update folder": "폴더 수정",
            "Delete folder": "폴더 삭제",
            "Move folder": "폴더 이동 요청",
            "Retrieve list of metadata templates": "메타데이터 템플릿 목록 조회",
            "Create metadata template": "메타데이터 템플릿 생성",
            "Retrieve metadata template details": "메타데이터 템플릿 상세 조회",
            "Update metadata template": "메타데이터 템플릿 수정",
            "Delete metadata template": "메타데이터 템플릿 삭제",
            "Register metadata template": "메타데이터 템플릿 등록",
            "Retrieve list of dashboard widgets": "대시보드 위젯 목록 조회",
            "Create dashboard widget": "대시보드 위젯 생성",
            "Retrieve dashboard widget details": "대시보드 위젯 상세 조회",
            "Update dashboard widget": "대시보드 위젯 수정",
            "Delete dashboard widget": "대시보드 위젯 삭제",
            "Retrieve list of dashboard widget data": "대시보드 위젯의 데이터 조회",
            "Retrieve list of storage folders": "저장소 폴더 목록 조회",
            "Retrieve list of storage files": "저장소 파일 목록 조회",
            "Move asset": "자산 폴더 이동 요청",
            "Request storage action": "스토리지 액션 요청",
            "Lock Searchable Bucket": "검색 버킷 잠금",
            "Unlock Searchable Bucket": "검색 버킷 잠금 해제",
            "Retrieve list of multipart upload jobs": "멀티파트 업로드 작업 목록 조회",
            "Retrieve list of parts in multipart upload job": "멀티파트 업로드 작업에 포함된 파트 목록 조회",
            "Retrieve list of collections": "컬렉션 목록 조회",
            "Create collection": "컬렉션 생성",
            "Retrieve collection details": "컬렉션 상세 조회",
            "Update collection": "컬렉션 수정",
            "Delete collection": "컬렉션 삭제",
            "Retrieve list of items in collection": "컬렉션에 포함된 자산 목록 조회",
            "Update collection tags": "컬렉션 태그 수정",
            "Retrieve list of linked collections": "컬렉션의 연결된 컬렉션 목록 조회",
            "Request collection action": "컬렉션 액션 요청",
            "Retrieve list of content field types": "콘텐츠 필드 타입 목록 조회",
            "Create content field type": "콘텐츠 필드 타입 생성",
            "Retrieve content field type details": "콘텐츠 필드 타입 상세 조회",
            "Update content field type": "콘텐츠 필드 타입 수정",
            "Delete content field type": "콘텐츠 필드 타입 삭제",
            "Create content schema": "콘텐츠 스키마 생성",
            "Request content schema field action": "콘텐츠 스키마 필드 액션 요청",
            "Retrieve content schema details": "콘텐츠 스키마 상세 조회",
            "Update content schema": "콘텐츠 스키마 수정",
            "Delete content schema": "콘텐츠 스키마 삭제",
            "Request content schema action": "콘텐츠 스키마 액션 요청",
            "Retrieve list of projects assigned to content schema": "콘텐츠 스키마가 할당된 프로젝트 목록 조회",
            "Retrieve list of custom contents": "커스텀 콘텐츠 목록 조회",
            "Create custom content": "커스텀 콘텐츠 생성",
            "Retrieve custom content details": "커스텀 콘텐츠 상세 조회",
            "Update custom content": "커스텀 콘텐츠 수정",
            "Delete custom content": "커스텀 콘텐츠 삭제",
            "Request custom content action": "커스텀 콘텐츠 액션 요청",
            "Retrieve custom content field details": "커스텀 콘텐츠 필드 상세 조회",
            "Request custom content action in bulk": "커스텀 콘텐츠 대량 액션 요청",
            "Retrieve list of AI caption jobs": "AI 자막 작업 목록 조회",
            "Create AI caption job": "AI 자막 작업 생성",
            "Retrieve AI caption job details": "AI 자막 작업 상세 조회",
            "Retrieve list of AI analysis jobs": "AI 분석 작업 목록 조회",
            "Create AI analysis job": "AI 분석 작업 생성",
            "Retrieve AI analysis job details": "AI 분석 작업 상세 조회",
            "Delete AI analysis job": "AI 분석 작업 삭제",
            "Retrieve list of AI analysis job summaries": "AI 분석 작업 요약 분석 결과 목록 조회",
            "Retrieve list of AI analysis job results": "AI 분석 작업 분석 결과 목록 조회",
            "Retrieve list of AI analysis job original results": "AI 분석 작업 원본 분석 결과 목록 조회",
            "Retrieve AI analysis job original result details": "AI 분석 작업 원본 분석 결과 상세 조회",
            "Callback for AI analysis job engine": "AI 분석 콜백 호출",
            "Retrieve list of dictation vocabularies": "단어장 목록 조회",
            "Create dictation vocabulary": "단어장 생성",
            "Retrieve dictation vocabulary details": "단어장 상세 조회",
            "Delete dictation vocabulary": "단어장 삭제",
            "Update dictation vocabulary": "단어장 수정",
            "Retrieve list of phrases in vocabulary": "단어장 단어 목록 조회",
            "Request vocabulary phrase action": "단어장 단어 액션 요청",
            "Retrieve list of notifications": "알림 목록 조회",
            "Create notification": "알림 생성",
            "Retrieve notification details": "알림 상세 조회",
            "Update notification": "알림 수정",
            "Delete notification": "알림 삭제",
            "Retrieve list of notification subscriptions": "알림 구독 목록 조회",
            "Subscribe to notification": "알림 구독",
            "Retrieve notification subscription details": "알림 구독 상세 조회",
            "Unsubscribe from notification": "알림 구독 해제",
            "Retrieve list of notification conditions": "알림 조건 목록 조회",
            "Update notification conditions": "알림 조건 수정",
            "Retrieve list of domain events": "도메인 이벤트 목록 조회",
            "Retrieve download links for AI analysis job": "AI 분석 작업 결과에 대한 다운로드 링크 조회",
            "Retrieve list of asset versions": "자산 버전 목록 조회",
            "Create asset version": "자산 버전 생성",
            "Retrieve asset version details": "자산 버전 상세 조회",
            "Delete asset version": "자산 버전 삭제",
            "Retrieve list of comment threads": "댓글 스레드 목록 조회",
            "Create comment thread": "댓글 스레드 생성",
            "Retrieve list of comments in thread": "댓글 스레드에 작성된 댓글 목록 조회",
            "Create comment": "댓글 생성",
            "Update comment": "댓글 수정",
            "Delete comment": "댓글 삭제",
            "Request comment action": "댓글 액션 요청",
            "Delete comment thread": "댓글 스레드 삭제",
            "Retrieve comment details": "댓글 상세 조회",
            "Update comment thread": "댓글 스레드 수정",
            "Retrieve list of comments": "댓글 목록 조회",
            "Retrieve list of Action Groups": "액션 그룹 목록 조회",
            "Retrieve Action Group details": "액션 그룹 상세 조회",
            "Retrieve list of my space permissions": "나의 스페이스 권한 목록 조회",
            "Retrieve list of my project permissions": "나의 프로젝트 권한 목록 조회",
            "Request role action": "역할 액션 요청",
            "Retrieve list of entities by role": "역할이 부여된 사용자 또는 그룹 목록 조회",
            "Assign role to entity": "사용자 또는 그룹에 역할 부여",
            "Remove role from entity": "사용자 또는 그룹에서 역할 제거",
            "Create user": "사용자 생성",
            "Create team": "그룹 생성",
            "Update team": "그룹 수정",
            "Delete team": "그룹 삭제",
            "Assign member to team": "그룹 멤버 할당",
            "Retrieve team member details": "그룹 멤버 상세 조회",
            "Remove member from team": "그룹 멤버 제거",
            "Assign project member": "프로젝트 멤버 할당",
            "Retrieve project member details": "프로젝트 멤버 상세 조회",
            "Remove project member": "프로젝트 멤버 제거",
            "Assign project team": "프로젝트 그룹 할당",
            "Retrieve project team details": "프로젝트 그룹 상세 조회",
            "Remove project team": "프로젝트 그룹 제거",
            "Retrieve list of project team members": "프로젝트 그룹 멤버 목록 조회",
            "Retrieve project team member details": "프로젝트 그룹 멤버 상세 조회",
            "Retrieve list of Resource Types": "리소스 유형 목록 조회",
            "Copy asset": "자산 복제",
            "Retrieve list of collections by asset": "자산의 컬렉션 목록 조회",
            "Delete users in bulk": "사용자 삭제",
            "Request team action": "그룹 액션 요청",
            "Delete teams in bulk": "그룹 삭제",
            "Remove project members in bulk": "프로젝트 멤버 제거",
            "Remove project teams in bulk": "프로젝트 그룹 제거",
            "Retrieve list of linked assets": "연결된 에셋 목록 조회",
            "Add linked asset": "연결된 에셋 추가",
            "Remove linked asset": "연결된 에셋 제거",
            "Create comment attachment": "댓글 첨부 파일 생성",
            "Delete comment attachment": "댓글 첨부 파일 삭제",
            "Request user action": "사용자 액션 요청",
            "Retrieve list of project admins": "프로젝트 관리자 목록 조회",
            "Request project action": "프로젝트 액션 요청",
            "Retrieve list of project member's teams": "프로젝트 그룹 목록 조회",
            "Retrieve list of project member's roles": "프로젝트 멤버 역할 목록 조회",
            "Retrieve list of project team's roles": "프로젝트 그룹 역할 목록 조회",
            "Retrieve comment thread details": "댓글 스레드 상세 조회",
            "Retrieve list of thread entities": "댓글 스레드 참여자 목록 조회",
            "Create thread entity": "댓글 스레드 참여자 생성",
            "Retrieve list of pending users for space invitation": "스페이스 초대를 기다리는 사용자 목록 조회",
            "Request space user invitation": "스페이스 사용자 초대 요청",
            "Retrieve list of pending users for project invitation": "프로젝트 초대를 기다리는 사용자 목록 조회",
            "Request project user invitation": "프로젝트 사용자 초대 요청",
            "Retrieve list of assignable members to team": "그룹에 할당 가능한 멤버 목록 조회",
            "Create exported metadata job": "메타데이터 내보내기 작업 생성",
            "Retrieve list of exported metadata jobs": "메타데이터 내보내기 작업 목록 조회",
            "Retrieve exported metadata job details": "메타데이터 내보내기 작업 상세 조회",
            "Update exported metadata job": "메타데이터 내보내기 작업 수정",
            "Delete exported metadata job": "메타데이터 내보내기 작업 삭제",
            "Retrieve upload Presigned URL for preview resource": "미리보기 업로드 URL 생성",
            "Request preview resource action": "미리보기 변경",
            "Retrieve list of audit log search keys": "관리 감사 로그 검색 조건 목록 조회",
            "Retrieve embed URL for posting": "포스팅 임베드 URL 생성",
            "Request role management action": "역할 관리 액션 요청",
            "Retrieve list of report settings": "리포트 설정 목록 조회",
            "Retrieve report setting details": "리포트 설정 상세 조회",
            "Update report setting": "리포트 설정 수정",
            "Retrieve list of reports": "리포트 목록 조회",
            "Retrieve report details": "리포트 상세 조회",
            "Retrieve list of report subscribers": "리포트 수신 대상자 목록 조회",
            "Capture asset frame": "자산 프레임 캡쳐",
            "Retrieve list of links": "링크 목록 조회",
            "Create link": "링크 생성",
            "Update link": "링크 수정",
            "Delete link": "링크 삭제",
            "Create drive": "드라이브 생성",
            "Delete drive": "드라이브 삭제",
            "Validate share grantee": "공유 대상 사용자 검증",
            "Apply asset owner lock": "자산 소유자 잠금 설정",
            "Release asset owner lock": "자산 소유자 잠금 해제",
            "Create video clip from asset": "자산 비디오 클립 생성",
            "Retrieve list of favorite resources": "자산 즐겨찾기 목록 조회",
            "Create favorite resource": "자산 즐겨찾기 생성",
            "Delete favorite resource": "자산 즐겨찾기 삭제",
            "Retrieve list of custom menu sets": "사용자 정의 메뉴 세트 목록 조회",
            "Create custom menu set": "사용자 정의 메뉴 세트 생성",
            "Retrieve custom menu set details": "사용자 정의 메뉴 세트 상세 조회",
            "Update custom menu set": "사용자 정의 메뉴 세트 수정",
            "Delete custom menu set": "사용자 정의 메뉴 세트 삭제",
            "Request custom menu set action": "사용자 정의 메뉴 세트 액션",
            "Retrieve list of custom menus": "사용자 정의 메뉴 목록 조회",
            "Create custom menu": "사용자 정의 메뉴 생성",
            "Retrieve custom menu details": "사용자 정의 메뉴 상세 조회",
            "Update custom menu": "사용자 정의 메뉴 수정",
            "Delete custom menu": "사용자 정의 메뉴 삭제",
            "Retrieve list of asset histories": "자산 활동 내역 목록 조회",
            "Retrieve asset history details": "자산 활동 내역 상세 조회",
            "Retrieve integrated search detailed list": "통합 검색 상세 목록 조회",
            "Retrieve list of my requests": "나의 리퀘스트 목록 조회",
            "Retrieve my request details": "나의 리퀘스트 상세 조회",
            "Update my request": "나의 리퀘스트 수정",
            "Delete my request": "나의 리퀘스트 삭제",
            "Create request": "리퀘스트 생성",
            "Retrieve list of requests": "리퀘스트 목록 조회",
            "Retrieve request details": "리퀘스트 상세 조회",
            "Update request": "리퀘스트 수정",
            "Delete request": "리퀘스트 삭제",
            "Update request status": "리퀘스트 상태 변경",
            "Create attachment in my request": "나의 리퀘스트에 첨부 파일 생성",
            "Delete attachment from my request": "나의 리퀘스트 첨부 파일 삭제",
            "Create attachment in request": "리퀘스트에 첨부 파일 생성",
            "Delete attachment from request": "리퀘스트 첨부 파일 삭제",
            "Retrieve list of request categories": "리퀘스트 카테고리 목록 조회",
            "Retrieve list of assets shared with me": "나에게 공유된 에셋 목록 조회",
            "Share asset": "에셋 공유",
            "Retrieve list of shared assets": "에셋 공유 목록 조회",
            "Unshare asset": "에셋 공유 해제",
            "Assign request assignee": "리퀘스트 담당자 할당",
            "Retrieve custom metadata details of asset": "자산 커스텀 메타데이터 상세 조회",
            "Retrieve list of projects for asset shared with me": "나에게 공유된 에셋 프로젝트 목록 조회",
            "Retrieve list of user agreements": "이용 약관 목록 조회",
            "Retrieve user agreement details": "이용 약관 상세 조회",
            "Update user agreement consent": "이용 약관 동의 여부 변경",
            "Create favorite resources in bulk": "자산 즐겨찾기 대량 생성",
            "Delete favorite resources in bulk": "자산 즐겨찾기 대량 삭제",
            "Retrieve list of supported regions by provider": "지원되는 리젼 목록 조회",
            "Update asset share": "에셋 공유 수정",
            "Retrieve list of assets I shared": "내가 공유한 에셋 목록 조회",
            "Retrieve list of projects for asset shared by me": "내가 공유한 에셋 프로젝트 목록 조회",
            "Retrieve list of asset owners": "에셋 소유자 목록 조회",
            "Retrieve list of usage metric tenants": "사용량 메트릭 테넌트 목록 조회",
            "Retrieve list of usage metrics": "사용량 메트릭 목록 조회",
            "Retrieve list of usage metric data": "사용량 메트릭 데이터 목록 조회",
            "Retrieve assignable storages": "할당 가능한 스토리지 조회",
            "Retrieve assigned storages": "할당된 스토리지 조회",
            "Manage project storages": "프로젝트 스토리지 관리",
            "Update owners of assets in bulk": "자산의 소유자 대량 변경",
            "Callback for Gen AI service": "Gen AI 서비스 콜백",
            "Create AI job in request": "요청에서 AI 작업 생성",
            "AI Source Synchronization": "AI 소스 동기화",
            "Delete Gen AI Source": "AI 소스 삭제",
            "Create prompt preset": "프롬프트 프리셋 생성",
            "Update prompt preset": "프롬프트 프리셋 수정",
            "Delete prompt preset": "프롬프트 프리셋 삭제",
            "Update prompt preset status": "프롬프트 프리셋 상태 수정"
        }
    }
}
